import React__default, { useMemo, useState, useRef, useEffect, useCallback, createElement, Fragment as Fragment$1, createRef, Component } from 'react';
import purify from 'dompurify';
import require$$0 from 'util';
import react_dom_1 from 'react-dom';

var QuestionCodeEnum;
(function (QuestionCodeEnum) {
    QuestionCodeEnum["DEACTIVATED"] = "DEACTIVATED";
    QuestionCodeEnum["GENERIC"] = "ATT_GENERIC";
    QuestionCodeEnum["POWER_ON"] = "POWER_ON";
    QuestionCodeEnum["LCD_FUNCTIONALITY"] = "LCD_FUNCTIONALITY";
    QuestionCodeEnum["NO_DAMAGE"] = "NO_DAMAGE";
})(QuestionCodeEnum || (QuestionCodeEnum = {}));
var GenericQuestionAnswerTextEnum;
(function (GenericQuestionAnswerTextEnum) {
    GenericQuestionAnswerTextEnum["YES"] = "Yes";
    GenericQuestionAnswerTextEnum["NO"] = "No";
})(GenericQuestionAnswerTextEnum || (GenericQuestionAnswerTextEnum = {}));
var AnalyticsEventType;
(function (AnalyticsEventType) {
    AnalyticsEventType["PAGE_LOAD_SELECT_DEVICE"] = "PAGE_LOAD_SELECT_DEVICE";
    AnalyticsEventType["PAGE_LOAD_ANSWER_QUESTIONS"] = "PAGE_LOAD_ANSWER_QUESTIONS";
    AnalyticsEventType["CONTINUE_CTA_PRESSED"] = "CONTINUE_CTA_PRESSED";
    AnalyticsEventType["CONTINUE_IMEI_CTA_PRESSED"] = "CONTINUE_IMEI_CTA_PRESSED";
    AnalyticsEventType["SKIP_IMEI_CTA_PRESSED"] = "SKIP_IMEI_CTA_PRESSED";
    AnalyticsEventType["IMEI_VALIDATION"] = "IMEI_VALIDATION";
})(AnalyticsEventType || (AnalyticsEventType = {}));
var ErrorTypeEnum;
(function (ErrorTypeEnum) {
    ErrorTypeEnum["CONFIG_FILE_ERROR"] = "CONFIG_FILE_ERROR";
    ErrorTypeEnum["API_ERROR"] = "API_ERROR";
})(ErrorTypeEnum || (ErrorTypeEnum = {}));
var ReportingDeviceCondition;
(function (ReportingDeviceCondition) {
    ReportingDeviceCondition["GOOD"] = "Good Condition";
    ReportingDeviceCondition["BAD"] = "Bad Condition";
})(ReportingDeviceCondition || (ReportingDeviceCondition = {}));
var SharedOfferModalStatus;
(function (SharedOfferModalStatus) {
    SharedOfferModalStatus["ACCEPT"] = "USER_ACCEPTED";
    SharedOfferModalStatus["DECLINE"] = "USER_DECLINED";
    SharedOfferModalStatus["NOOFFER"] = "NO_OFFER_FOUND";
    SharedOfferModalStatus["DATAFAILED"] = "DATA_RETRIEVE_FAILED";
})(SharedOfferModalStatus || (SharedOfferModalStatus = {}));
var DeactivatedQuestionDescriptionMakes;
(function (DeactivatedQuestionDescriptionMakes) {
    DeactivatedQuestionDescriptionMakes["APPLE"] = "Apple";
    DeactivatedQuestionDescriptionMakes["SAMSUNG"] = "Samsung";
    DeactivatedQuestionDescriptionMakes[DeactivatedQuestionDescriptionMakes["APPLE_INDEX"] = 0] = "APPLE_INDEX";
    DeactivatedQuestionDescriptionMakes[DeactivatedQuestionDescriptionMakes["SAMSUNG_INDEX"] = 1] = "SAMSUNG_INDEX";
    DeactivatedQuestionDescriptionMakes[DeactivatedQuestionDescriptionMakes["OTHER_INDEX"] = 2] = "OTHER_INDEX";
})(DeactivatedQuestionDescriptionMakes || (DeactivatedQuestionDescriptionMakes = {}));
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["SUCCESS_ADMIT"] = "Success_Admit";
    ErrorTypes["FAILURE_DATA"] = "Failure_Data";
})(ErrorTypes || (ErrorTypes = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var allContent = "SharedOffer-module_all-content__CQOXH";
var boxContainer = "SharedOffer-module_box-container__kSjIC";
var buttonAccept = "SharedOffer-module_button-accept__etiSa";
var buttonDecline = "SharedOffer-module_button-decline__cxAwE";
var spinnerContainer = "SharedOffer-module_spinner-container__VaPOr";
var spinnerLoadingText = "SharedOffer-module_spinner-loading-text__ZzhmU";
var css_248z = ".SharedOffer-module_all-content__CQOXH {\n  background-color: #FFFFFF;\n  width: 100%; }\n\n.SharedOffer-module_separator__gcO0U {\n  width: 100%;\n  height: 1px;\n  background-color: #dcdfe3;\n  display: block;\n  margin-bottom: 18px;\n  margin-top: 18px; }\n\n.SharedOffer-module_box-container__kSjIC {\n  border-radius: 3px; }\n  @media (max-width: 425px) {\n    .SharedOffer-module_box-container__kSjIC {\n      padding: 0px 16px 16px 16px; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .SharedOffer-module_box-container__kSjIC {\n      padding: 0px 8px 8px 8px; } }\n  @media (min-width: 1025px) {\n    .SharedOffer-module_box-container__kSjIC {\n      padding: 0px 8px 0px 8px; } }\n\n.SharedOffer-module_instructions__eKweE {\n  font-family: font-regular, sans-serif;\n  font-size: 14px;\n  margin-top: 20px; }\n\n.SharedOffer-module_results-container__0QhjC > ul {\n  list-style-type: disc; }\n\n.SharedOffer-module_results-container__0QhjC > ul > li {\n  margin-top: 8px; }\n\n.SharedOffer-module_button-accept__etiSa {\n  width: 100%;\n  margin-top: 32px; }\n\n.SharedOffer-module_button-decline__cxAwE {\n  width: 100%;\n  margin-top: 16px; }\n\n.SharedOffer-module_optional-contextual-container__g0ITz {\n  display: flex;\n  font-family: font-medium, sans-serif;\n  margin-top: 16px;\n  font-size: 16px; }\n\n.SharedOffer-module_optional-contextual-image__wjyIP path {\n  fill: #0057b8; }\n\n.SharedOffer-module_optional-contextual-image__wjyIP svg {\n  height: 24px;\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px; }\n\n.SharedOffer-module_error-image__tIjpU path {\n  fill: #c70032; }\n\n.SharedOffer-module_error-image__tIjpU svg {\n  height: 24px;\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px; }\n\n.SharedOffer-module_spinner-container__VaPOr {\n  display: flex;\n  font-family: font-medium, sans-serif;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 24px; }\n  .SharedOffer-module_spinner-container__VaPOr .SharedOffer-module_spinner-loading-text__ZzhmU {\n    margin-top: 16px; }\n";
styleInject(css_248z);

var radioButtonGroup = "DeviceTypeSelection-module_radio-button-group__lolXw";
var header = "DeviceTypeSelection-module_header__4-JMb";
var buttonGroup = "DeviceTypeSelection-module_button-group__MrhIM";
var css_248z$1 = ".DeviceTypeSelection-module_radio-button-group__lolXw {\n  margin-bottom: 24px; }\n  .DeviceTypeSelection-module_radio-button-group__lolXw ul {\n    list-style-type: disc; }\n  .DeviceTypeSelection-module_radio-button-group__lolXw input[type=\"radio\"] {\n    opacity: 0;\n    position: absolute; }\n    .DeviceTypeSelection-module_radio-button-group__lolXw input[type=\"radio\"]:checked + label {\n      border: 2px solid #0057B8; }\n    .DeviceTypeSelection-module_radio-button-group__lolXw input[type=\"radio\"]:focus-visible + label {\n      outline: 1px dotted #0057B8;\n      outline-offset: 5px; }\n  .DeviceTypeSelection-module_radio-button-group__lolXw img {\n    height: 24px; }\n\n.DeviceTypeSelection-module_header__4-JMb b, .DeviceTypeSelection-module_header__4-JMb strong {\n  font-weight: bold; }\n\n.DeviceTypeSelection-module_button-group__MrhIM {\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: row;\n  margin-right: -16px; }\n";
styleInject(css_248z$1);

var buttonContainer = "RadioButton-module_button-container__5Vaet";
var radioSelectButton = "RadioButton-module_radio-select-button__ZaK2Y";
var imageLabelContainer = "RadioButton-module_image-label-container__P2hz9";
var css_248z$2 = ".RadioButton-module_button-container__5Vaet {\n  position: relative;\n  width: 100%; }\n\n.RadioButton-module_radio-select-button__ZaK2Y {\n  padding: 10px 10px;\n  border: 1px solid #DCDFE3;\n  background-color: #ffffff;\n  border-radius: 3px;\n  box-sizing: border-box;\n  display: block;\n  margin-right: 16px; }\n\n.RadioButton-module_image-label-container__P2hz9 {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n";
styleInject(css_248z$2);

var RadioButton = function (_a) {
    var label = _a.label, checked = _a.checked, index = _a.index, img = _a.img, name = _a.name, onChange = _a.onChange;
    return (React__default.createElement(React__default.Fragment, { key: index },
        React__default.createElement("div", { className: "" + buttonContainer },
            React__default.createElement("input", { id: "sharedoffer-radio-button-" + name + "-" + index, name: name, type: "radio", value: label, key: index, checked: checked, onChange: onChange }),
            React__default.createElement("label", { htmlFor: "sharedoffer-radio-button-" + name + "-" + index, className: "type-base " + radioSelectButton },
                React__default.createElement("div", { className: imageLabelContainer },
                    img && React__default.createElement("img", { src: img, alt: label }),
                    label)))));
};

var DeviceTypeEnum;
(function (DeviceTypeEnum) {
    DeviceTypeEnum["PHONE"] = "phone";
    DeviceTypeEnum["TABLET"] = "tablet";
    DeviceTypeEnum["WEARABLE"] = "wearable";
})(DeviceTypeEnum || (DeviceTypeEnum = {}));
var CurrentStageEnum;
(function (CurrentStageEnum) {
    CurrentStageEnum[CurrentStageEnum["SELECT_DEVICE_TYPE"] = 0] = "SELECT_DEVICE_TYPE";
    CurrentStageEnum[CurrentStageEnum["SELECT_MAKE"] = 1] = "SELECT_MAKE";
    CurrentStageEnum[CurrentStageEnum["SELECT_MODEL"] = 2] = "SELECT_MODEL";
    CurrentStageEnum[CurrentStageEnum["SELECT_CAPACITY"] = 3] = "SELECT_CAPACITY";
    CurrentStageEnum[CurrentStageEnum["SELECT_QUESTION_ANSWERS"] = 4] = "SELECT_QUESTION_ANSWERS";
    CurrentStageEnum[CurrentStageEnum["HYLA_CALL"] = 5] = "HYLA_CALL";
})(CurrentStageEnum || (CurrentStageEnum = {}));
var OfferType;
(function (OfferType) {
    OfferType["NORMAL"] = "tradein";
    OfferType["GENERIC"] = "generictradein";
})(OfferType || (OfferType = {}));

var DeviceTypeSelectionGroup = function (_a) {
    var optionsFromCMS = _a.optionsFromCMS, name = _a.name, heading = _a.heading, selectedDeviceType = _a.selectedDeviceType, setCurrentStage = _a.setCurrentStage, setSelectedDeviceType = _a.setSelectedDeviceType, children = _a.children;
    var options = useMemo(function () {
        var updatedOptions = optionsFromCMS.map(function (i) {
            return __assign(__assign({}, i), { checked: selectedDeviceType === i.master.type });
        });
        return updatedOptions;
    }, [selectedDeviceType, optionsFromCMS]);
    var onDeviceTypeChange = function (e) {
        var deviceTypeName = e.target.value;
        var deviceTypeCMSObj = options.find(function (i) { return i.master.text === deviceTypeName; });
        var deviceType = deviceTypeCMSObj.master.type;
        setSelectedDeviceType(deviceType);
        setCurrentStage(CurrentStageEnum.SELECT_MAKE);
    };
    return (React__default.createElement("div", { className: "" + radioButtonGroup },
        React__default.createElement("fieldset", { id: "sharedoffer-radio-group-" + name, "aria-label": heading },
            React__default.createElement("legend", null,
                React__default.createElement("label", { className: header + " formfield-label" },
                    React__default.createElement("span", { dangerouslySetInnerHTML: {
                            __html: purify.sanitize(heading),
                        } }))),
            children,
            React__default.createElement("div", { className: buttonGroup }, options.map(function (option, index) {
                var _a;
                return (React__default.createElement(RadioButton, { label: option.master.text, checked: (_a = option) === null || _a === void 0 ? void 0 : _a.checked, index: index, img: option.master.imagePath, name: name, key: index, onChange: onDeviceTypeChange }));
            })))));
};

var getHylaOfferFromAPI = function (formData, campaignIdHeader, callHylaTradeinMuleApi) { return __awaiter(void 0, void 0, void 0, function () {
    var apiURL;
    return __generator(this, function (_a) {
        if (callHylaTradeinMuleApi) {
            apiURL = '/msapi/onlinesalesorchestration/products-papi/v1/hylaOfferDetails';
        }
        else {
            if (window.location.hostname.indexOf('localhost') > -1) {
                apiURL = 'https://e-tst3.stage.att.com/msapi/onlinesalesorch/v1/hylaOfferDetails';
            }
            else {
                apiURL = '/msapi/onlinesalesorch/v1/hylaOfferDetails';
            }
        }
        return [2 /*return*/, fetch(apiURL, {
                body: JSON.stringify(formData),
                headers: __assign({ Accept: 'application/json', 'Cache-Control': 'no-cache=set-cookie', 'Content-Type': 'application/json' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader }),
                method: 'POST',
            }).then(function (res) {
                return res
                    .json()
                    .then(function (response) {
                    var _a, _b;
                    var offers = (_b = (_a = response) === null || _a === void 0 ? void 0 : _a.wireless) === null || _b === void 0 ? void 0 : _b.promotions;
                    if (Array.isArray(offers) && offers.length > 0) {
                        return { success: true, offer: offers[0] };
                    }
                    throw Error('Incrorrect response format');
                })
                    .catch(function (err) {
                    console.error("Shared Offer Service: fetch error: " + err);
                    return { success: false, offer: undefined, err: err };
                });
            })];
    });
}); };
var parseValue = function (value) {
    var parsedValue = parseFloat(value);
    if (value === '-Infinity') {
        parsedValue = Number.NEGATIVE_INFINITY;
    }
    else if (value === 'Infinity') {
        parsedValue = Number.POSITIVE_INFINITY;
    }
    return parsedValue;
};
var selectPromotion = function (formData, promotions) {
    var promotionsWithQualifyingSKU = promotions.filter(function (promo) {
        return promo.qualifierSkus.includes(formData.skuId);
    });
    var promotionsWithCorrectMinAndMax = promotionsWithQualifyingSKU.filter(function (promo) {
        var parsedMin = parseValue(promo.minValue);
        var parsedMax = parseValue(promo.maxValue);
        return formData.tradeInValue >= parsedMin && formData.tradeInValue <= parsedMax;
    });
    var promotionsWithLosgType = promotionsWithCorrectMinAndMax.filter(function (promo) {
        return promo.losgTypes.includes(formData.losgTypes);
    });
    var promotionWithPopulatedTradeInModelArray;
    var finalPromotions = promotionsWithLosgType.filter(function (promo) {
        var _a;
        if (!((_a = promo) === null || _a === void 0 ? void 0 : _a.tradeInModels) || promo.tradeInModels.length === 0) {
            // if tradeInModel array does not exist we keep the promotion as valid
            return true;
        }
        if (promo.tradeInModels.includes(formData.tradeInModel)) {
            // if we have only one valid promotion with populated tradeInModel array we select this one
            // if there is more than one we cannot determine the correct promotion and we call the api
            if (promotionWithPopulatedTradeInModelArray) {
                throw new Error('Cannot determine promotion');
            }
            promotionWithPopulatedTradeInModelArray = promo;
            return true;
        }
        else {
            return false;
        }
    });
    var selectedPromotion;
    // if this promotion exists, return as valid promotion
    // else proceed and return others
    if (promotionWithPopulatedTradeInModelArray) {
        selectedPromotion = promotionWithPopulatedTradeInModelArray;
    }
    else {
        if (finalPromotions.length !== 1)
            throw new Error('Incrorrect promotions length');
        selectedPromotion = finalPromotions[0];
    }
    // check if discount value is less than trade in value
    if (selectedPromotion.discount < selectedPromotion.tradeInValue)
        throw new Error('discount cannot be less than tradeInValue');
    return selectedPromotion;
};
var getHylaOfferFromConfigFile = function (formData, promotions) {
    try {
        var selectedPromotion = selectPromotion(formData, promotions);
        var result = {
            discount: selectedPromotion.discount,
            hylaOfferCode: selectedPromotion.hylaOfferCode,
            id: selectedPromotion.id,
            promoType: selectedPromotion.promoType,
        };
        if (selectedPromotion.promoType === OfferType.NORMAL) {
            result.hylaMarketValue = selectedPromotion.tradeInValue;
        }
        return result;
    }
    catch (_a) {
        return null;
    }
};
var getHylaOffer = function (_a) {
    var formData = _a.formData, isGoodCondition = _a.isGoodCondition, promotions = _a.promotions, campaignIdHeader = _a.campaignIdHeader, callHylaTradeinMuleApi = _a.callHylaTradeinMuleApi;
    return __awaiter(void 0, void 0, void 0, function () {
        var offer, result;
        return __generator(this, function (_b) {
            if (isGoodCondition && promotions) {
                offer = getHylaOfferFromConfigFile(formData, promotions);
                if (offer) {
                    result = {
                        offer: offer,
                        success: true,
                    };
                    return [2 /*return*/, result];
                }
            }
            return [2 /*return*/, getHylaOfferFromAPI(formData, campaignIdHeader, callHylaTradeinMuleApi)];
        });
    });
};

var content = {
    heading: 'Estimate your trade-in value',
    headingPhone: 'Estimate your phone’s trade-in value',
    headingDeviceCondition: 'Tell us about the condition of your device',
    subHeading: '<p> We’ll use your device info to estimate its trade-in offer value.</p><p>Don’t see your device listed? That means it isn’t available for this offer.</p>',
    subHeadingPhone: '<p>We’ll use your phone’s info to estimate its trade-in offer value.</p><p>Don’t see your phone listed? That means it isn’t available for this offer.</p>',
    manufacturerLabel: 'Brand',
    modelLabel: 'Model',
    capacityLabel: 'Capacity',
    backButtonContent: 'Trade in a different device',
    backButtonContentError: 'Back to device type',
    genericTradeInMessage: 'Your device isn’t eligible for this offer, but you can still get its estimated trade-in value as an AT&T promotional card. Use it to purchase products and services or pay your bill at AT&T-owned stores or att.com.',
    tradeInMessageSVGAltText: 'Trade in Icon',
    errorMessage: '<p>We\'re unable to complete this task right now. After you place your order, go to <a href="https://tradein.att.com" target="_blank">tradein.att.com</a> or visit an AT&T store to complete your trade-in.</p>',
    errorHeading: "We're having some trouble",
    errorMessageSVGAltText: 'Error icon',
    tradeInMessageSVG: '/idpassets/global/icons/svg/communication-alerts/functional-icon_exclamation-circle-filled_32.svg',
    errorMessageSVG: '/idpassets/global/icons/svg/communication-alerts/functional-icon_exclamation-circle-filled_32.svg',
    yourDeviceLabel: 'You’re trading in your',
    spinnerLoadingMessage: 'Checking trade-in value ...',
    buttonAccept: 'Trade in this device',
    buttonDecline: 'No, thanks',
    buttonError: 'Continue',
    buttonContinue: 'Continue',
    deviceSelectionHeading: 'Device type',
    tooltipSvg: '/idpassets/global/icons/svg/communication-alerts/functional-icon_question-circle-filled_64.svg',
    tooltipContent: '<div>iOS: Settings > General > About</div><p/><div>Android: Settings > Device Maintenance</div>',
    otherMakeText: 'Other',
    otherMakeSelectorPlaceholder: 'Select model',
    promotionDisplayHeader: 'Estimated trade-in value',
    promotionCardDisplayHeader: 'Estimated promotional value',
    promotionDisplayMarketValueLabel: 'Market value:',
    promotionDisplayDisclaimer: '<div>Requires eligible unlimited plan (speed restrictions apply) and trade-in. Other terms apply. <a href="https://tradein.att.com/offer-details" target="_blank" rel="noopener noreferrer">See offer details</a></div>',
    promotionCardDisplayDisclaimer: 'Highest value available based on device brand, model, and condition. See <a href="https://tradein.att.com" target="_blank" rel="noopener noreferrer">tradein.att.com</a> for details.',
    promotionDisplayOptionFreeDevice: 'Trade in and get a FREE new device',
    promotionDisplayOptionNoPercentage: 'Trade in and save',
    promotionDisplayOptionSavingsPercentage: 'Save [[savings percentage]]% on your new device',
    promotionOfferMsg: 'Reminder: Make sure you have an eligible unlimited plan to get this offer.',
    modelSelectorPlaceholder: 'Select model',
    deviceSelectionOptions: [
        {
            master: {
                text: 'Phone',
                imagePath: '/idpassets/global/icons/svg/devices/functional-icon_smartphone_32.svg',
                type: 'phone',
            },
        },
        {
            master: {
                text: 'Tablet',
                imagePath: '/idpassets/global/icons/svg/devices/functional-icon_tablet_32.svg',
                type: 'tablet',
            },
        },
        {
            master: {
                text: 'Smartwatch',
                imagePath: '/idpassets/global/icons/svg/devices/functional-icon_smartwatch_32.svg',
                type: 'wearable',
            },
        },
    ],
    questions: [
        {
            master: {
                questionCode: QuestionCodeEnum.GENERIC,
                questionLabel: '<div>Is your device in good condition?</div><div>Select <b>Yes</b> if the following are true:</div>',
                questionDescription: [
                    'It turns on and off, and functions normally',
                    'The buttons and cameras work',
                    "It's free of dents and scratches",
                    "The touchscreen and back glass aren't damaged",
                ],
            },
        },
        {
            master: {
                questionCode: QuestionCodeEnum.POWER_ON,
                questionLabel: 'Does the device power on and off?',
                questionDescription: [
                    'Turn the device all the way off and back on again.',
                    'Make sure the device stays on.',
                ],
            },
        },
        {
            master: {
                questionCode: QuestionCodeEnum.LCD_FUNCTIONALITY,
                questionLabel: 'Is the screen functioning correctly and intact, free of any chips, bruised or dead pixels, and burn-in?',
                questionDescription: [
                    'The screen should work properly, display all information clearly, and not contain any dead spots or bruising.',
                    'If the screen has any cracks, chips, lack of function, dead spots, or bruising, please answer <b>No</b>.',
                ],
            },
        },
        {
            master: {
                questionCode: QuestionCodeEnum.NO_DAMAGE,
                questionLabel: 'Is the device otherwise free of breaks or cracks in the housing, keypad, hinge, or battery door?',
                questionDescription: [
                    'It should have no cracks around the hinges, battery cover, charging port, or other ports.',
                    'All buttons, including any keypad, volume, or camera buttons, should work correctly',
                    'The battery door must be with the device, if applicable',
                ],
            },
        },
        {
            master: {
                questionCode: QuestionCodeEnum.DEACTIVATED,
                questionLabel: 'Is the activation lock (for example, Find my iPhone or Reactivation Lock) turned off?',
                questionDescription: [
                    'Apple devices: To turn off the activation lock in iOS 14 and later, go to <b>Settings</b> and select <b>your name</b> to view your Apple ID settings. Then select <b>Find My</b>, select <b>Find my iPhone</b>, and toggle the <b>Find my iPhone</b> switch to <b>Off</b>.',
                    'Samsung devices: To turn off the activation lock, go to <b>Settings</b> and select <b>Personal</b>. Then select <b>Lock screen and security</b>, select <b>Find my mobile</b>, and toggle the <b>Reactivation lock</b> switch to <b>Off</b>.',
                ],
            },
        },
    ],
    mustSwitchPriceOptionMessage: 'Choosing to trade in will switch you to an installment plan.',
};

var loadCMSContent = function (setContent) {
    var src = '/msapi/idp-content-orchestration/v1/idpcms/sales/sharedoffercontent2';
    if (window.location.hostname.indexOf('localhost') > -1) {
        src =
            'https://e-tst3.stage.att.com/msapi/idp-content-orchestration/v1/idpcms/sales/sharedoffercontent2';
    }
    fetch(src)
        .then(function (res) { return res.json(); })
        .then(function (data) {
        setContent(data['idp-cms-feed'].sharedoffercontent2.contentFragments.modalContent.master);
    })
        .catch(function () {
        // Fallback CMS feed
        setContent(content);
    });
};

// check data correctness now so unexpected errors don't appear while the component is being used
var dataIsCorrect = function (devices) {
    if (!devices)
        return false;
    if (!Array.isArray(devices))
        return false;
    var _loop_1 = function (deviceType) {
        var device = devices.find(function (i) { return i.category === DeviceTypeEnum[deviceType]; });
        if (!device)
            return { value: false };
        if (!device.questions)
            return { value: false };
        var question = device.questions[0];
        if (!question || !question.questionCode || !question.sortOrder || !question.validAnswers)
            return { value: false };
        var answer = question.validAnswers[0];
        if (!answer || !answer.answerText || !answer.skuCode || !answer.questionCode)
            return { value: false };
        if (!device.makes)
            return { value: false };
        var make = device.makes[0];
        if (!make || !make.name || !make.models)
            return { value: false };
        var model = make.models[0];
        if (!model || !model.name || !model.productFamily)
            return { value: false };
        var product = model.productFamily[0];
        if (!product ||
            !product.name ||
            !product.image ||
            !product.modelCode ||
            !product.modelPrice ||
            !product.capacity ||
            !product.capacity)
            return { value: false };
    };
    // check we have all the devices and for each one check that at least the first object in each array is correct
    // we dont want to check every single option because that would take too long
    for (var deviceType in DeviceTypeEnum) {
        var state_1 = _loop_1(deviceType);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return true;
};
var loadDataConfig = function (setDevices, sendError, setShowError) {
    var src = '';
    if (window.location.hostname.indexOf('localhost') > -1) {
        src = 'http://localhost:6060/config.json';
    }
    else if (window.location.hostname.indexOf('dev') > -1) {
        src = '/sharedoffer/dev/sharedoffermodal/config.json';
    }
    else if (window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf('e-tst') > -1 ||
        window.location.hostname.indexOf('stage') > -1) {
        src = '/sharedoffer/virtual/sharedoffermodal/config.json';
    }
    else {
        src = '/sharedoffer/prod/sharedoffermodal/config.json';
    }
    fetch(src)
        .then(function (res) { return res.json(); })
        .then(function (data) {
        var _a;
        if (!dataIsCorrect((_a = data) === null || _a === void 0 ? void 0 : _a.devices)) {
            throw new Error('Invald Config File');
        }
        setDevices(data.devices);
    })
        .catch(function () {
        setShowError(true);
        sendError(ErrorTypeEnum.CONFIG_FILE_ERROR);
    });
};

var subHeader = "Header-module_sub-header__5CtU4";
var backButton = "Header-module_back-button__p0eqp";
var topBar = "Header-module_top-bar__pr-IK";
var css_248z$3 = ".Header-module_sub-header__5CtU4 {\n  font-family: font-regular, sans-serif;\n  font-size: 14px;\n  margin-bottom: 24px;\n  margin-top: 12px; }\n\n.Header-module_back-button__p0eqp::after {\n  transform: rotate(180deg);\n  margin: 0 16px 0 0; }\n\n.Header-module_back-button__p0eqp {\n  flex-direction: row-reverse;\n  text-transform: none; }\n\n.Header-module_top-bar__pr-IK {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px; }\n\n.Header-module_close-icon__-hShc {\n  height: 24px;\n  width: 24px; }\n\n.Header-module_make-steps-invisible__ylzk1 span {\n  display: none; }\n\n.Header-module_make-steps-invisible__ylzk1 h2 {\n  width: 100%; }\n";
styleInject(css_248z$3);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$1 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$1.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$1.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation = keysShim;

var slice = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

/** @type {import('.')} */
var esErrors = Error;

/** @type {import('./eval')} */
var _eval = EvalError;

/** @type {import('./range')} */
var range = RangeError;

/** @type {import('./ref')} */
var ref = ReferenceError;

/** @type {import('./syntax')} */
var syntax = SyntaxError;

/** @type {import('./type')} */
var type = TypeError;

/** @type {import('./uri')} */
var uri = URIError;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
var hasProto = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr$2 = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$2.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;


/** @type {import('.')} */
var hasown = functionBind.call(call, $hasOwn);

var undefined$1;









var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new type();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$1 = hasSymbols();
var hasProto$1 = hasProto();

var getProto = Object.getPrototypeOf || (
	hasProto$1
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$1 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': esErrors,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': _eval,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$1 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$1 || !getProto ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': range,
	'%ReferenceError%': ref,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$1 || !getProto ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$1 && getProto ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$1 ? Symbol : undefined$1,
	'%SyntaxError%': syntax,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': type,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': uri,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace = functionBind.call(Function.call, String.prototype.replace);
var $strSlice = functionBind.call(Function.call, String.prototype.slice);
var $exec = functionBind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new syntax('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new syntax('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasown(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasown(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new type('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new syntax('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new type('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new type('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new syntax('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new syntax('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasown(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new type('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasown(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

/** @type {import('.')} */
var $defineProperty = getIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

var esDefineProperty = $defineProperty;

var $gOPD$1 = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var gopd = $gOPD$1;

/** @type {import('.')} */
var defineDataProperty = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new type('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new type('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new type('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new type('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new type('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new type('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if (esDefineProperty) {
		esDefineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new syntax('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!esDefineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!esDefineProperty) {
		return null;
	}
	try {
		return esDefineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors;

var hasSymbols$2 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$3 = Object.prototype.toString;
var concat = Array.prototype.concat;


var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$3.call(fn) === '[object Function]';
};

var supportsDescriptors = hasPropertyDescriptors_1();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols$2) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

var map = hasUnscopables && Array.prototype[Symbol.unscopables];

var $TypeError = TypeError;

var esShimUnscopables = function shimUnscopables(method) {
	if (typeof method !== 'string' || !method) {
		throw new $TypeError('method must be a non-empty string');
	}
	if (!hasown(Array.prototype, method)) {
		throw new $TypeError('method must be on Array.prototype');
	}
	if (hasUnscopables) {
		map[method] = true;
	}
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var _isFinite = function (x) { return (typeof x === 'number' || typeof x === 'bigint') && !_isNaN(x) && x !== Infinity && x !== -Infinity; };

var $abs = getIntrinsic('%Math.abs%');
var $floor = getIntrinsic('%Math.floor%');




var isInteger = function isInteger(argument) {
	if (typeof argument !== 'number' || _isNaN(argument) || !_isFinite(argument)) {
		return false;
	}
	var absValue = $abs(argument);
	return $floor(absValue) === absValue;
};

var $ArrayPrototype = getIntrinsic('%Array.prototype%');






var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var hasProto$2 = hasProto();

var $setProto = getIntrinsic('%Object.setPrototypeOf%', true) || (
	hasProto$2
		? function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
		: null
);

// https://262.ecma-international.org/12.0/#sec-arraycreate

var ArrayCreate = function ArrayCreate(length) {
	if (!isInteger(length) || length < 0) {
		throw new type('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new range('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new syntax('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};

var util_inspect = require$$0.inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat$1 = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor$1 = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable$1 = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor$1(-num) : $floor$1(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace$1.call(intStr, sepRegex, '$&_') + '.' + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace$1.call(str, sepRegex, '$&_');
}


var inspectCustom = util_inspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$1(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable$1.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat$1.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && util_inspect) {
            return util_inspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (obj === commonjsGlobal) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr$4(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat$1.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace$1.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr$4(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr$4(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr$4(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$4(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr$4(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr$4(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr$4(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$4(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace$1.call($replace$1.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable$1.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

// https://262.ecma-international.org/6.0/#sec-ispropertykey

var IsPropertyKey = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

// https://262.ecma-international.org/5.1/#sec-8

var Type = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

var Type$1 = function Type$1(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return Type(x);
};

// https://262.ecma-international.org/6.0/#sec-get-o-p

var Get = function Get(O, P) {
	// 7.3.1.1
	if (Type$1(O) !== 'Object') {
		throw new type('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: IsPropertyKey(P) is not true, got ' + objectInspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var hasDescriptors = hasPropertyDescriptors_1();



var $floor$2 = getIntrinsic('%Math.floor%');

/** @type {import('.')} */
var setFunctionLength = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new type('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor$2(length) !== length) {
		throw new type('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gopd) {
		var desc = gopd(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			defineDataProperty(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			defineDataProperty(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};

var callBind = createCommonjsModule(function (module) {






var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);


var $max = getIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new type('a function is required');
	}
	var func = $reflectApply(functionBind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if (esDefineProperty) {
	esDefineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var $Array = getIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$5 = !$Array.isArray && callBound('Object.prototype.toString');

var IsArray = $Array.isArray || function IsArray(argument) {
	return toStr$5(argument) === '[object Array]';
};

// https://262.ecma-international.org/6.0/#sec-isarray
var IsArray$1 = IsArray;

// TODO: remove, semver-major

var GetIntrinsic = getIntrinsic;

var allowed = {
	__proto__: null,
	'[[Configurable]]': true,
	'[[Enumerable]]': true,
	'[[Get]]': true,
	'[[Set]]': true,
	'[[Value]]': true,
	'[[Writable]]': true
};

// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type

var propertyDescriptor = function isPropertyDescriptor(Desc) {
	if (!Desc || typeof Desc !== 'object') {
		return false;
	}

	for (var key in Desc) { // eslint-disable-line
		if (hasown(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	var isData = hasown(Desc, '[[Value]]') || hasown(Desc, '[[Writable]]');
	var IsAccessor = hasown(Desc, '[[Get]]') || hasown(Desc, '[[Set]]');
	if (isData && IsAccessor) {
		throw new type('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};

var hasArrayLengthDefineBug = hasPropertyDescriptors_1.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray$1 = hasArrayLengthDefineBug && IsArray;



var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!esDefineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray$1(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	esDefineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};

var fromPropertyDescriptor = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};

// https://262.ecma-international.org/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined' && !propertyDescriptor(Desc)) {
		throw new type('Assertion failed: `Desc` must be a Property Descriptor');
	}

	return fromPropertyDescriptor(Desc);
};

// https://262.ecma-international.org/5.1/#sec-8.10.2

var IsDataDescriptor = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	if (!propertyDescriptor(Desc)) {
		throw new type('Assertion failed: `Desc` must be a Property Descriptor');
	}

	if (!hasown(Desc, '[[Value]]') && !hasown(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

// http://262.ecma-international.org/5.1/#sec-9.12

var SameValue = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return _isNaN(x) && _isNaN(y);
};

// http://262.ecma-international.org/5.1/#sec-9.2

var ToBoolean = function ToBoolean(value) { return !!value; };

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$6 = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr$6.call(all) === toStr$6.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr$6.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

var isCallable = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$6.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};

// http://262.ecma-international.org/5.1/#sec-9.11

var IsCallable = isCallable;

// https://262.ecma-international.org/5.1/#sec-8.10.5

var ToPropertyDescriptor = function ToPropertyDescriptor(Obj) {
	if (Type$1(Obj) !== 'Object') {
		throw new type('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (hasown(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (hasown(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (hasown(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (hasown(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (hasown(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new type('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (hasown(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new type('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((hasown(desc, '[[Get]]') || hasown(desc, '[[Set]]')) && (hasown(desc, '[[Value]]') || hasown(desc, '[[Writable]]'))) {
		throw new type('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

// https://262.ecma-international.org/6.0/#sec-definepropertyorthrow

var DefinePropertyOrThrow = function DefinePropertyOrThrow(O, P, desc) {
	if (Type$1(O) !== 'Object') {
		throw new type('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = propertyDescriptor(desc) ? desc : ToPropertyDescriptor(desc);
	if (!propertyDescriptor(Desc)) {
		throw new type('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};

var IsConstructor = createCommonjsModule(function (module) {



var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow$1 = DefinePropertyOrThrow;
try {
	DefinePropertyOrThrow$1({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow$1 = null;
}

// https://262.ecma-international.org/6.0/#sec-isconstructor

if (DefinePropertyOrThrow$1 && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow$1(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}
});

var $species = getIntrinsic('%Symbol.species%', true);










// https://262.ecma-international.org/12.0/#sec-arrayspeciescreate

var ArraySpeciesCreate = function ArraySpeciesCreate(originalArray, length) {
	if (!isInteger(length) || length < 0) {
		throw new type('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray$1(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type$1(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new type('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};

var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991; // Math.pow(2, 53) - 1;

var $apply = getIntrinsic('%Reflect.apply%', true) || callBound('Function.prototype.apply');

// https://262.ecma-international.org/6.0/#sec-call

var Call = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray$1(argumentsList)) {
		throw new type('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};

// https://262.ecma-international.org/5.1/#sec-8.10.1

var IsAccessorDescriptor = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	if (!propertyDescriptor(Desc)) {
		throw new type('Assertion failed: `Desc` must be a Property Descriptor');
	}

	if (!hasown(Desc, '[[Get]]') && !hasown(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var $preventExtensions = getIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = getIntrinsic('%Object.isExtensible%', true);



// https://262.ecma-international.org/6.0/#sec-isextensible-o

var IsExtensible = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};

var isFullyPopulatedPropertyDescriptor = function isFullyPopulatedPropertyDescriptor(ES, Desc) {
	return propertyDescriptor(Desc)
		&& typeof Desc === 'object'
		&& '[[Enumerable]]' in Desc
		&& '[[Configurable]]' in Desc
		&& (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
};

// https://262.ecma-international.org/6.0/#sec-isgenericdescriptor

var IsGenericDescriptor = function IsGenericDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	if (!propertyDescriptor(Desc)) {
		throw new type('Assertion failed: `Desc` must be a Property Descriptor');
	}

	if (!IsAccessorDescriptor(Desc) && !IsDataDescriptor(Desc)) {
		return true;
	}

	return false;
};

// https://262.ecma-international.org/13.0/#sec-validateandapplypropertydescriptor

// see https://github.com/tc39/ecma262/pull/2468 for ES2022 changes

// eslint-disable-next-line max-lines-per-function, max-statements
var ValidateAndApplyPropertyDescriptor = function ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current) {
	var oType = Type$1(O);
	if (oType !== 'Undefined' && oType !== 'Object') {
		throw new type('Assertion failed: O must be undefined or an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: P must be a Property Key');
	}
	if (typeof extensible !== 'boolean') {
		throw new type('Assertion failed: extensible must be a Boolean');
	}
	if (!propertyDescriptor(Desc)) {
		throw new type('Assertion failed: Desc must be a Property Descriptor');
	}
	if (typeof current !== 'undefined' && !propertyDescriptor(current)) {
		throw new type('Assertion failed: current must be a Property Descriptor, or undefined');
	}

	if (typeof current === 'undefined') { // step 2
		if (!extensible) {
			return false; // step 2.a
		}
		if (oType === 'Undefined') {
			return true; // step 2.b
		}
		if (IsAccessorDescriptor(Desc)) { // step 2.c
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				Desc
			);
		}
		// step 2.d
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			{
				'[[Configurable]]': !!Desc['[[Configurable]]'],
				'[[Enumerable]]': !!Desc['[[Enumerable]]'],
				'[[Value]]': Desc['[[Value]]'],
				'[[Writable]]': !!Desc['[[Writable]]']
			}
		);
	}

	// 3. Assert: current is a fully populated Property Descriptor.
	if (
		!isFullyPopulatedPropertyDescriptor(
			{
				IsAccessorDescriptor: IsAccessorDescriptor,
				IsDataDescriptor: IsDataDescriptor
			},
			current
		)
	) {
		throw new type('`current`, when present, must be a fully populated and valid Property Descriptor');
	}

	// 4. If every field in Desc is absent, return true.
	// this can't really match the assertion that it's a Property Descriptor in our JS implementation

	// 5. If current.[[Configurable]] is false, then
	if (!current['[[Configurable]]']) {
		if ('[[Configurable]]' in Desc && Desc['[[Configurable]]']) {
			// step 5.a
			return false;
		}
		if ('[[Enumerable]]' in Desc && !SameValue(Desc['[[Enumerable]]'], current['[[Enumerable]]'])) {
			// step 5.b
			return false;
		}
		if (!IsGenericDescriptor(Desc) && !SameValue(IsAccessorDescriptor(Desc), IsAccessorDescriptor(current))) {
			// step 5.c
			return false;
		}
		if (IsAccessorDescriptor(current)) { // step 5.d
			if ('[[Get]]' in Desc && !SameValue(Desc['[[Get]]'], current['[[Get]]'])) {
				return false;
			}
			if ('[[Set]]' in Desc && !SameValue(Desc['[[Set]]'], current['[[Set]]'])) {
				return false;
			}
		} else if (!current['[[Writable]]']) { // step 5.e
			if ('[[Writable]]' in Desc && Desc['[[Writable]]']) {
				return false;
			}
			if ('[[Value]]' in Desc && !SameValue(Desc['[[Value]]'], current['[[Value]]'])) {
				return false;
			}
		}
	}

	// 6. If O is not undefined, then
	if (oType !== 'Undefined') {
		var configurable;
		var enumerable;
		if (IsDataDescriptor(current) && IsAccessorDescriptor(Desc)) { // step 6.a
			configurable = ('[[Configurable]]' in Desc ? Desc : current)['[[Configurable]]'];
			enumerable = ('[[Enumerable]]' in Desc ? Desc : current)['[[Enumerable]]'];
			// Replace the property named P of object O with an accessor property having [[Configurable]] and [[Enumerable]] attributes as described by current and each other attribute set to its default value.
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': !!configurable,
					'[[Enumerable]]': !!enumerable,
					'[[Get]]': ('[[Get]]' in Desc ? Desc : current)['[[Get]]'],
					'[[Set]]': ('[[Set]]' in Desc ? Desc : current)['[[Set]]']
				}
			);
		} else if (IsAccessorDescriptor(current) && IsDataDescriptor(Desc)) {
			configurable = ('[[Configurable]]' in Desc ? Desc : current)['[[Configurable]]'];
			enumerable = ('[[Enumerable]]' in Desc ? Desc : current)['[[Enumerable]]'];
			// i. Replace the property named P of object O with a data property having [[Configurable]] and [[Enumerable]] attributes as described by current and each other attribute set to its default value.
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': !!configurable,
					'[[Enumerable]]': !!enumerable,
					'[[Value]]': ('[[Value]]' in Desc ? Desc : current)['[[Value]]'],
					'[[Writable]]': !!('[[Writable]]' in Desc ? Desc : current)['[[Writable]]']
				}
			);
		}

		// For each field of Desc that is present, set the corresponding attribute of the property named P of object O to the value of the field.
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			Desc
		);
	}

	return true; // step 7
};

// https://262.ecma-international.org/6.0/#sec-ordinarydefineownproperty

var OrdinaryDefineOwnProperty = function OrdinaryDefineOwnProperty(O, P, Desc) {
	if (Type$1(O) !== 'Object') {
		throw new type('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: P must be a Property Key');
	}
	if (!propertyDescriptor(Desc)) {
		throw new type('Assertion failed: Desc must be a Property Descriptor');
	}
	if (!gopd) {
		// ES3/IE 8 fallback
		if (IsAccessorDescriptor(Desc)) {
			throw new syntax('This environment does not support accessor property descriptors.');
		}
		var creatingNormalDataProperty = !(P in O)
			&& Desc['[[Writable]]']
			&& Desc['[[Enumerable]]']
			&& Desc['[[Configurable]]']
			&& '[[Value]]' in Desc;
		var settingExistingDataProperty = (P in O)
			&& (!('[[Configurable]]' in Desc) || Desc['[[Configurable]]'])
			&& (!('[[Enumerable]]' in Desc) || Desc['[[Enumerable]]'])
			&& (!('[[Writable]]' in Desc) || Desc['[[Writable]]'])
			&& '[[Value]]' in Desc;
		if (creatingNormalDataProperty || settingExistingDataProperty) {
			O[P] = Desc['[[Value]]']; // eslint-disable-line no-param-reassign
			return SameValue(O[P], Desc['[[Value]]']);
		}
		throw new syntax('This environment does not support defining non-writable, non-enumerable, or non-configurable properties');
	}
	var desc = gopd(O, P);
	var current = desc && ToPropertyDescriptor(desc);
	var extensible = IsExtensible(O);
	return ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current);
};

// https://262.ecma-international.org/6.0/#sec-createdataproperty

var CreateDataProperty = function CreateDataProperty(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new type('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: IsPropertyKey(P) is not true');
	}
	var newDesc = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Value]]': V,
		'[[Writable]]': true
	};
	return OrdinaryDefineOwnProperty(O, P, newDesc);
};

// // https://262.ecma-international.org/14.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new type('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new type('unable to create data property');
	}
};

// https://262.ecma-international.org/6.0/#sec-hasproperty

var HasProperty = function HasProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new type('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new type('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

var isPrimitive$1 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

/** @type {import('.')} */
var shams$1 = function hasToStringTagShams() {
	return shams() && !!Symbol.toStringTag;
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$7 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$1 = shams$1();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$1 ? tryDateObject(value) : toStr$7.call(value) === dateClass;
};

var isSymbol$1 = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols$1 = hasSymbols();

if (hasSymbols$1) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive$1(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive$1(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols$3) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol$1(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive$1(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol$1(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://262.ecma-international.org/6.0/#sec-toprimitive

var ToPrimitive = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var hasToStringTag$2 = shams$1();
var has$2;
var $exec$1;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$2) {
	has$2 = callBound('Object.prototype.hasOwnProperty');
	$exec$1 = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$2
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has$2(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec$1(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};

var $exec$2 = callBound('RegExp.prototype.exec');


var safeRegexTest = function regexTester(regex) {
	if (!isRegex(regex)) {
		throw new type('`regex` must be a RegExp');
	}
	return function test(s) {
		return $exec$2(regex, s) !== null;
	};
};

/** @type {import('./RequireObjectCoercible')} */
var RequireObjectCoercible = function RequireObjectCoercible(value) {
	if (value == null) {
		throw new type((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
	}
	return value;
};

var $String = getIntrinsic('%String%');


// https://262.ecma-international.org/6.0/#sec-tostring

var ToString = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new type('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

var $replace$2 = callBound('String.prototype.replace');

var mvsIsWS = (/^\s$/).test('\u180E');
/* eslint-disable no-control-regex */
var leftWhitespace = mvsIsWS
	? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/
	: /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = mvsIsWS
	? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/
	: /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */

var implementation$2 = function trim() {
	var S = ToString(RequireObjectCoercible(this));
	return $replace$2($replace$2(S, leftWhitespace, ''), rightWhitespace, '');
};

var zeroWidthSpace = '\u200b';
var mongolianVowelSeparator = '\u180E';

var polyfill = function getPolyfill() {
	if (
		String.prototype.trim
		&& zeroWidthSpace.trim() === zeroWidthSpace
		&& mongolianVowelSeparator.trim() === mongolianVowelSeparator
		&& ('_' + mongolianVowelSeparator).trim() === ('_' + mongolianVowelSeparator)
		&& (mongolianVowelSeparator + '_').trim() === (mongolianVowelSeparator + '_')
	) {
		return String.prototype.trim;
	}
	return implementation$2;
};

var shim = function shimStringTrim() {
	var polyfill$1 = polyfill();
	defineProperties_1(String.prototype, { trim: polyfill$1 }, {
		trim: function testTrim() {
			return String.prototype.trim !== polyfill$1;
		}
	});
	return polyfill$1;
};

var bound = callBind(polyfill());
var boundMethod = function trim(receiver) {
	RequireObjectCoercible(receiver);
	return bound(receiver);
};

defineProperties_1(boundMethod, {
	getPolyfill: polyfill,
	implementation: implementation$2,
	shim: shim
});

var string_prototype_trim = boundMethod;

var $Number = getIntrinsic('%Number%');
var $RegExp = getIntrinsic('%RegExp%');

var $parseInteger = getIntrinsic('%parseInt%');




var $strSlice$1 = callBound('String.prototype.slice');
var isBinary = safeRegexTest(/^0b[01]+$/i);
var isOctal = safeRegexTest(/^0o[0-7]+$/i);
var isInvalidHexLiteral = safeRegexTest(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = safeRegexTest(nonWSregex);



// https://262.ecma-international.org/13.0/#sec-stringtonumber

var StringToNumber = function StringToNumber(argument) {
	if (typeof argument !== 'string') {
		throw new type('Assertion failed: `argument` is not a String');
	}
	if (isBinary(argument)) {
		return $Number($parseInteger($strSlice$1(argument, 2), 2));
	}
	if (isOctal(argument)) {
		return $Number($parseInteger($strSlice$1(argument, 2), 8));
	}
	if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
		return NaN;
	}
	var trimmed = string_prototype_trim(argument);
	if (trimmed !== argument) {
		return StringToNumber(trimmed);
	}
	return $Number(argument);
};

var $Number$1 = getIntrinsic('%Number%');





// https://262.ecma-international.org/13.0/#sec-tonumber

var ToNumber = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number$1);
	if (typeof value === 'symbol') {
		throw new type('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new type('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		return StringToNumber(value);
	}
	return $Number$1(value);
};

// var modulo = require('./modulo');
var $floor$3 = Math.floor;

// http://262.ecma-international.org/11.0/#eqn-floor

var floor = function floor(x) {
	// return x - modulo(x, 1);
	if (typeof x === 'bigint') {
		return x;
	}
	return $floor$3(x);
};

// https://262.ecma-international.org/14.0/#eqn-truncate

var truncate = function truncate(x) {
	if (typeof x !== 'number' && typeof x !== 'bigint') {
		throw new type('argument must be a Number or a BigInt');
	}
	var result = x < 0 ? -floor(-x) : floor(x);
	return result === 0 ? 0 : result; // in the spec, these are math values, so we filter out -0 here
};

// https://262.ecma-international.org/14.0/#sec-tointegerorinfinity

var ToIntegerOrInfinity = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if (_isNaN(number) || number === 0) { return 0; }
	if (!_isFinite(number)) { return number; }
	return truncate(number);
};

var ToLength = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > maxSafeInteger) { return maxSafeInteger; }
	return len;
};

// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

var LengthOfArrayLike = function LengthOfArrayLike(obj) {
	if (Type$1(obj) !== 'Object') {
		throw new type('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

var $String$1 = getIntrinsic('%String%');


// https://262.ecma-international.org/6.0/#sec-tostring

var ToString$1 = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new type('Cannot convert a Symbol value to a string');
	}
	return $String$1(argument);
};

// https://262.ecma-international.org/11.0/#sec-flattenintoarray

var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString$1(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new type('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray$1(element);
			}
			if (shouldFlatten) {
				var elementLen = LengthOfArrayLike(element);
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= maxSafeInteger) {
					throw new type('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString$1(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

/** @type {import('.')} */
var esObjectAtoms = Object;

/** @type {import('./ToObject')} */
var ToObject = function ToObject(value) {
	RequireObjectCoercible(value);
	return esObjectAtoms(value);
};

// https://262.ecma-international.org/6.0/#sec-toobject

var ToObject$1 = ToObject;

var implementation$3 = function flat() {
	var O = ToObject$1(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToIntegerOrInfinity(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};

var polyfill$1 = function getPolyfill() {
	return Array.prototype.flat || implementation$3;
};

var shim$1 = function shimFlat() {
	var polyfill = polyfill$1();

	defineProperties_1(
		Array.prototype,
		{ flat: polyfill },
		{ flat: function () { return Array.prototype.flat !== polyfill; } }
	);

	esShimUnscopables('flat');

	return polyfill;
};

shim$1();

var FlatFilter = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatfiltermap = exports.filtermap = exports.flatfilter = exports.flatmap = exports.flat = exports.map = exports.filter = exports.assertType = void 0;
/** Asserts the type of obj at compile-time */
function assertType(_obj) {
    return;
}
exports.assertType = assertType;
function wrap(array) {
    return Array.isArray(array) ? array : [array];
}
function filter(array) {
    return wrap(array).filter(Boolean);
}
exports.filter = filter;
function map(array, mapper) {
    return wrap(array).map(mapper);
}
exports.map = map;
function flat(array) {
    return wrap(array).flat(Infinity);
}
exports.flat = flat;
function flatmap(array, mapper) {
    return map(flat(array), mapper);
}
exports.flatmap = flatmap;
function flatfilter(array) {
    return filter(flat(array));
}
exports.flatfilter = flatfilter;
function filtermap(array, mapper) {
    return filter(map(array, mapper));
}
exports.filtermap = filtermap;
function flatfiltermap(array, mapper) {
    return filtermap(flat(array), mapper);
}
exports.flatfiltermap = flatfiltermap;
});

var Join = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;

/** Create a single CSS class from a set of classes or conditional classes. */
function join() {
    var potentials = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        potentials[_i] = arguments[_i];
    }
    // Edge is stubborn and adds commas anyways. Let's replace them with spaces.
    return FlatFilter.flatfilter(potentials)
        .join(" ")
        .replace(/,/g, " ");
}
exports.join = join;
});

var progressIndicatorContainer = "ProgressIndicator_progress-indicator-container__9UXpm";
var infoContainer = "ProgressIndicator_info-container__RmV5M";
var title = "ProgressIndicator_title__EDuKH";
var pagination = "ProgressIndicator_pagination__uut4n";
var outerBar = "ProgressIndicator_outer-bar__Y4QkL";
var innerBar = "ProgressIndicator_inner-bar__LI4fE";
var css_248z$4 = ".ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n  font-size: 34px;\n  bottom: 0;\n  width: 85%; }\n  @media (max-width: 1023px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 28px; } }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 22px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n  font-size: 12px;\n  padding-top: 10px;\n  bottom: 3px; }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n      font-size: 11px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL {\n  width: 100%;\n  border-radius: 2px; }\n  .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL .ProgressIndicator_inner-bar__LI4fE {\n    padding: 1.5px;\n    border-radius: 2px; }\n";
var ProgressIndicator = {"progress-indicator-container":"ProgressIndicator_progress-indicator-container__9UXpm","info-container":"ProgressIndicator_info-container__RmV5M","title":"ProgressIndicator_title__EDuKH","pagination":"ProgressIndicator_pagination__uut4n","outer-bar":"ProgressIndicator_outer-bar__Y4QkL","inner-bar":"ProgressIndicator_inner-bar__LI4fE","progressIndicatorContainer":"ProgressIndicator_progress-indicator-container__9UXpm","infoContainer":"ProgressIndicator_info-container__RmV5M","outerBar":"ProgressIndicator_outer-bar__Y4QkL","innerBar":"ProgressIndicator_inner-bar__LI4fE"};
const stylesheet=".ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n  font-size: 34px;\n  bottom: 0;\n  width: 85%; }\n  @media (max-width: 1023px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 28px; } }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 22px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n  font-size: 12px;\n  padding-top: 10px;\n  bottom: 3px; }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n      font-size: 11px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL {\n  width: 100%;\n  border-radius: 2px; }\n  .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL .ProgressIndicator_inner-bar__LI4fE {\n    padding: 1.5px;\n    border-radius: 2px; }\n";
styleInject(css_248z$4);

var ProgressIndicator$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    progressIndicatorContainer: progressIndicatorContainer,
    infoContainer: infoContainer,
    title: title,
    pagination: pagination,
    outerBar: outerBar,
    innerBar: innerBar,
    'default': ProgressIndicator,
    stylesheet: stylesheet
});

var styles = /*@__PURE__*/getAugmentedNamespace(ProgressIndicator$1);

var ProgressIndicator_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var ProgressIndicator = function (_a) {
    var testId = _a.testId, title = _a.title, numPages = _a.numPages, currentPageNum = _a.currentPageNum, className = _a.className, accessibility = _a.accessibility, isFirstElement = _a.isFirstElement;
    return (React__default.createElement("div", { "data-testid": testId, className: Join.join(styles.progressIndicatorContainer, className) },
        React__default.createElement("div", { role: "alert", "aria-label": accessibility, className: Join.join(styles.infoContainer, "flex", "rel", "text-left") },
            isFirstElement ? (React__default.createElement("h1", { className: Join.join(styles.title, "pull-left", "color-ui-black", "font-medium") }, title)) : (React__default.createElement("h2", { className: Join.join(styles.title, "pull-left", "color-ui-black", "font-medium") }, title)),
            React__default.createElement("span", { className: Join.join(styles.pagination, "absolute", "pull-right", "color-ui-dark-gray", "pad-l-xxs", "right"), "aria-label": "progress is on step " },
                currentPageNum,
                " of ",
                numPages)),
        React__default.createElement("div", { className: Join.join(styles.outerBar, "height-xxxs", "bg-ui-light-gray", "mar-t-xs") },
            React__default.createElement("div", { className: Join.join(styles.innerBar, "height-xxxs", "bg-cobalt"), style: { width: (currentPageNum / numPages) * 100 + "%" } }))));
};
exports.default = ProgressIndicator;
});

var ProgressIndicator$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ProgressIndicator_1.default;
});

var ProgressIndicator$3 = /*@__PURE__*/getDefaultExportFromCjs(ProgressIndicator$2);

var Simplify = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplify = void 0;
/**
 * Turns all optional values in an object to the value itself if it is truthy, or undefined if not.
 * @param obj The object to simplify.
 */
function simplify(obj) {
    var except = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        except[_i - 1] = arguments[_i];
    }
    var ret = {};
    // tslint:disable-next-line: forin
    for (var key in obj) {
        if (except.includes && except.includes(key)) {
            continue;
        }
        ret[key] = obj[key] || undefined;
    }
    return ret;
}
exports.simplify = simplify;
});

var utils = createCommonjsModule(function (module, exports) {
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSsrSafe = exports.ssrSafe = exports.isMobile = void 0;
/**
 * @param {string} parentTestId testId of parent component
 * @param {string} component Callee component's definition. Ex: Button
 * @param {string} testIdSuffix Describes callee component's feature/property. Ex: SelectPrice
 */
function getTestId(parentTestId, component, testIdSuffix) {
    return parentTestId
        ? parentTestId + "_" + component + (testIdSuffix ? "_" + testIdSuffix : "")
        : "";
}
exports.default = getTestId;
function isMobile() {
    if (process.browser) {
        return /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
}
exports.isMobile = isMobile;
/**
 * Run a function if it is safe to do so when taking SSR into account.
 * @param func The function to run if it is safe to do so.
 * @param dependencies Any extra dependencies to check.
 */
function ssrSafe(func, dependencies) {
    if (dependencies === void 0) { dependencies = [
        (typeof process === "object" && process.browser) || typeof window === "object",
    ]; }
    // ensures browser specific functions are run only if browser is available whether in ssr or client
    if (dependencies.every(Boolean)) {
        return func();
    }
    return undefined;
}
exports.ssrSafe = ssrSafe;
function makeSsrSafe(func, dependencies) {
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ssrSafe(function () {
            var _a;
            return (_a = func).call.apply(_a, __spread([_this], args));
        }, dependencies);
    };
}
exports.makeSsrSafe = makeSsrSafe;
});

var Constants = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusableSelector = void 0;
/** A selector that will match elements that can be focused. */
exports.focusableSelector = 'a:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'area:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'button:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'input:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'object:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'select:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'textarea:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    '[tabindex]:not([tabindex^="-"]):not([tabindex=""])';
});

var Focus = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.focus = exports.getFocusableChildren = void 0;


/** Get all the children of this element that are focusable. */
function getFocusableChildren(inElement) {
    return inElement ? Array.from(inElement.querySelectorAll(Constants.focusableSelector)) : [];
}
exports.getFocusableChildren = getFocusableChildren;
/** Transfer the focus to an element that isn't traditionally focusable. This is for accessibility purposes if you need to move the focus somewhere but don't exactly have a precise target for it. */
exports.focus = utils.makeSsrSafe(function (element, preventScroll) {
    if (preventScroll === void 0) { preventScroll = true; }
    if (!element) {
        return;
    }
    var selectable = element.matches(Constants.focusableSelector);
    var tabIndex;
    if (!selectable) {
        tabIndex = element.getAttribute("tabindex");
        element.tabIndex = 0;
    }
    var scrollX = window.scrollX, scrollY = window.scrollY;
    element.focus({
        preventScroll: preventScroll,
    });
    if (preventScroll && (window.scrollY !== scrollY || window.scrollX !== scrollX)) {
        window.scrollTo(scrollX, scrollY);
    }
    if (tabIndex) {
        element.setAttribute("tabindex", tabIndex);
    }
    else {
        element.removeAttribute("tabindex");
    }
});
});

var Refs = createCommonjsModule(function (module, exports) {
var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refs = void 0;

/** Combine a set of refs into a single ref callback. */
function refs() {
    var refsToCombine = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refsToCombine[_i] = arguments[_i];
    }
    return function (instance) {
        var e_1, _a;
        try {
            for (var _b = __values(FlatFilter.flatfilter(refsToCombine)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var ref = _c.value;
                if (typeof ref === "function") {
                    ref(instance);
                }
                else if (ref && typeof ref === "object" && "current" in ref) {
                    ref.current = instance;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
}
exports.refs = refs;
});

var ConcatUrls = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUrls = void 0;

function concatUrls() {
    var urls = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        urls[_i] = arguments[_i];
    }
    var filtered = FlatFilter.flatfilter(urls);
    return filtered.length > 0 ? "/" + filtered.join("/").replace(/^\/+|\/+$|\/+(\/)/g, "$1") : "";
}
exports.concatUrls = concatUrls;
});

var Reporting = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingHelper = void 0;



var service;
exports.ReportingHelper = {
    get initialized() {
        return Boolean(service);
    },
    initialize: function (ReportingServiceClass) {
        service = ReportingServiceClass.getInstance();
    },
    pageLoad: function (_a) {
        var suffix = _a.url, prefix = _a.prefix, flowCode = _a.flowCode, lineOfBusiness = _a.lineOfBusiness, maybeDisplayedMessage = _a.displayedMessage, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls.concatUrls(prefix, suffix);
        var displayedMessage = FlatFilter.flatfilter(maybeDisplayedMessage).join("|");
        // 	console.log(`ReportingHelper: pageLoad ->
        // url : ${url}
        // flowCode : ${flowCode}
        // lineOfBusiness: ${lineOfBusiness}${
        // 		displayedMessage
        // 			? `
        // displayedMessage: ${displayedMessage}`
        // 			: ``
        // 	}`)
        service.firePageLoadEvent(__assign({ url: url, "page.pageInfo.flowCode": flowCode, "page.pageInfo.lineOfBusiness": lineOfBusiness, "page.attributes.displayedMessage": displayedMessage }, additionalParameters));
    },
    linkClick: function (_a) {
        var name = _a.name, _b = _a.position, position = _b === void 0 ? "Body" : _b, suffix = _a.url, prefix = _a.prefix, pageUrl = _a.pageUrl, pagePrefix = _a.pagePrefix, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls.concatUrls(prefix, suffix);
        // 	console.log(
        // 		`ReportingHelper: linkClick ->
        // name: ${name}
        // position: ${position}${
        // 			url
        // 				? `
        // url: ${url}`
        // 				: ""
        // 		}`
        // 	)
        if (pageUrl) {
            this.pageLoad({ url: pageUrl, prefix: pagePrefix });
        }
        service.fireLinkClickEvent(__assign({ linkName: name, linkPosition: position, linkDestinationUrl: url }, additionalParameters));
    },
    systemEvent: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireSystemEvent(name, data);
    },
    formSubmit: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireFormSubmitEvent(name, data);
    },
    formResponse: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireFormResponseEvent(name, data);
    },
    impression: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var data = Simplify.simplify(payload).data;
        // console.log(
        // 	`ReportingHelper: impression ->
        //         data: ${data ? JSON.stringify(data) : ""}
        //     `
        // )
        service.fireImpression(data);
    },
};
/** Function for logging, simplifying, and returning payloads for systemEvent or formSubmit due to their similarity */
function logEventPayload(payload, _eventType) {
    var _a = Simplify.simplify(payload), name = _a.name, data = _a.data;
    // 	console.log(
    // 		`ReportingHelper: ${_eventType} ->
    // eventName: ${name}${
    // 			data
    // 				? `
    // additionalData: ${JSON.stringify(data)}`
    // 				: ``
    // 		}`
    // 	)
    return { name: name, data: data };
}
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction$1(x) {
    return typeof x === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (config.useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            hostReportError(err);
        }
    },
    complete: function () { }
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray$2 = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x !== null && typeof x === 'object';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
var UnsubscriptionError = UnsubscriptionErrorImpl;

/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (isFunction$1(_unsubscribe)) {
            if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
            }
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (isArray$2(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new UnsubscriptionError(errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/ (function () {
    return typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
})();

/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
var Subscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[rxSubscriber] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(Subscription));
var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (isFunction$1(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== empty) {
                context = Object.create(observerOrNext);
                if (isFunction$1(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                hostReportError(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    hostReportError(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (config.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!config.useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                hostReportError(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof Subscriber) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}

/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber]) {
            return nextOrObserver[rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber(empty);
    }
    return new Subscriber(nextOrObserver, error, complete);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}

/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
var Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (config.useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (canReportError(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = config.Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
})();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    __extends$1(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */
var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(Subscriber));
var Subject = /*@__PURE__*/ (function (_super) {
    __extends$1(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));
var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    __extends$1(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */
var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    __extends$1(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount()(this);
    };
    return ConnectableObservable;
}(Observable));
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(SubjectSubscriber));

/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    __extends$1(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable));
var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    __extends$1(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */
var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    __extends$1(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject));

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var Action = /*@__PURE__*/ (function (_super) {
    __extends$1(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        return this;
    };
    return Action;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
var AsyncAction = /*@__PURE__*/ (function (_super) {
    __extends$1(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action));

/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
var QueueAction = /*@__PURE__*/ (function (_super) {
    __extends$1(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction));

var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    __extends$1(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var QueueScheduler = /*@__PURE__*/ (function (_super) {
    __extends$1(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */
var queueScheduler = /*@__PURE__*/ new QueueScheduler(QueueAction);
var queue = queueScheduler;

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
var EMPTY = /*@__PURE__*/ new Observable(function (subscriber) { return subscriber.complete(); });
function empty$1(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function scheduleArray(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function fromArray(input, scheduler) {
    if (!scheduler) {
        return new Observable(subscribeToArray(input));
    }
    else {
        return scheduleArray(input, scheduler);
    }
}

/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (isScheduler(scheduler)) {
        args.pop();
        return scheduleArray(args, scheduler);
    }
    else {
        return fromArray(args);
    }
}

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function throwError(error, scheduler) {
    if (!scheduler) {
        return new Observable(function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new Observable(function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */
var NotificationKind;
/*@__PURE__*/ (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return of(this.value);
            case 'E':
                return throwError(this.error);
            case 'C':
                return empty$1();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification.createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification.createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(Subscriber));
var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */
var ReplaySubject = /*@__PURE__*/ (function (_super) {
    __extends$1(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) {
                _events.shift();
            }
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.isStopped || this.hasError) {
            subscription = Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new ObserveOnSubscriber(subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject));
var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());

/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */
var AsyncSubject = /*@__PURE__*/ (function (_super) {
    __extends$1(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ (function () { return /*@__PURE__*/ Promise.resolve(); })();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};

/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */
var AsapAction = /*@__PURE__*/ (function (_super) {
    __extends$1(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var AsapScheduler = /*@__PURE__*/ (function (_super) {
    __extends$1(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */
var asapScheduler = /*@__PURE__*/ new AsapScheduler(AsapAction);
var asap = asapScheduler;

/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var asyncScheduler = /*@__PURE__*/ new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    __extends$1(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    __extends$1(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */
var animationFrameScheduler = /*@__PURE__*/ new AnimationFrameScheduler(AnimationFrameAction);
var animationFrame = animationFrameScheduler;

/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    __extends$1(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler));
var VirtualAction = /*@__PURE__*/ (function (_super) {
    __extends$1(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function isObservable(obj) {
    return !!obj && (obj instanceof Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
})();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var EmptyErrorImpl = /*@__PURE__*/ (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
var EmptyError = EmptyErrorImpl;

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var TimeoutErrorImpl = /*@__PURE__*/ (function () {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
})();
var TimeoutError = TimeoutErrorImpl;

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function map$1(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map$1(function (args) { return isArray$2(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new Observable(function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch$1, 0, state);
            }
        });
    };
}
function dispatch$1(state) {
    var _this = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}

/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map$1(function (args) { return isArray$2(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new Observable(function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(dispatch$2, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function dispatch$2(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext$1, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext$1(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, hostReportError);
        return subscriber;
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator$1 = iterable[iterator]();
        do {
            var item = void 0;
            try {
                item = iterator$1.next();
            }
            catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator$1.return === 'function') {
            subscriber.add(function () {
                if (iterator$1.return) {
                    iterator$1.return();
                }
            });
        }
        return subscriber;
    };
};

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[observable]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
var subscribeTo = function (result) {
    if (!!result && typeof result[observable] === 'function') {
        return subscribeToObservable(result);
    }
    else if (isArrayLike(result)) {
        return subscribeToArray(result);
    }
    else if (isPromise(result)) {
        return subscribeToPromise(result);
    }
    else if (!!result && typeof result[iterator] === 'function') {
        return subscribeToIterable(result);
    }
    else {
        var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};

/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) {
        innerSubscriber = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    }
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable) {
        return result.subscribe(innerSubscriber);
    }
    return subscribeTo(result)(innerSubscriber);
}

/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */
var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = undefined;
    var scheduler = undefined;
    if (isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && isArray$2(observables[0])) {
        observables = observables[0];
    }
    return fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());
var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber));

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */
function scheduleObservable(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        sub.add(scheduler.schedule(function () {
            var observable$1 = input[observable]();
            sub.add(observable$1.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function schedulePromise(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        sub.add(scheduler.schedule(function () {
            return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */
function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        var iterator$1;
        sub.add(function () {
            if (iterator$1 && typeof iterator$1.return === 'function') {
                iterator$1.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator$1 = input[iterator]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator$1.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
function isInteropObservable(input) {
    return input && typeof input[observable] === 'function';
}

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
function isIterable(input) {
    return input && typeof input[iterator] === 'function';
}

/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */
function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        else if (isPromise(input)) {
            return schedulePromise(input, scheduler);
        }
        else if (isArrayLike(input)) {
            return scheduleArray(input, scheduler);
        }
        else if (isIterable(input) || typeof input === 'string') {
            return scheduleIterable(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof Observable) {
            return input;
        }
        return new Observable(subscribeTo(input));
    }
    else {
        return scheduled(input, scheduler);
    }
}

/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}(Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}(Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable) {
        return result.subscribe(innerSubscriber);
    }
    var subscription;
    try {
        subscription = subscribeTo(result)(innerSubscriber);
    }
    catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return from(project(a, i)).pipe(map$1(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());
var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish) {
        var innerSubscriber = new SimpleInnerSubscriber(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = innerSubscribe(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */
function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap(identity, concurrent);
}

/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */
function concatAll() {
    return mergeAll(1);
}

/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */
function concat$1() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return concatAll()(of.apply(void 0, observables));
}

/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
function defer(observableFactory) {
    return new Observable(function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? from(input) : empty$1();
        return source.subscribe(subscriber);
    });
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */
function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (isArray$2(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && isArray$2(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(map$1(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new Observable(function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = from(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction$1(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(map$1(function (args) { return isArray$2(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable(function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(map$1(function (args) { return isArray$2(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable(function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!isFunction$1(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}

/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || identity;
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || isScheduler(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = identity;
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new Observable(function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(dispatch$3, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function dispatch$3(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}

/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = EMPTY;
    }
    if (falseResult === void 0) {
        falseResult = EMPTY;
    }
    return defer(function () { return condition() ? trueResult : falseResult; });
}

/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
function isNumeric(val) {
    return !isArray$2(val) && (val - parseFloat(val) + 1) >= 0;
}

/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */
function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = async;
    }
    if (!isNumeric(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = async;
    }
    return new Observable(function (subscriber) {
        subscriber.add(scheduler.schedule(dispatch$4, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function dispatch$4(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}

/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable) {
        return observables[0];
    }
    return mergeAll(concurrent)(fromArray(observables, scheduler));
}

/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */
var NEVER = /*@__PURE__*/ new Observable(noop);
function never() {
    return NEVER;
}

/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */
function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return EMPTY;
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && isArray$2(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new Observable(function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return from(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function pairs(obj, scheduler) {
    if (!scheduler) {
        return new Observable(function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new Observable(function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new Subscription();
            subscription.add(scheduler.schedule(dispatch$5, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function dispatch$5(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */
function partition(source, predicate, thisArg) {
    return [
        filter(predicate, thisArg)(new Observable(subscribeTo(source))),
        filter(not(predicate, thisArg))(new Observable(subscribeTo(source)))
    ];
}

/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (isArray$2(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return fromArray(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult(this, observable, undefined, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber));

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function range$1(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    return new Observable(function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(dispatch$6, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function dispatch$6(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}

/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (isNumeric(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (isScheduler(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!isScheduler(scheduler)) {
        scheduler = async;
    }
    return new Observable(function (subscriber) {
        var due = isNumeric(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch$7, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch$7(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}

/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
function using(resourceFactory, observableFactory) {
    return new Observable(function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? from(result) : EMPTY;
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}

/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return fromArray(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());
var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (isArray$2(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[iterator] === 'function') {
            iterators.push(new StaticIterator(value[iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(Subscriber));
var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    __extends$1(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[iterator] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function () {
        return innerSubscribe(this.observable, new SimpleInnerSubscriber(this));
    };
    return ZipBufferIterator;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */

var _esm5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Observable: Observable,
    ConnectableObservable: ConnectableObservable,
    GroupedObservable: GroupedObservable,
    observable: observable,
    Subject: Subject,
    BehaviorSubject: BehaviorSubject,
    ReplaySubject: ReplaySubject,
    AsyncSubject: AsyncSubject,
    asap: asap,
    asapScheduler: asapScheduler,
    async: async,
    asyncScheduler: asyncScheduler,
    queue: queue,
    queueScheduler: queueScheduler,
    animationFrame: animationFrame,
    animationFrameScheduler: animationFrameScheduler,
    VirtualTimeScheduler: VirtualTimeScheduler,
    VirtualAction: VirtualAction,
    Scheduler: Scheduler,
    Subscription: Subscription,
    Subscriber: Subscriber,
    Notification: Notification,
    get NotificationKind () { return NotificationKind; },
    pipe: pipe,
    noop: noop,
    identity: identity,
    isObservable: isObservable,
    ArgumentOutOfRangeError: ArgumentOutOfRangeError,
    EmptyError: EmptyError,
    ObjectUnsubscribedError: ObjectUnsubscribedError,
    UnsubscriptionError: UnsubscriptionError,
    TimeoutError: TimeoutError,
    bindCallback: bindCallback,
    bindNodeCallback: bindNodeCallback,
    combineLatest: combineLatest,
    concat: concat$1,
    defer: defer,
    empty: empty$1,
    forkJoin: forkJoin,
    from: from,
    fromEvent: fromEvent,
    fromEventPattern: fromEventPattern,
    generate: generate,
    iif: iif,
    interval: interval,
    merge: merge,
    never: never,
    of: of,
    onErrorResumeNext: onErrorResumeNext,
    pairs: pairs,
    partition: partition,
    race: race,
    range: range$1,
    throwError: throwError,
    timer: timer,
    using: using,
    zip: zip,
    scheduled: scheduled,
    EMPTY: EMPTY,
    NEVER: NEVER,
    config: config
});

var UserAgent = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouch = exports.isFirefox = exports.isSafari = exports.isEdge = exports.isChrome = exports.isPCDevice = exports.isMac = exports.isKindle = exports.isMobileDevice = exports.isIE = exports.isAndroid = exports.isIos = void 0;

exports.isIos = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /ipad|iphone|ipod/i.test(navigator.userAgent));
});
exports.isAndroid = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /android/i.test(navigator.userAgent));
});
exports.isIE = utils.makeSsrSafe(function () {
    return Boolean(/MSIE|Trident/i.test(window.navigator.userAgent));
});
exports.isMobileDevice = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent &&
        /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Silk/i.test(navigator.userAgent));
});
exports.isKindle = utils.makeSsrSafe(function () {
    return Boolean(/Silk/i.test(window.navigator.userAgent));
});
exports.isMac = utils.makeSsrSafe(function () {
    return Boolean(/Macintosh/i.test(window.navigator.userAgent));
});
exports.isPCDevice = utils.makeSsrSafe(function () {
    return Boolean(!exports.isAndroid() && !exports.isIos() && !exports.isKindle() && !exports.isMac());
});
exports.isChrome = utils.makeSsrSafe(function () {
    return Boolean(/Chrome/i.test(window.navigator.userAgent));
});
exports.isEdge = utils.makeSsrSafe(function () {
    return Boolean(/(?=.*AppleWebKit)(?=.*Safari)(?=.*Edg)/i.test(window.navigator.userAgent));
});
exports.isSafari = utils.makeSsrSafe(function () {
    return Boolean(exports.isMac && !exports.isMobileDevice && !exports.isChrome && /Safari/i.test(window.navigator.userAgent));
});
exports.isFirefox = utils.makeSsrSafe(function () {
    return Boolean(/Firefox/i.test(window.navigator.userAgent) &&
        "MozAppearance" in document.documentElement.style);
});
exports.isTouch = utils.makeSsrSafe(function () {
    return Boolean("ontouchstart" in document.documentElement);
});
});

var rxjs_1 = /*@__PURE__*/getAugmentedNamespace(_esm5);

var TabWatcher = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabWatcher = void 0;



/** The subject that will emit events when tabbing state changes */
var subject = new rxjs_1.Subject();
var isTabbing = false;
var initialized = false;
var checkFocusable = function (ele) {
    var eleArray = ["a", "button", "input", "select", "textarea", "label"];
    var eleTag = ele.nodeName.toLowerCase();
    if (eleArray.indexOf(eleTag) > -1) {
        return true;
    }
    else {
        if (ele.getAttribute("tabindex") !== null && ele.getAttribute("tabindex") !== "-1") {
            return true;
        }
        else {
            return false;
        }
    }
};
var maybeStartTabbing = function (event) {
    var key = event.which || event.keyCode || 0;
    var eleFocusable = checkFocusable(event.target);
    if ((!isTabbing && key === 9) || key === 13 || key === 32 || key === 37 || key === 38 || key === 39 || key === 40) {
        if (initialized && eleFocusable) {
            document.documentElement.classList.add("is-tabbing");
            document.documentElement.classList.remove("is-mouse");
        }
        isTabbing = true;
        subject.next(isTabbing);
    }
};
var mouseClick = function () {
    var eleFocusable = checkFocusable(document.activeElement);
    if (eleFocusable) {
        document.documentElement.classList.add("is-mouse");
        document.documentElement.classList.remove("is-tabbing");
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var stopTabbing = function () {
    if (isTabbing) {
        if (initialized) {
            document.documentElement.classList.remove("is-mouse");
            document.documentElement.classList.remove("is-tabbing");
        }
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var addDeviceClass = function () {
    if (UserAgent.isAndroid()) {
        document.documentElement.classList.add("isAndroid");
    }
    if (UserAgent.isIos()) {
        document.documentElement.classList.add("isIOS");
    }
    if (UserAgent.isIE()) {
        document.documentElement.classList.add("isIE");
    }
    if (UserAgent.isMobileDevice()) {
        document.documentElement.classList.add("isMobile");
    }
    if (UserAgent.isKindle()) {
        document.documentElement.classList.add("isKindle");
    }
    if (UserAgent.isMac()) {
        document.documentElement.classList.add("isMac");
    }
    if (UserAgent.isPCDevice()) {
        document.documentElement.classList.add("isPC");
    }
    if (UserAgent.isChrome()) {
        document.documentElement.classList.add("isChrome");
    }
    if (UserAgent.isEdge()) {
        document.documentElement.classList.add("isEdge");
    }
    if (UserAgent.isSafari()) {
        document.documentElement.classList.add("isSafari");
    }
    if (UserAgent.isFirefox()) {
        document.documentElement.classList.add("isFirefox");
    }
    if (UserAgent.isTouch()) {
        document.documentElement.classList.add("isTouch");
    }
    addOrientationClass();
};
var addOrientationClass = function () {
    if (window.innerWidth < window.innerHeight) {
        document.documentElement.classList.add("isPortrait");
        document.documentElement.classList.remove("isLandscape");
    }
    if (window.innerWidth > window.innerHeight) {
        document.documentElement.classList.remove("isPortrait");
        document.documentElement.classList.add("isLandscape");
    }
};
utils.ssrSafe(function () {
    addEventListener("keyup", maybeStartTabbing);
    addEventListener("click", mouseClick);
    addEventListener("touchstart", stopTabbing);
    addEventListener("resize", addOrientationClass);
    if (document.readyState === "complete") {
        addDeviceClass();
    }
    else {
        addEventListener("DOMContentLoaded", addDeviceClass);
    }
}, [typeof addEventListener === "function"]);
var observable = subject.asObservable();
/**
 * Subscribe to this to see whenever the user starts or stops tabbing.
 */
exports.TabWatcher = {
    /** Initialize the default action (adding `is-tabbing` class to body). */
    initialize: function () {
        initialized = true;
    },
    /** Whether we are currently using tab to navigate. */
    get isTabbing() {
        return isTabbing;
    },
    /** Subscribe to this observable. */
    subscribe: observable.subscribe.bind(observable),
    /** Pipe this observable with operators. */
    pipe: observable.pipe.bind(observable),
};
});

var baseCta = "BaseCta_base-cta__rJBl3";
var googlePlayLg = "BaseCta_google-play-lg__26W15";
var googlePlaySm = "BaseCta_google-play-sm__fgrG2";
var appleAppStoreLg = "BaseCta_apple-app-store-lg__iENHQ";
var appleAppStoreSm = "BaseCta_apple-app-store-sm__YNBA8";
var css_248z$5 = ".BaseCta_base-cta__rJBl3 {\n  background: none;\n  border: none; }\n  body.is-tabbing .BaseCta_base-cta__rJBl3:focus {\n    outline: 2px solid #0057b8; }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_google-play-sm__fgrG2 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_apple-app-store-lg__iENHQ, a.BaseCta_apple-app-store-sm__YNBA8 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_apple-app-store-lg__iENHQ {\n  height: 48px;\n  width: 162px; }\n\na.BaseCta_google-play-sm__fgrG2, a.BaseCta_apple-app-store-sm__YNBA8 {\n  height: 32px;\n  width: 108px; }\n";
var BaseCta = {"base-cta":"BaseCta_base-cta__rJBl3","google-play-lg":"BaseCta_google-play-lg__26W15","google-play-sm":"BaseCta_google-play-sm__fgrG2","apple-app-store-lg":"BaseCta_apple-app-store-lg__iENHQ","apple-app-store-sm":"BaseCta_apple-app-store-sm__YNBA8","baseCta":"BaseCta_base-cta__rJBl3","googlePlayLg":"BaseCta_google-play-lg__26W15","googlePlaySm":"BaseCta_google-play-sm__fgrG2","appleAppStoreLg":"BaseCta_apple-app-store-lg__iENHQ","appleAppStoreSm":"BaseCta_apple-app-store-sm__YNBA8"};
const stylesheet$1=".BaseCta_base-cta__rJBl3 {\n  background: none;\n  border: none; }\n  body.is-tabbing .BaseCta_base-cta__rJBl3:focus {\n    outline: 2px solid #0057b8; }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_google-play-sm__fgrG2 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_apple-app-store-lg__iENHQ, a.BaseCta_apple-app-store-sm__YNBA8 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_apple-app-store-lg__iENHQ {\n  height: 48px;\n  width: 162px; }\n\na.BaseCta_google-play-sm__fgrG2, a.BaseCta_apple-app-store-sm__YNBA8 {\n  height: 32px;\n  width: 108px; }\n";
styleInject(css_248z$5);

var BaseCta$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    baseCta: baseCta,
    googlePlayLg: googlePlayLg,
    googlePlaySm: googlePlaySm,
    appleAppStoreLg: appleAppStoreLg,
    appleAppStoreSm: appleAppStoreSm,
    'default': BaseCta,
    stylesheet: stylesheet$1
});

var BaseCtaProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = void 0;
var Classes;
(function (Classes) {
    Classes["onDark"] = "on-dark";
    Classes["disabled"] = "disabled";
})(Classes = exports.Classes || (exports.Classes = {}));
});

var styles$1 = /*@__PURE__*/getAugmentedNamespace(BaseCta$1);

var BaseCta$2 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakeCtaFromBase = exports.BaseCta = void 0;









TabWatcher.TabWatcher.initialize();
/** A CTA without any styling. */
exports.BaseCta = MakeCtaFromBase(function (props) { return ({ props: props, classes: styles$1.baseCta }); });
function MakeCtaFromBase(customizer) {
    if (customizer === void 0) { customizer = function (props) { return ({ props: props }); }; }
    return React__default.forwardRef(function (allProps, ref) {
        var _a = customizer(allProps), props = _a.props, classes = _a.classes, prepend = _a.prepend, append = _a.append;
        // Separate the properties that will be passed to the CTA directly. Parse the rest manually.
        var _b = Simplify.simplify(props), children = _b.children, _c = _b.onDark, onDark = _c === void 0 ? false : _c, appsDownload = _b.appsDownload, _d = _b.suppressLinkClick, suppressLinkClick = _d === void 0 ? false : _d, _e = _b.name, name = _e === void 0 ? typeof props.children === "string" ? props.children : undefined : _e, position = _b.position, url = _b.url, prefix = _b.urlPrefix, onClick = _b.onClick, className = _b.className, style = _b.style, _f = _b.openInNewWindow, openInNewWindow = _f === void 0 ? false : _f, _g = _b.link, link = _g === void 0 ? props.overrideLink ? true : !props.onClick && Boolean(props.url) : _g, _h = _b.overrideLink, overrideLink = _h === void 0 ? false : _h, _j = _b.disabled, disabled = _j === void 0 ? false : _j, deviceOptimization = _b.deviceOptimization, mediaType = _b.mediaType, download = _b.download, relationship = _b.relationship, autoFocus = _b.autoFocus, form = _b.form, _k = _b.buttonType, buttonType = _k === void 0 ? "button" : _k, formAction = _b.formAction, formEncType = _b.formEncType, formMethod = _b.formMethod, formNoValidate = _b.formNoValidate, testId = _b.testId, passthrough = __rest(_b, ["children", "onDark", "appsDownload", "suppressLinkClick", "name", "position", "url", "urlPrefix", "onClick", "className", "style", "openInNewWindow", "link", "overrideLink", "disabled", "deviceOptimization", "mediaType", "download", "relationship", "autoFocus", "form", "buttonType", "formAction", "formEncType", "formMethod", "formNoValidate", "testId"]);
        var combinedOnClick = function (event) {
            if (!suppressLinkClick && name && Reporting.ReportingHelper.initialized) {
                Reporting.ReportingHelper.linkClick({
                    name: name,
                    position: position,
                    url: url,
                    prefix: prefix,
                });
            }
            if (onClick) {
                onClick(event);
            }
        };
        var handleKeyPress = function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                if (onClick) {
                    combinedOnClick(event);
                }
            }
        };
        var otherProps = link
            ? {
                href: (overrideLink && url) || (!overrideLink && !disabled) ? url : undefined,
                target: openInNewWindow ? "_blank" : undefined,
                rel: relationship,
                media: deviceOptimization,
                type: mediaType,
                download: download,
            }
            : {
                autoFocus: autoFocus,
                type: buttonType,
                form: form,
                formAction: formAction,
                formEncType: formEncType,
                formMethod: formMethod,
                formNoValidate: formNoValidate,
                formTarget: openInNewWindow ? "_blank" : undefined,
            };
        var lnkRole = props.role ? { role: props.role } : { role: "button" };
        var eleRole = link ? (overrideLink && onClick ? lnkRole : "") : "";
        var Element = link ? "a" : "button";
        var myRef = React__default.useRef(null);
        React__default.useEffect(function () {
            if (link && autoFocus && myRef.current) {
                Focus.focus(myRef.current);
            }
        }, [autoFocus, link]);
        return (React__default.createElement(Element, __assign({ className: Join.join(onDark && BaseCtaProps.Classes.onDark, link && disabled && BaseCtaProps.Classes.disabled, className, classes, appsDownload === "google-lg" ? "" + styles$1.googlePlayLg : "", appsDownload === "apple-lg" ? "" + styles$1.appleAppStoreLg : "", appsDownload === "google-sm" ? "" + styles$1.googlePlaySm : "", appsDownload === "apple-sm" ? "" + styles$1.appleAppStoreSm : ""), "data-testid": testId, disabled: (!link && disabled) || undefined, onClick: combinedOnClick, style: style, ref: Refs.refs(myRef, ref) }, { tabIndex: overrideLink ? 0 : undefined }, {
            onKeyDown: link
                ? overrideLink && onClick
                    ? handleKeyPress
                    : undefined
                : undefined,
        }, passthrough, eleRole, otherProps),
            prepend,
            link && (prepend !== "" || append !== "") ? React__default.createElement("span", null, children) : children,
            overrideLink && openInNewWindow && (React__default.createElement("span", { className: "hidden-spoken" }, " (opens in a new window)")),
            append));
    });
}
exports.MakeCtaFromBase = MakeCtaFromBase;
});

var BaseCta$3 = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(BaseCta$2, exports);
__exportStar(BaseCtaProps, exports);
var BaseCta_1 = BaseCta$2;
exports.default = BaseCta_1.BaseCta;
});

var css_248z$6 = ".link-icon-left,\n.link-icon-right {\n  display: inline-flex;\n  align-items: center; }\n\n.link-icon-left span,\n.link-icon-right span {\n  border-bottom: 1px solid transparent; }\n\n.link-icon-left svg,\n.link-icon-right svg {\n  flex-shrink: 0; }\n\n.link-icon-left:hover,\n.link-icon-right:hover {\n  color: #0057b8;\n  text-decoration: none; }\n\n.link-icon-left:hover span,\n.link-icon-right:hover span {\n  border-bottom: 1px solid #0057b8; }\n\n.link-icon-left.type-base svg,\n.link-icon-right.type-base svg {\n  width: 20px;\n  height: 20px; }\n\n.link-icon-left.type-sm svg,\n.link-icon-right.type-sm svg {\n  width: 16px;\n  height: 16px; }\n\n.link-icon-left.type-xs svg,\n.link-icon-right.type-xs svg {\n  width: 16px;\n  height: 16px; }\n\n.link-icon-left.type-base svg {\n  margin-right: 6px; }\n\n.link-icon-right.type-base svg {\n  margin-left: 6px; }\n\n.link-icon-left.type-sm svg,\n.link-icon-left.type-xs svg {\n  margin-right: 5px; }\n\n.link-icon-right.type-sm svg,\n.link-icon-right.type-xs svg {\n  margin-left: 5px; }\n\n.link-icon-left.color-ui-white:hover,\n.link-icon-right.color-ui-white:hover {\n  color: #ffffff; }\n\n.link-icon-left.color-ui-white:hover span,\n.link-icon-right.color-ui-white:hover span {\n  border-color: #ffffff; }\n\n.row-reverse {\n  flex-direction: row-reverse; }\n\n.link-tertiary-large.row-reverse:after {\n  margin: 0 16px 1px 0; }\n\n.link-tertiary-small.row-reverse:after {\n  margin: 0 8px 0 0;\n  min-width: 21px; }\n\n.rotate180-after:after {\n  transform: rotate(180deg); }\n\n.link-utility-primary,\n.link-utility-secondary {\n  align-items: center;\n  display: inline-flex;\n  text-decoration: underline; }\n\n.link-utility-primary.solo,\n.link-utility-secondary.solo {\n  font-family: font-medium, sans-serif;\n  font-size: 1.5rem;\n  text-decoration: none; }\n\n.link-text,\n.link-text3 {\n  text-decoration: underline; }\n\n.link-text3.solo:not(.on-dark) {\n  text-decoration: none; }\n\n.link-text3.solo:not(.on-dark):hover {\n  text-decoration: underline; }\n\n.link-utility-primary:not(.solo):hover,\n.link-utility-secondary:not(.solo):hover {\n  text-decoration: underline; }\n";
styleInject(css_248z$6);

var LinkProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kind = void 0;
var Kind;
(function (Kind) {
    /** A link that is blue on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilityPrimary"] = "link-utility-primary";
    /** A link that is dark gray on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilitySecondary"] = "link-utility-secondary";
    /** A small link with a rightward arrow. */
    Kind["tertiarySmall"] = "link-tertiary-small";
    /** A large link with a rightward arrow. */
    Kind["tertiaryLarge"] = "link-tertiary-large";
    /** A text link with an underline. */
    Kind["textUnderline"] = "link-text";
    /** A text link with medium font. */
    Kind["textMedium"] = "link-text2";
    /** A text link without any distinguishing features. Use this very sparingly. As in almost never. */
    Kind["textPlain"] = "link-text3";
    /** A link with Icon prepended before text. */
    Kind["withPrependIcon"] = "link-icon-left";
    /** A link with Icon appended after text. */
    Kind["withAppendIcon"] = "link-icon-right";
    /** A link no default classes */
    Kind["none"] = "";
})(Kind = exports.Kind || (exports.Kind = {}));
});

var Link_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });




/**
 * A CTA that looks like a link. Will use `<a>` or `<button>` under the hood depending on the functionality needed.
 */
var Link = BaseCta$3.MakeCtaFromBase(function (allProps) {
    var _a = Simplify.simplify(allProps), _b = _a.kind, kind = _b === void 0 ? "utilityPrimary" : _b, icon = _a.icon, props = __rest(_a, ["kind", "icon"]);
    return {
        prepend: kind === "withPrependIcon" ? icon : "",
        append: kind === "withAppendIcon" ? icon : "",
        classes: [
            LinkProps.Kind[kind],
            kind === "withPrependIcon" || kind === "withAppendIcon"
                ? allProps.onDark
                    ? "line-h-md color-ui-white font-medium"
                    : "line-h-md color-cobalt font-medium"
                : "",
        ],
        props: __assign(__assign({}, props), { className: allProps.className, overrideLink: true, role: allProps.role ? allProps.role : undefined }),
    };
});
exports.default = Link;
});

var Link = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Link_1.default;
});

var Link$1 = /*@__PURE__*/getDefaultExportFromCjs(Link);

var Header = function (_a) {
    var heading = _a.heading, subHeading = _a.subHeading, deviceName = _a.deviceName, currentPage = _a.currentPage, numberOfPages = _a.numberOfPages, backButtonContent = _a.backButtonContent, onBackButtonClick = _a.onBackButtonClick, backButtonVisible = _a.backButtonVisible;
    return (React__default.createElement(React__default.Fragment, null,
        backButtonVisible && (React__default.createElement("div", { className: topBar },
            React__default.createElement(Link$1, { kind: "tertiarySmall", buttonType: "button", className: "" + backButton, onClick: onBackButtonClick }, backButtonContent))),
        React__default.createElement("div", { style: { width: '100%' } },
            React__default.createElement(ProgressIndicator$3, { currentPageNum: currentPage, numPages: numberOfPages, title: heading })),
        subHeading && (React__default.createElement("div", { className: subHeader, dangerouslySetInnerHTML: {
                __html: purify.sanitize(subHeading ? subHeading.replace('[[device name]]', deviceName) : ''),
            } }))));
};

var radioButtonGroup$1 = "MakeSelector-module_radio-button-group__4jyN7";
var header$1 = "MakeSelector-module_header__dP2GM";
var buttonGroup$1 = "MakeSelector-module_button-group__pgXKu";
var buttonMargin = "MakeSelector-module_buttonMargin__nT6RZ";
var css_248z$7 = ".MakeSelector-module_radio-button-group__4jyN7 {\n  margin-bottom: 24px; }\n  .MakeSelector-module_radio-button-group__4jyN7 ul {\n    list-style-type: disc; }\n  .MakeSelector-module_radio-button-group__4jyN7 input[type=\"radio\"] {\n    opacity: 0;\n    position: absolute; }\n    .MakeSelector-module_radio-button-group__4jyN7 input[type=\"radio\"]:checked + label {\n      border: 2px solid #0057B8; }\n    .MakeSelector-module_radio-button-group__4jyN7 input[type=\"radio\"]:focus-visible + label {\n      outline: 1px dotted #0057B8;\n      outline-offset: 5px; }\n  .MakeSelector-module_radio-button-group__4jyN7 img {\n    height: 24px; }\n\n.MakeSelector-module_header__dP2GM b, .MakeSelector-module_header__dP2GM strong {\n  font-weight: bold; }\n\n.MakeSelector-module_button-group__pgXKu {\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: row; }\n\n.MakeSelector-module_buttonMargin__nT6RZ:not(:last-child) {\n  margin-right: -16px; }\n";
styleInject(css_248z$7);

var Debounce = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;

/**
 * Debounce the passed function. This means that the function will only fire once while
 * it is being called within the threshold.
 * @param fn The function to be debounced
 * @param threshold How long to wait before allowing the function to be triggered again. Default is `100`.
 * @param immediate Whether to trigger the function at the start instead of after the threshold. Default is `false`.
 * @return A version of this function that will only trigger when it isn't called for the threshold amount of time.
 */
// tslint:disable-next-line: no-any
exports.debounce = utils.makeSsrSafe(function (fn, threshold, immediate) {
    if (threshold === void 0) { threshold = 100; }
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var call = function () {
            timeout = undefined;
            if (!immediate) {
                return fn.apply(_this, args);
            }
        };
        if (immediate && !timeout) {
            call();
        }
        clearTimeout(timeout);
        timeout = window.setTimeout(call, threshold);
    };
});
});

var keyPress = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigitChar = exports.isSpecialChar = exports.isLetterChar = exports.KeyPress = exports.KeyCode = void 0;
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["ALT"] = 18] = "ALT";
    KeyCode[KeyCode["UPARROW"] = 38] = "UPARROW";
    KeyCode[KeyCode["DOWNARROW"] = 40] = "DOWNARROW";
    KeyCode[KeyCode["LEFTARROW"] = 37] = "LEFTARROW";
    KeyCode[KeyCode["RIGHTARROW"] = 39] = "RIGHTARROW";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["ESC"] = 27] = "ESC";
    KeyCode[KeyCode["FORWARDSLASH"] = 191] = "FORWARDSLASH";
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["PAGEUP"] = 33] = "PAGEUP";
    KeyCode[KeyCode["PAGEDOWN"] = 34] = "PAGEDOWN";
    KeyCode[KeyCode["ATRATE"] = 50] = "ATRATE";
    KeyCode[KeyCode["HASH"] = 51] = "HASH";
    KeyCode[KeyCode["DOLLAR"] = 52] = "DOLLAR";
    KeyCode[KeyCode["SHIFT"] = 16] = "SHIFT";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));
var specialChars = new Map();
specialChars.set(192, "`");
specialChars.set(189, "-");
specialChars.set(187, "=");
specialChars.set(219, "[");
specialChars.set(221, "]");
specialChars.set(220, "\\");
specialChars.set(186, ";");
specialChars.set(222, "'");
specialChars.set(223, ",");
specialChars.set(190, ".");
specialChars.set(191, "/");
specialChars.set(-192, "~");
specialChars.set(-49, "!");
specialChars.set(-50, "@");
specialChars.set(-51, "#");
specialChars.set(-52, "$");
specialChars.set(-53, "%");
specialChars.set(-54, "^");
specialChars.set(-55, "&");
specialChars.set(-56, "*");
specialChars.set(-57, "(");
specialChars.set(-48, ")");
specialChars.set(-189, "_");
specialChars.set(-187, "+");
specialChars.set(-219, "{");
specialChars.set(-221, "}");
specialChars.set(-220, "|");
specialChars.set(-186, ":");
specialChars.set(-222, '"');
specialChars.set(-188, "<");
specialChars.set(-190, ">");
specialChars.set(-191, "?");
var KeyPress = /** @class */ (function () {
    function KeyPress() {
    }
    KeyPress.shiftIsPressed = function (e) { return e.keyCode === KeyCode.SHIFT; };
    KeyPress.altIsPressed = function (e) { return e.keyCode === KeyCode.ALT; };
    KeyPress.enterIsPressed = function (e) { return e.keyCode === KeyCode.ENTER; };
    KeyPress.upArrowIsPressed = function (e) { return e.keyCode === KeyCode.UPARROW; };
    KeyPress.downArrowIsPressed = function (e) { return e.keyCode === KeyCode.DOWNARROW; };
    KeyPress.leftArrowIsPressed = function (e) { return e.keyCode === KeyCode.LEFTARROW; };
    KeyPress.rightArrowIsPressed = function (e) { return e.keyCode === KeyCode.RIGHTARROW; };
    KeyPress.tabIsPressed = function (e) { return e.keyCode === KeyCode.TAB; };
    KeyPress.escIsPressed = function (e) { return e.keyCode === KeyCode.ESC; };
    KeyPress.forwardSlashIsPressed = function (e) { return e.keyCode === KeyCode.FORWARDSLASH; };
    KeyPress.backspaceIsPressed = function (e) { return e.keyCode === KeyCode.BACKSPACE; };
    KeyPress.deleteIsPressed = function (e) { return e.keyCode === KeyCode.DELETE; };
    KeyPress.homeIsPressed = function (e) { return e.keyCode === KeyCode.HOME; };
    KeyPress.endIsPressed = function (e) { return e.keyCode === KeyCode.END; };
    KeyPress.pageUpIsPressed = function (e) { return e.keyCode === KeyCode.PAGEUP; };
    KeyPress.pageDownIsPressed = function (e) { return e.keyCode === KeyCode.PAGEDOWN; };
    KeyPress.attherateIsPressed = function (e) { return e.keyCode === KeyCode.ATRATE; };
    KeyPress.hashIsPressed = function (e) { return e.keyCode === KeyCode.HASH; };
    KeyPress.dollarIsPressed = function (e) { return e.keyCode === KeyCode.DOLLAR; };
    KeyPress.spaceIsPressed = function (e) { return e.keyCode === KeyCode.SPACE; };
    return KeyPress;
}());
exports.KeyPress = KeyPress;
exports.isLetterChar = function (e) {
    if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)) {
        return String.fromCharCode(e.keyCode);
    }
    else {
        return undefined;
    }
};
exports.isSpecialChar = function (e, altPressed) {
    if (altPressed && specialChars.has(e.keyCode * -1)) {
        return specialChars.get(e.keyCode * -1);
    }
    else if (specialChars.has(e.keyCode)) {
        return specialChars.get(e.keyCode);
    }
    else {
        return undefined;
    }
};
exports.isDigitChar = function (e) {
    if (e.keyCode >= 48 && e.keyCode <= 57) {
        return String.fromCharCode(e.keyCode);
    }
    else {
        return undefined;
    }
};
});

var css_248z$8 = "[class=\"svg-base\"] {\n  fill: currentColor !important; }\n\n:not([class*=\"color-\"]) [class=\"svg-accent\"] {\n  fill: currentColor; }\n\n[class*=\"svg-accent-att-blue\"] [class=\"svg-accent\"] {\n  fill: #009fdb; }\n";
styleInject(css_248z$8);

var IconSvg_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });


var IconSvg = /** @class */ (function (_super) {
    __extends(IconSvg, _super);
    function IconSvg(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var svgUrl = _this.props.svgUrl;
            if (svgUrl) {
                _this.getIconFromUrl();
            }
        };
        _this.getIconFromUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var svgUrl, response, svgMarkUp, svgContent, viewBoxVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        svgUrl = this.props.svgUrl;
                        return [4 /*yield*/, fetch(svgUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        svgMarkUp = _a.sent();
                        svgContent = this.getIconContent(svgMarkUp);
                        viewBoxVal = this.getViewBoxVal(svgMarkUp);
                        this.setState({ svgContent: svgContent, viewBoxVal: viewBoxVal });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderIconFromStr = function () {
            var svgNodeStr = _this.props.svgNodeStr;
            if (svgNodeStr) {
                var svgContent = _this.getIconContent(svgNodeStr);
                var viewBoxVal = _this.getViewBoxVal(svgNodeStr);
                return _this.renderSvg(svgContent, viewBoxVal);
            }
            return null;
        };
        _this.getIconContent = function (svgNode) {
            var trimmedStr = svgNode.trim();
            var index = trimmedStr.indexOf("><");
            var returnStr = trimmedStr.substring(index + 1, trimmedStr.length - 6);
            return returnStr;
        };
        _this.getViewBoxVal = function (svgFromSource) {
            var splitA = svgFromSource.split('viewBox="');
            var splitB = splitA[1].split('"');
            var viewBoxVal = splitB[0];
            return viewBoxVal;
        };
        _this.renderSvg = function (svgContent, viewBoxVal) {
            var _a = _this.props, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, className = _a.className, colorClass = _a.colorClass, pictogramAccent = _a.pictogramAccent, pictogramDarkBg = _a.pictogramDarkBg, size = _a.size;
            var iconClass = colorClass;
            if (pictogramAccent) {
                iconClass = "svg-accent-att-blue " + (pictogramDarkBg ? "color-ui-white" : "color-black");
            }
            return (React__default.createElement("svg", { "aria-hidden": ariaHidden !== false, "aria-label": ariaHidden !== false ? undefined : ariaLabel, className: "inline-block " + iconClass + (className ? " " + className : ""), focusable: !(ariaHidden !== false), role: ariaHidden !== false ? undefined : "img", height: size ? size + "px" : undefined, width: size ? size + "px" : undefined, viewBox: viewBoxVal, dangerouslySetInnerHTML: {
                    __html: svgContent,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, svgNodeStr = _a.svgNodeStr, svgUrl = _a.svgUrl;
            if (svgUrl) {
                var _b = _this.state, svgContent = _b.svgContent, viewBoxVal = _b.viewBoxVal;
                if (svgContent && viewBoxVal) {
                    return _this.renderSvg(svgContent, viewBoxVal);
                }
            }
            else if (svgNodeStr && svgNodeStr.trim().substring(1, 4) === "svg") {
                return _this.renderIconFromStr();
            }
            return null;
        };
        _this.state = {
            svgContent: null,
            viewBoxVal: null,
        };
        return _this;
    }
    return IconSvg;
}(React__default.PureComponent));
exports.default = IconSvg;
});

var IconSvg = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = IconSvg_1.default;
});

var IconSVG = /*@__PURE__*/getDefaultExportFromCjs(IconSvg);

var menuItem = "MultiSelectInputList_menu-item__GonjJ";
var activeItem = "MultiSelectInputList_active-item__U56a3";
var menuItemSelected = "MultiSelectInputList_menu-item-selected__LsAyS";
var groupTitle = "MultiSelectInputList_group-title__spW5r";
var checkMark = "MultiSelectInputList_check-mark__lyShk";
var comboHoverColor = "MultiSelectInputList_combo-hover-color__dlbk4";
var comboFocusColor = "MultiSelectInputList_combo-focus-color__LbDgU";
var comboListHeight = "MultiSelectInputList_combo-list-height__BG13W";
var comboLi = "MultiSelectInputList_combo-li__wJ4za";
var css_248z$9 = ".MultiSelectInputList_menu-item__GonjJ {\n  cursor: pointer;\n  padding: 10px 16px 10px 24px;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: wrap;\n  background-color: #ffffff; }\n  .MultiSelectInputList_menu-item__GonjJ .MultiSelectInputList_active-item__U56a3 {\n    font-size: 14px; }\n  .MultiSelectInputList_menu-item__GonjJ:hover {\n    background-color: #f7f8f9 !important; }\n  .MultiSelectInputList_menu-item__GonjJ:focus {\n    background-color: #f2f2f2 !important; }\n  .MultiSelectInputList_menu-item__GonjJ.MultiSelectInputList_menu-item-selected__LsAyS {\n    font: inherit;\n    background-color: #f2f2f2;\n    border: 1px solid #ffff; }\n  @media (max-width: 767px) {\n    .MultiSelectInputList_menu-item__GonjJ {\n      white-space: initial;\n      text-align: justify;\n      word-break: break-word;\n      text-justify: inter-word;\n      display: inline-block;\n      width: 100%; } }\n\n.MultiSelectInputList_group-title__spW5r {\n  padding-top: 10px !important; }\n\n.MultiSelectInputList_check-mark__lyShk {\n  width: 30px;\n  margin-left: auto;\n  margin-top: auto;\n  margin-bottom: auto; }\n\n@media (max-width: 766px) {\n  .MultiSelectInputList_check-mark__lyShk {\n    width: 70px; } }\n\n.MultiSelectInputList_combo-hover-color__dlbk4:hover {\n  color: #0057B8 !important;\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-focus-color__LbDgU:focus {\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-list-height__BG13W {\n  font-size: 1.4rem !important; }\n\n.MultiSelectInputList_combo-li__wJ4za {\n  padding: 12px 16px 12px !important;\n  line-height: 16.8px !important; }\n";
var MultiSelectInputList = {"menu-item":"MultiSelectInputList_menu-item__GonjJ","active-item":"MultiSelectInputList_active-item__U56a3","menu-item-selected":"MultiSelectInputList_menu-item-selected__LsAyS","group-title":"MultiSelectInputList_group-title__spW5r","check-mark":"MultiSelectInputList_check-mark__lyShk","combo-hover-color":"MultiSelectInputList_combo-hover-color__dlbk4","combo-focus-color":"MultiSelectInputList_combo-focus-color__LbDgU","combo-list-height":"MultiSelectInputList_combo-list-height__BG13W","combo-li":"MultiSelectInputList_combo-li__wJ4za","menuItem":"MultiSelectInputList_menu-item__GonjJ","activeItem":"MultiSelectInputList_active-item__U56a3","menuItemSelected":"MultiSelectInputList_menu-item-selected__LsAyS","groupTitle":"MultiSelectInputList_group-title__spW5r","checkMark":"MultiSelectInputList_check-mark__lyShk","comboHoverColor":"MultiSelectInputList_combo-hover-color__dlbk4","comboFocusColor":"MultiSelectInputList_combo-focus-color__LbDgU","comboListHeight":"MultiSelectInputList_combo-list-height__BG13W","comboLi":"MultiSelectInputList_combo-li__wJ4za"};
const stylesheet$2=".MultiSelectInputList_menu-item__GonjJ {\n  cursor: pointer;\n  padding: 10px 16px 10px 24px;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: wrap;\n  background-color: #ffffff; }\n  .MultiSelectInputList_menu-item__GonjJ .MultiSelectInputList_active-item__U56a3 {\n    font-size: 14px; }\n  .MultiSelectInputList_menu-item__GonjJ:hover {\n    background-color: #f7f8f9 !important; }\n  .MultiSelectInputList_menu-item__GonjJ:focus {\n    background-color: #f2f2f2 !important; }\n  .MultiSelectInputList_menu-item__GonjJ.MultiSelectInputList_menu-item-selected__LsAyS {\n    font: inherit;\n    background-color: #f2f2f2;\n    border: 1px solid #ffff; }\n  @media (max-width: 767px) {\n    .MultiSelectInputList_menu-item__GonjJ {\n      white-space: initial;\n      text-align: justify;\n      word-break: break-word;\n      text-justify: inter-word;\n      display: inline-block;\n      width: 100%; } }\n\n.MultiSelectInputList_group-title__spW5r {\n  padding-top: 10px !important; }\n\n.MultiSelectInputList_check-mark__lyShk {\n  width: 30px;\n  margin-left: auto;\n  margin-top: auto;\n  margin-bottom: auto; }\n\n@media (max-width: 766px) {\n  .MultiSelectInputList_check-mark__lyShk {\n    width: 70px; } }\n\n.MultiSelectInputList_combo-hover-color__dlbk4:hover {\n  color: #0057B8 !important;\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-focus-color__LbDgU:focus {\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-list-height__BG13W {\n  font-size: 1.4rem !important; }\n\n.MultiSelectInputList_combo-li__wJ4za {\n  padding: 12px 16px 12px !important;\n  line-height: 16.8px !important; }\n";
styleInject(css_248z$9);

var MultiSelectInputList$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    menuItem: menuItem,
    activeItem: activeItem,
    menuItemSelected: menuItemSelected,
    groupTitle: groupTitle,
    checkMark: checkMark,
    comboHoverColor: comboHoverColor,
    comboFocusColor: comboFocusColor,
    comboListHeight: comboListHeight,
    comboLi: comboLi,
    'default': MultiSelectInputList,
    stylesheet: stylesheet$2
});

var optionStyles = /*@__PURE__*/getAugmentedNamespace(MultiSelectInputList$1);

var MultiSelectInputList_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });




var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var MultiSelectInputList = /** @class */ (function (_super) {
    __extends(MultiSelectInputList, _super);
    function MultiSelectInputList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            if (_this.props.onSelect) {
                _this.props.onSelect(_this.props.data.choice, false);
            }
        };
        _this.handleKeyDown = function (e) {
            if (enterIsPressed(e)) {
                var elem = e.target;
                elem.parentElement.parentElement.parentElement.children[0].focus();
                if (_this.props.onSelect) {
                    _this.props.onSelect(_this.props.data.choice, true);
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            else if (_this.props.handelKeyDown) {
                _this.props.handelKeyDown(e);
            }
        };
        _this.setLiRef = function (element) {
            _this.liRef = element;
        };
        return _this;
    }
    MultiSelectInputList.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props.data, choice = _h.choice, isSelected = _h.isSelected, textData = _h.textData;
        var isHoverClass = '';
        var isHoverFocusClass = '';
        var isListHeightClass = 'type-sm';
        var isComboLi = '';
        var isComboboxBg = false;
        if (this.props.options && ((_a = this.props.options) === null || _a === void 0 ? void 0 : _a.isCombobox)) {
            isHoverClass = ((_b = this.props.options.isCombobox) === null || _b === void 0 ? void 0 : _b.isHoverColor) ? optionStyles.comboHoverColor : '';
            isHoverFocusClass = ((_c = this.props.options.isCombobox) === null || _c === void 0 ? void 0 : _c.isHoverFocusColor) ? optionStyles.comboFocusColor : '';
            isComboboxBg = ((_d = this.props.options.isCombobox) === null || _d === void 0 ? void 0 : _d.isAddBgColor) === true ? true : false;
            isListHeightClass = optionStyles.comboListHeight;
            isComboLi = optionStyles.comboLi;
        }
        var classes = isSelected
            ? [optionStyles.menuItem, optionStyles.menuItemSelected, !isComboboxBg ? " color-ui-dark-gray flex color-cobalt" : " color-ui-dark-gray", isHoverClass, isHoverFocusClass, isComboLi].join(" ")
            : [optionStyles.menuItem, !isComboLi ? " overflow-hidden" : "", isHoverClass, isHoverFocusClass, isComboLi].join(" ");
        var text = choice.displayText
            ? choice.displayText
            : choice.value
                ? choice.value.toString()
                : "No Suggestion";
        var searchLen = ((_g = (_f = (_e = this.props) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.textData) === null || _g === void 0 ? void 0 : _g.length) || 0;
        var subStrIndex = this.props.data && this.props.data.textData
            ? text.toUpperCase().indexOf(this.props.data.textData.toUpperCase())
            : 0;
        /*
        if (textData && subStrIndex !== textData.length) {
            subStrIndex = 0;
        }*/
        var primary1stText = text.substring(0, subStrIndex);
        var primary2ndText = text.substring(subStrIndex, subStrIndex + searchLen);
        var primary3rdText = text.substring(subStrIndex + searchLen, text.length);
        var optionText = React__default.createElement("span", null, text);
        if (this.props.options && this.props.options.heighlightTextData) {
            optionText = (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("span", { "aria-hidden": "true", className: "" + isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary1stText
                            ? primary1stText.split(" ").join("&nbsp;")
                            : primary1stText,
                    } }),
                React__default.createElement("span", { "aria-hidden": "true", className: !isComboboxBg ? " font-bold " + isListHeightClass : isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary2ndText
                            ? primary2ndText.split(" ").join("&nbsp;")
                            : primary2ndText,
                    } }),
                React__default.createElement("span", { "aria-hidden": "true", className: "" + isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary3rdText
                            ? primary3rdText.replace(" ", "&nbsp;")
                            : primary3rdText,
                    } })));
        }
        return (React__default.createElement("li", { id: text, "data-test-id": this.props.testId, className: classes, role: "menuitem", title: isSelected ? text + "( is selected)" : text, tabIndex: isHoverFocusClass ? -1 : 0, onClick: this.handleClick, "aria-selected": isSelected, ref: this.setLiRef, onKeyDown: this.handleKeyDown },
            React__default.createElement("div", null, optionText),
            isSelected && !isComboboxBg ? (React__default.createElement("span", { "aria-hidden": "true", className: optionStyles.checkMark + " text-right flex flex-items-center justify-center " },
                React__default.createElement(IconSvg.default, { size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.33 26.75l-10-10 1.42-1.42 8.62 8.63 18-18 1.42 1.41z\"/></svg>" }))) : ("")));
    };
    return MultiSelectInputList;
}(React__default.Component));
exports.default = MultiSelectInputList;
});

var MultiSelectInputList$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = MultiSelectInputList_1.default;
});

var dropdown = "ComboBox_dropdown__W9nLG";
var divPosition = "ComboBox_div-position__tHucA";
var closePosition = "ComboBox_close-position__r5l-s";
var resultNotFound = "ComboBox_result-not-found__e9ewg";
var showAllResult = "ComboBox_show-all-result__HAqMt";
var css_248z$a = ".ComboBox_dropdown__W9nLG {\n  top: 74px;\n  z-index: 1;\n  border-radius: 0 0 0.3rem 0.3rem; }\n\n.ComboBox_div-position__tHucA {\n  position: relative; }\n\n.ComboBox_close-position__r5l-s {\n  top: 37px; }\n\n.ComboBox_result-not-found__e9ewg {\n  cursor: default !important;\n  padding-top: 12px !important;\n  padding-bottom: 12px;\n  line-height: 18.8px;\n  padding-left: 16px;\n  background-color: #ffffff;\n  font-size: 1.4rem; }\n  .ComboBox_result-not-found__e9ewg:hover {\n    background-color: #ffffff !important; }\n  .ComboBox_result-not-found__e9ewg:focus {\n    background-color: #ffffff !important; }\n\n.ComboBox_show-all-result__HAqMt {\n  max-height: 128px !important;\n  overflow: auto !important; }\n";
var ComboBox = {"dropdown":"ComboBox_dropdown__W9nLG","div-position":"ComboBox_div-position__tHucA","close-position":"ComboBox_close-position__r5l-s","result-not-found":"ComboBox_result-not-found__e9ewg","show-all-result":"ComboBox_show-all-result__HAqMt","divPosition":"ComboBox_div-position__tHucA","closePosition":"ComboBox_close-position__r5l-s","resultNotFound":"ComboBox_result-not-found__e9ewg","showAllResult":"ComboBox_show-all-result__HAqMt"};
const stylesheet$3=".ComboBox_dropdown__W9nLG {\n  top: 74px;\n  z-index: 1;\n  border-radius: 0 0 0.3rem 0.3rem; }\n\n.ComboBox_div-position__tHucA {\n  position: relative; }\n\n.ComboBox_close-position__r5l-s {\n  top: 37px; }\n\n.ComboBox_result-not-found__e9ewg {\n  cursor: default !important;\n  padding-top: 12px !important;\n  padding-bottom: 12px;\n  line-height: 18.8px;\n  padding-left: 16px;\n  background-color: #ffffff;\n  font-size: 1.4rem; }\n  .ComboBox_result-not-found__e9ewg:hover {\n    background-color: #ffffff !important; }\n  .ComboBox_result-not-found__e9ewg:focus {\n    background-color: #ffffff !important; }\n\n.ComboBox_show-all-result__HAqMt {\n  max-height: 128px !important;\n  overflow: auto !important; }\n";
styleInject(css_248z$a);

var ComboBox$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    dropdown: dropdown,
    divPosition: divPosition,
    closePosition: closePosition,
    resultNotFound: resultNotFound,
    showAllResult: showAllResult,
    'default': ComboBox,
    stylesheet: stylesheet$3
});

var styles$2 = /*@__PURE__*/getAugmentedNamespace(ComboBox$1);

var ComboBox_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });








var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var upArrowIsPressed = keyPress.KeyPress.upArrowIsPressed;
var downArrowIsPressed = keyPress.KeyPress.downArrowIsPressed;
var escIsPressed = keyPress.KeyPress.escIsPressed;
var tabIsPressed = keyPress.KeyPress.tabIsPressed;
var ComboBox = /** @class */ (function (_super) {
    __extends(ComboBox, _super);
    function ComboBox(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.debouncedLog = Debounce.debounce(function (text) {
            _this.filterAndSetData(text, "change");
        }, 300);
        _this.onChange = function (e) {
            var events = _this.props.events;
            var currentValue = e.target.value;
            if (currentValue) {
                _this.setState({ currentText: currentValue, errorText: "", isClickBack: false });
                _this.debouncedLog(currentValue);
            }
            else {
                if (_this.state.isLoadInitialResult) {
                    _this.setState({
                        isOpen: true,
                        currentText: currentValue,
                        errorText: "",
                        isClickBack: false,
                    });
                    _this.filterAndSetData("", "focus");
                }
                else {
                    _this.setState({ isOpen: false, currentText: currentValue, errorText: "" });
                }
            }
            if (events && events.onChange) {
                events.onChange(e);
            }
        };
        _this.filterAndSetData = function (txtValue, from) {
            var filteredData = _this.props.data.choices;
            if (txtValue) {
                filteredData = _this.props.data.choices.filter(function (choice) {
                    var searchText = txtValue.toUpperCase();
                    var displayText = choice.displayText.toUpperCase();
                    return displayText.includes(searchText);
                });
                // tslint:disable-next-line:no-console
                var noSuggestionText = filteredData.length === 0 && txtValue ? true : false;
                _this.setState({ isOpen: true, showClose: true, filteredData: filteredData, noSuggestionText: noSuggestionText });
            }
            else {
                if (from === "focus") {
                    filteredData = _this.props.data.choices.filter(function (choice) {
                        var displayText = choice.displayText.toUpperCase();
                        return displayText;
                    });
                    _this.setState({
                        isOpen: true,
                        showClose: true,
                        filteredData: filteredData,
                        noSuggestionText: true,
                    });
                }
                else {
                    _this.setState({ filteredData: [], noSuggestionText: false });
                }
            }
        };
        _this.handleInputKeyDown = function (e) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (e.shiftKey && e.keyCode === 9) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            if (tabIsPressed(e) && currentText.length === 0) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            else if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
            }
            else if (_this.state.isOpen && downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var firstLi = el.querySelector("." + optionStyles.menuItem);
                if (firstLi) {
                    firstLi.focus();
                }
            }
            if (events && events.onKeyUp) {
                events.onKeyUp(e);
            }
            if (downArrowIsPressed(e) || upArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                e.preventDefault();
                if (liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                }
                return;
            }
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            var events = _this.props.events;
            if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                var elm = e.currentTarget.parentElement;
                var liElementMain = elm.querySelector("." + optionStyles.menuItem + ":focus");
                _this.setState({ currentText: liElementMain.innerHTML });
            }
            else if (downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                var firstLi = el.querySelectorAll("." + optionStyles.menuItem);
                if (liElement && liElement.nextElementSibling) {
                    liElement.nextElementSibling.focus();
                }
                else {
                    if (firstLi && firstLi.length) {
                        firstLi[0].focus();
                    }
                }
                e.preventDefault();
                if (!UserAgent.isIE()) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                    return;
                }
            }
            else if (upArrowIsPressed(e)) {
                var elUp = e.currentTarget.parentElement;
                var liUpElement = elUp.querySelector("." + optionStyles.menuItem + ":focus");
                var lastLi = elUp.querySelectorAll("." + optionStyles.menuItem);
                if (liUpElement && liUpElement.previousElementSibling) {
                    liUpElement.previousElementSibling.focus();
                }
                else {
                    if (lastLi && lastLi.length > 1) {
                        lastLi[lastLi.length - 1].focus();
                    }
                }
                e.preventDefault();
            }
            else if (keyPress.KeyPress.tabIsPressed(e)) {
                if (_this.state.isOpen) {
                    _this.setState({
                        showClose: true,
                    }, function () {
                        var _a, _b;
                        (_b = (_a = _this.closeRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                    });
                    e.preventDefault();
                }
            }
            if (events && events.handleKeyDown) {
                events.handleKeyDown(e);
            }
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            _this.setState({ isOnFocus: true });
            if (events && events.onFocus) {
                events.onFocus(event);
            }
            if (_this.state.isLoadInitialResult && _this.state.currentText.length === 0) {
                _this.filterAndSetData("", "focus");
                _this.setState({ errorText: "" });
            }
            if (_this.state.isLoadInitialResult && _this.state.currentText.length > 0) {
                _this.showAllList();
            }
            if (!_this.state.isLoadInitialResult) {
                _this.setState({ showClose: true });
            }
        };
        _this.showAllList = function () {
            var currentTxt = _this.state.currentText;
            var filteredData = _this.props.data.choices;
            var checkRecord = _this.props.data.choices.filter(function (choice) {
                var searchText = currentTxt.toUpperCase();
                var displayText = choice.displayText.toUpperCase();
                return displayText === searchText;
            });
            // tslint:disable-next-line:no-console
            if (checkRecord.length === 0) {
                _this.filterAndSetData(currentTxt, "change");
            }
            else {
                _this.setState({
                    isOpen: true,
                    showClose: true,
                    filteredData: filteredData,
                    noSuggestionText: false,
                    isClickBack: true,
                });
            }
        };
        _this.handleClickOutside = function (event) {
            var domNode = react_dom_1.findDOMNode(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.setState({
                    isOpen: false,
                    showClose: false,
                });
            }
        };
        _this.onBlur = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (_this.state.isLoadInitialResult && _this.state.isOpen && currentText.length > 0) {
                _this.setState({ isOnFocus: false, showClose: true });
            }
            else if (_this.state.isLoadInitialResult) {
                _this.setState({ isOnFocus: false, showClose: false });
            }
            else {
                _this.setState({ isOnFocus: false, showClose: false });
            }
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
        };
        _this.onSelect = function (choice, enter) {
            var events = _this.props.events;
            _this.setState({
                isOpen: false,
                currentText: choice.displayText ? choice.displayText : "",
                showClose: false,
            });
            if (events && events.onSelect) {
                events.onSelect(choice);
            }
        };
        _this.clearInput = function (e) {
            var _a, _b;
            e.preventDefault();
            _this.setState({ currentText: "", isOpen: false, isOnFocus: true });
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            if (_this.state.isLoadInitialResult) {
                _this.filterAndSetData("", "focus");
                _this.setState({ errorText: "" });
            }
        };
        _this.closeOnBlur = function (e) {
            _this.setState({ isOpen: false, showClose: false });
        };
        _this.onNoSuggestionSelect = function () {
            _this.setState({ isOpen: false });
        };
        _this.closeIcon = function () {
            return (React__default.createElement(React__default.Fragment, null, _this.state.currentText.length && _this.state.showClose ? (React__default.createElement("button", { className: styles$2.closePosition + " right mar-r-xxs icon-close absolute", onMouseDown: _this.clearInput, onBlur: _this.closeOnBlur, ref: _this.closeRef, "aria-label": "Clear Input field" })) : ("")));
        };
        _this.getFindIndex = function (inputText, listText) {
            if (inputText === listText && _this.state.isClickBack === true) {
                return true;
            }
            return false;
        };
        _this.closeRef = React__default.createRef();
        _this.inputRef = React__default.createRef();
        _this.state = {
            isOpen: false,
            currentData: props.data,
            currentText: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.value) ? props.data.value : "",
            currentValue: null,
            filteredData: [],
            isOnFocus: false,
            errorText: ((_b = props.options) === null || _b === void 0 ? void 0 : _b.errorText) ? props.options.errorText : "",
            showClose: false,
            alertText: "",
            isLoadInitialResult: ((_c = props.options) === null || _c === void 0 ? void 0 : _c.isLoadInitialResult) === false ? false : true,
        };
        return _this;
    }
    ComboBox.prototype.componentDidMount = function () {
        document.addEventListener("click", this.handleClickOutside, true);
    };
    ComboBox.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
    };
    ComboBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId;
        var id = "input-" + testId;
        var ariaControlId = "aria-control-" + testId;
        var _b = this.state, isOpen = _b.isOpen, filteredData = _b.filteredData, currentText = _b.currentText, noSuggestionText = _b.noSuggestionText, errorText = _b.errorText;
        var dropdownCls = isOpen
            ? [
                styles$2.dropdown,
                "block pad-none left right absolute overflow-hidden bg-ui-white border border-medium-gray",
            ].join(" ")
            : [styles$2.dropdown, "absolute left right overflow-hidden hide"].join(" ");
        var choices = this.props.data.choices;
        var noDataFound = false;
        if (choices && choices.length === 0) {
            noDataFound = true;
        }
        var labelClass = errorText && errorText.length > 0 ? "error" : "";
        return (React__default.createElement("div", { "data-test-id": testId, className: styles$2.divPosition },
            React__default.createElement("div", { className: "inline-flex" }, data.labelText && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("label", { className: labelClass + " formfield-label", htmlFor: id }, data.labelText),
                React__default.createElement("span", { className: "hidden-spoken" }, errorText && errorText.length > 0 ? errorText : null),
                (options === null || options === void 0 ? void 0 : options.tooltip) !== undefined && options.tooltip))),
            React__default.createElement("div", null,
                React__default.createElement("div", { id: "multi-select-container" },
                    React__default.createElement("input", { id: id, "aria-describedby": errorText && errorText.length > 0 ? "msg_" + id : undefined, className: "textfield pad-r-lg rel", autoComplete: "off", "aria-autocomplete": "list", "aria-controls": ariaControlId, value: currentText, type: "text", placeholder: data.placeHolder, "aria-invalid": errorText && errorText.length > 0 ? true : undefined, onChange: this.onChange, onKeyDown: this.handleInputKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, tabIndex: 0, ref: this.inputRef }),
                    errorText && errorText.length > 0 && (React__default.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: { __html: errorText }, id: "msg_" + id, role: "alert" })),
                    React__default.createElement("div", { id: ariaControlId, className: dropdownCls },
                        React__default.createElement("div", { className: styles$2.showAllResult },
                            currentText.length > 0 && (React__default.createElement("div", { className: "hidden-spoken", "aria-live": "polite", dangerouslySetInnerHTML: {
                                    __html: filteredData.length + "\n                            suggestions shown, use your arrow keys to navigate through them and Enter to select",
                                } })),
                            React__default.createElement("ul", { role: "menu" },
                                noSuggestionText &&
                                    currentText &&
                                    filteredData.length === 0 ? (React__default.createElement("li", { className: optionStyles.menuItem +
                                        " " +
                                        " pad-t-xs " +
                                        styles$2.resultNotFound, "aria-label": options === null || options === void 0 ? void 0 : options.noSuggestionsText, tabIndex: -1, role: "option", onKeyDown: this.handleKeyDown },
                                    React__default.createElement("span", null, options === null || options === void 0 ? void 0 : options.noSuggestionsText))) : (""),
                                filteredData.map(function (choice, index) { return (React__default.createElement(MultiSelectInputList$2.default, { testId: _this.props.testId + " \"_Option_\" " + index + ")", key: choice.value, data: {
                                        choice: choice,
                                        isSelected: _this.getFindIndex(currentText, choice.displayText)
                                            ? true
                                            : false,
                                        textData: currentText || "",
                                    }, onSelect: noDataFound
                                        ? _this.onNoSuggestionSelect
                                        : _this.onSelect, options: {
                                        heighlightTextData: true,
                                        isCombobox: {
                                            isHoverColor: true,
                                            isHoverFocusColor: true,
                                            isAddBgColor: _this.state.isClickBack
                                                ? true
                                                : false,
                                        },
                                    }, handelKeyDown: _this.handleKeyDown })); })))),
                    this.closeIcon())),
            React__default.createElement("div", { "aria-live": "assertive", role: "status" },
                React__default.createElement("span", { className: "hidden-spoken" },
                    " ",
                    this.state.alertText))));
    };
    return ComboBox;
}(React__default.Component));
exports.default = ComboBox;
});

var ComboBox$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ComboBox_1.default;
});

var ComboBox$3 = /*@__PURE__*/getDefaultExportFromCjs(ComboBox$2);

var MakeSelector = function (_a) {
    var manufacturerLabel = _a.manufacturerLabel, makeRef = _a.makeRef, selectedMakeName = _a.selectedMakeName, setSelectedMakeData = _a.setSelectedMakeData, setCurrentStage = _a.setCurrentStage, makesData = _a.makesData, otherMakeText = _a.otherMakeText, otherMakeSelectorPlaceholder = _a.otherMakeSelectorPlaceholder;
    var isOtherSelected = useMemo(function () {
        if (!selectedMakeName)
            return false;
        return !!makesData.otherMakes.find(function (i) { return i.name === selectedMakeName; });
    }, [makesData.otherMakes, selectedMakeName]);
    var _b = useState(isOtherSelected), otherSelected = _b[0], setOtherSelected = _b[1];
    var onRadioSelection = function (e) {
        var inputSelection = e.target.value;
        if (inputSelection === otherMakeText) {
            setOtherSelected(true);
            setSelectedMakeData(undefined);
            setCurrentStage(CurrentStageEnum.SELECT_MAKE);
        }
        else {
            setOtherSelected(false);
            var selectedMakeData = makesData.makes.find(function (i) { return i.name === inputSelection; });
            setSelectedMakeData(selectedMakeData);
            setCurrentStage(CurrentStageEnum.SELECT_MODEL);
        }
    };
    var options = useMemo(function () {
        var updatedOptions = __spreadArrays(makesData.makes.map(function (i) {
            if (selectedMakeName) {
                var isSelected = selectedMakeName === i.name;
                return { text: i.name, checked: isSelected };
            }
            else {
                return { text: i.name, checked: false };
            }
        }));
        if (makesData.otherMakes.length > 0) {
            updatedOptions = __spreadArrays(updatedOptions, [{ text: otherMakeText, checked: otherSelected }]);
        }
        else {
            setOtherSelected(false);
        }
        return updatedOptions;
    }, [makesData, selectedMakeName, otherMakeText, otherSelected]);
    var otherMakesOptions = useMemo(function () {
        var otherOptions = makesData.otherMakes.map(function (i) {
            return { value: i.name, displayText: i.name };
        });
        return otherOptions;
    }, [makesData.otherMakes]);
    var onOtherMakeSelection = function (inputSelection) {
        var selectedMakeData = makesData.otherMakes.find(function (i) { return i.name === inputSelection.value; });
        setSelectedMakeData(selectedMakeData);
        setCurrentStage(CurrentStageEnum.SELECT_MODEL);
    };
    return (React__default.createElement("div", { className: "" + radioButtonGroup$1, ref: makeRef },
        React__default.createElement("fieldset", { id: "sharedoffer-radio-group-make-selector", "aria-label": manufacturerLabel },
            React__default.createElement("legend", null,
                React__default.createElement("label", { className: header$1 + " formfield-label" },
                    React__default.createElement("span", { dangerouslySetInnerHTML: {
                            __html: purify.sanitize(manufacturerLabel),
                        } }))),
            React__default.createElement("div", { className: buttonGroup$1 + " " + buttonMargin }, options.map(function (option, index) {
                var _a;
                return (React__default.createElement(RadioButton, { label: option.text, checked: (_a = option) === null || _a === void 0 ? void 0 : _a.checked, index: index, name: option.text, key: index, onChange: onRadioSelection }));
            }))),
        otherSelected && (React__default.createElement(ComboBox$3, { data: {
                // @ts-ignore
                choices: otherMakesOptions,
                value: selectedMakeName,
                placeHolder: otherMakeSelectorPlaceholder,
            }, events: {
                onSelect: onOtherMakeSelection,
            } }))));
};

var ModelSelector = function (_a) {
    var modelSeriesLabel = _a.modelSeriesLabel, modelRef = _a.modelRef, selectedModelName = _a.selectedModelName, selectedMakeData = _a.selectedMakeData, setSelectedModelData = _a.setSelectedModelData, setCurrentStage = _a.setCurrentStage, modelSelectorPlaceholder = _a.modelSelectorPlaceholder, modelInputRef = _a.modelInputRef;
    var deviceModels = useMemo(function () {
        var models = selectedMakeData.models;
        var modelList = models &&
            models.map(function (m) {
                return { value: m.name, displayText: m.name };
            });
        return modelList;
    }, [selectedMakeData]);
    var onModelChange = function (inputSelection) {
        var selectedModelData = selectedMakeData.models.find(function (i) { return i.name === inputSelection.value; });
        setSelectedModelData(selectedModelData);
        setCurrentStage(CurrentStageEnum.SELECT_CAPACITY);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { ref: modelRef },
            React__default.createElement(ComboBox$3, { data: {
                    // @ts-ignore
                    choices: deviceModels,
                    value: selectedModelName,
                    placeHolder: modelSelectorPlaceholder,
                    labelText: modelSeriesLabel,
                }, events: {
                    onSelect: onModelChange,
                }, ref: modelInputRef }))));
};

var radioButtonGroup$2 = "RadioSelectionGroup-module_radio-button-group__3sCll";
var radioSelectButton$1 = "RadioSelectionGroup-module_radio-select-button__2fmdU";
var buttonContainer$1 = "RadioSelectionGroup-module_button-container__HivXE";
var buttonGroupContainer = "RadioSelectionGroup-module_button-group-container__OnA-m";
var header$2 = "RadioSelectionGroup-module_header__wjGAQ";
var headerConditionQuestion = "RadioSelectionGroup-module_headerConditionQuestion__d6jt5";
var tooltip = "RadioSelectionGroup-module_tooltip__9alNs";
var css_248z$b = ".RadioSelectionGroup-module_radio-button-group__3sCll ul {\n  list-style-type: disc; }\n\n.RadioSelectionGroup-module_radio-button-group__3sCll .RadioSelectionGroup-module_radio-select-button__2fmdU {\n  padding: 10px 20px;\n  border: 1px solid #DCDFE3;\n  background-color: #ffffff;\n  border-radius: 3px;\n  margin-right: 16px;\n  display: inline-block;\n  scroll-margin-inline: 8px;\n  margin-top: 8px; }\n\n.RadioSelectionGroup-module_radio-button-group__3sCll input[type=\"radio\"] {\n  opacity: 0;\n  position: absolute; }\n  .RadioSelectionGroup-module_radio-button-group__3sCll input[type=\"radio\"]:checked + label {\n    border: 2px solid #0057B8; }\n  .RadioSelectionGroup-module_radio-button-group__3sCll input[type=\"radio\"]:focus-visible + label {\n    outline: 1px dotted #0057B8;\n    outline-offset: 5px; }\n\n.RadioSelectionGroup-module_button-container__HivXE {\n  position: relative;\n  display: inline-block;\n  margin-top: 0px;\n  margin-bottom: 0px; }\n\n.RadioSelectionGroup-module_button-group-container__OnA-m {\n  margin-top: -8px; }\n\n.RadioSelectionGroup-module_header__wjGAQ {\n  font-size: 14px;\n  padding-top: 24px; }\n  .RadioSelectionGroup-module_header__wjGAQ b, .RadioSelectionGroup-module_header__wjGAQ strong {\n    font-weight: bold; }\n\n.RadioSelectionGroup-module_headerConditionQuestion__d6jt5 {\n  font-size: 16px;\n  padding-top: 24px; }\n  .RadioSelectionGroup-module_headerConditionQuestion__d6jt5 b, .RadioSelectionGroup-module_headerConditionQuestion__d6jt5 strong {\n    font-weight: bold; }\n\n.RadioSelectionGroup-module_tooltip__9alNs {\n  height: 16px;\n  padding-left: 8px;\n  max-width: 24px; }\n";
styleInject(css_248z$b);

var childContainer = "Tooltip_childContainer__gB0w-";
var textInfo = "Tooltip_textInfo__rRpKx";
var bgwhite = "Tooltip_bgwhite__UfvBO";
var infoBox = "Tooltip_infoBox__fQoZn";
var arrow = "Tooltip_arrow__V-Vpz";
var show = "Tooltip_show__r7ZoV";
var positionBottom = "Tooltip_positionBottom__8QOgP";
var positionTop = "Tooltip_positionTop__bifT8";
var relPmt = "Tooltip_rel-pmt__upNa3";
var css_248z$c = ".Tooltip_childContainer__gB0w- {\n  line-height: 0.8;\n  top: -1px; }\n  .Tooltip_childContainer__gB0w- > * {\n    position: relative !important; }\n  .Tooltip_childContainer__gB0w- svg {\n    vertical-align: baseline; }\n\n.Tooltip_textInfo__rRpKx {\n  color: #ffffff;\n  font-size: 1.2rem; }\n  .Tooltip_textInfo__rRpKx.Tooltip_bgwhite__UfvBO {\n    color: #454b52 !important; }\n\n.Tooltip_infoBox__fQoZn {\n  border-radius: 2px;\n  visibility: hidden;\n  background-color: #454b52;\n  position: absolute;\n  z-index: 1000;\n  max-width: 320px;\n  width: -moz-max-content;\n  width: max-content; }\n\n.Tooltip_bgwhite__UfvBO {\n  background-color: #ffffff !important; }\n\n.Tooltip_arrow__V-Vpz {\n  visibility: hidden;\n  border-radius: 0 2px 0 2px;\n  background-color: #454b52;\n  width: 8px;\n  height: 8px;\n  z-index: 1000;\n  position: absolute; }\n\n.Tooltip_show__r7ZoV {\n  visibility: visible !important; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(3px) rotate(-45deg);\n  top: 100%; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, 7px);\n  left: 50%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(-5px) rotate(-45deg);\n  bottom: 100%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, -9px);\n  bottom: 100%;\n  left: 50%; }\n\n.Tooltip_rel-pmt__upNa3 {\n  position: relative !important; }\n\n.form-row.rel {\n  z-index: auto; }\n\n.is-tabbing .trigger:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: 1px; }\n";
var Tooltip = {"childContainer":"Tooltip_childContainer__gB0w-","textInfo":"Tooltip_textInfo__rRpKx","bgwhite":"Tooltip_bgwhite__UfvBO","infoBox":"Tooltip_infoBox__fQoZn","arrow":"Tooltip_arrow__V-Vpz","show":"Tooltip_show__r7ZoV","positionBottom":"Tooltip_positionBottom__8QOgP","positionTop":"Tooltip_positionTop__bifT8","rel-pmt":"Tooltip_rel-pmt__upNa3","relPmt":"Tooltip_rel-pmt__upNa3"};
const stylesheet$4=".Tooltip_childContainer__gB0w- {\n  line-height: 0.8;\n  top: -1px; }\n  .Tooltip_childContainer__gB0w- > * {\n    position: relative !important; }\n  .Tooltip_childContainer__gB0w- svg {\n    vertical-align: baseline; }\n\n.Tooltip_textInfo__rRpKx {\n  color: #ffffff;\n  font-size: 1.2rem; }\n  .Tooltip_textInfo__rRpKx.Tooltip_bgwhite__UfvBO {\n    color: #454b52 !important; }\n\n.Tooltip_infoBox__fQoZn {\n  border-radius: 2px;\n  visibility: hidden;\n  background-color: #454b52;\n  position: absolute;\n  z-index: 1000;\n  max-width: 320px;\n  width: -moz-max-content;\n  width: max-content; }\n\n.Tooltip_bgwhite__UfvBO {\n  background-color: #ffffff !important; }\n\n.Tooltip_arrow__V-Vpz {\n  visibility: hidden;\n  border-radius: 0 2px 0 2px;\n  background-color: #454b52;\n  width: 8px;\n  height: 8px;\n  z-index: 1000;\n  position: absolute; }\n\n.Tooltip_show__r7ZoV {\n  visibility: visible !important; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(3px) rotate(-45deg);\n  top: 100%; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, 7px);\n  left: 50%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(-5px) rotate(-45deg);\n  bottom: 100%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, -9px);\n  bottom: 100%;\n  left: 50%; }\n\n.Tooltip_rel-pmt__upNa3 {\n  position: relative !important; }\n\n.form-row.rel {\n  z-index: auto; }\n\n.is-tabbing .trigger:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: 1px; }\n";
styleInject(css_248z$c);

var Tooltip$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    childContainer: childContainer,
    textInfo: textInfo,
    bgwhite: bgwhite,
    infoBox: infoBox,
    arrow: arrow,
    show: show,
    positionBottom: positionBottom,
    positionTop: positionTop,
    relPmt: relPmt,
    'default': Tooltip,
    stylesheet: stylesheet$4
});

var styles$3 = /*@__PURE__*/getAugmentedNamespace(Tooltip$1);

var TooltipProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionType = void 0;

exports.PositionType = {
    top: styles$3.positionTop,
    bottom: styles$3.positionBottom,
};
});

var Tooltip_1 = createCommonjsModule(function (module, exports) {
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });





var Tooltip = function (_a) {
    var infoTxt = _a.infoTxt, boxWidth = _a.boxWidth, _b = _a.position, position = _b === void 0 ? "top" : _b, children = _a.children, style = _a.style, className = _a.className, offset = _a.offset, _c = _a.show, show = _c === void 0 ? false : _c, _d = _a.content, content = _d === void 0 ? "stuff" : _d, testId = _a.testId, zIndex = _a.zIndex, _e = _a.type, type = _e === void 0 ? "dark" : _e;
    var _f = __read(React__default.useState(show), 2), showState = _f[0], setShowState = _f[1];
    var _g = __read(React__default.useState(position), 2), positionState = _g[0], setPositionState = _g[1];
    var _h = __read(React__default.useState(false), 2), isClick = _h[0], setIsClick = _h[1];
    var _j = __read(React__default.useState(false), 2), isHover = _j[0], setIsHover = _j[1];
    var _k = __read(React__default.useState(true), 2), isFocusable = _k[0], setIsFocusable = _k[1];
    var arrowRef = React__default.useRef(null);
    var boxRef = React__default.useRef(null);
    var triggerRef = React__default.useRef(null);
    var noWrap = false;
    React__default.useEffect(function () {
        if (process.browser && window) {
            suppressFocus();
            checkPosition();
            window.addEventListener("resize", checkPosition);
        }
        return function () {
            if (process.browser && window) {
                suppressFocus();
                window.removeEventListener("resize", checkPosition);
            }
        };
    }, []);
    var checkPosition = React__default.useCallback(function () {
        if (process.browser && window) {
            // if width of box exceeds screen size, set it responsively to the size of the screen
            if (!boxRef.current || !arrowRef.current || !triggerRef.current) {
                return;
            }
            var currentBox = boxRef.current;
            var bounds = currentBox.getBoundingClientRect();
            var currentArrow = arrowRef.current;
            var arrowBounds = currentArrow.getBoundingClientRect();
            var currentTrigger = triggerRef.current;
            var triggerBounds = currentTrigger.getBoundingClientRect();
            // if it is the size of the screen
            var sidePadding = window.innerWidth > 600 ? 32 : 16;
            // vertical positioning
            if (position === "top" && bounds.top < sidePadding) {
                setPositionState("bottom");
            }
            else if (position === "bottom" && bounds.bottom > window.innerHeight - sidePadding) {
                setPositionState("top");
            }
            if (bounds.width >= document.documentElement.clientWidth - sidePadding * 2) {
                currentBox.style.width =
                    document.documentElement.clientWidth - (sidePadding + 10) * 2 + "px";
            }
            else {
                currentBox.style.width = bounds.width + "px";
            }
            if (bounds.left < sidePadding) {
                currentBox.style.left =
                    sidePadding +
                        Math.abs(arrowBounds.left +
                            8 -
                            parseInt(currentBox.style.width.slice(0, -2), 10) / 2) +
                        triggerBounds.width / 2 +
                        "px";
                if (currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width >=
                    document.documentElement.clientWidth - sidePadding) {
                    var tmpLeft = parseInt(currentBox.style.left.slice(0, -2), 10);
                    currentBox.style.left =
                        tmpLeft -
                            (currentBox.getBoundingClientRect().right -
                                (document.documentElement.clientWidth - sidePadding)) +
                            "px";
                }
            }
            if (bounds.right > document.documentElement.clientWidth - sidePadding) {
                var extra = arrowBounds.left +
                    6 +
                    parseInt(currentBox.style.width.slice(0, -2), 10) / 2 -
                    (document.documentElement.clientWidth - sidePadding);
                currentBox.style.left = -extra + "px";
                if (currentBox.getBoundingClientRect().left < sidePadding) {
                    var tmpLeft = parseInt(currentBox.style.left.slice(0, -2), 10);
                    currentBox.style.left =
                        tmpLeft + (sidePadding - currentBox.getBoundingClientRect().left) + "px";
                }
            }
            if (
            // is there an offset? Is that offset less than half the width of the box? If I relocate it, will the offset push me off the page?
            offset &&
                Math.abs(offset) < currentBox.getBoundingClientRect().width / 2 - 15 &&
                currentBox.getBoundingClientRect().left + offset > sidePadding &&
                currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width +
                    offset <
                    window.innerWidth - sidePadding) {
                currentBox.style.left = "calc(50% + " + offset + "px)";
                // make sure its not pushhing off screen
                if (currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width >=
                    window.innerWidth - sidePadding) {
                    var extra = arrowBounds.left +
                        6 +
                        parseInt(currentBox.style.width.slice(0, -2), 10) / 2 -
                        (document.documentElement.clientWidth - sidePadding);
                    currentBox.style.left = -extra + "px";
                }
                else if (currentBox.getBoundingClientRect().left < sidePadding) {
                    currentBox.style.left =
                        sidePadding +
                            Math.abs(arrowBounds.left +
                                6 -
                                parseInt(currentBox.style.width.slice(0, -2), 10) / 2) +
                            triggerBounds.width / 2 +
                            "px";
                }
            }
        }
    }, []);
    function suppressFocus() {
        if (triggerRef.current) {
            var items = triggerRef.current.querySelectorAll("input, button, a, select, textarea");
            if (items.length > 0) {
                setIsFocusable(false);
            }
            else {
                setIsFocusable(true);
            }
        }
        else {
            setIsFocusable(true);
        }
    }
    var tooltipLabel = "tooltip";
    var tooltipId = getId();
    var msgid = "msg-" + tooltipId;
    if (!boxWidth &&
        boxRef &&
        boxRef.current &&
        boxRef.current.getBoundingClientRect().width < 320) {
        noWrap = true;
    }
    function getId() {
        if (typeof document !== "undefined") {
            var temp = tooltipLabel
                .replace(/ /g, "-")
                .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
                .toLowerCase();
            while (document.getElementById(temp)) {
                temp = temp.concat(Math.floor(Math.random() * 100 + 1).toString());
            }
            return temp;
        }
        else {
            return tooltipLabel;
        }
    }
    var KeyDownHandler = function (e) {
        if (keyPress.KeyPress.escIsPressed(e)) {
            hideTooltip();
            setIsClick(false);
            setIsHover(false);
        }
        else {
            if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
                e.preventDefault();
                if (!showState) {
                    showTooltip();
                    setIsClick(true);
                    setIsHover(false);
                }
                else {
                    hideTooltip();
                    setIsClick(false);
                    setIsHover(false);
                }
            }
        }
    };
    return (React__default.createElement("div", { className: "inline-block", style: { verticalAlign: "middle" }, "data-testid": testId },
        React__default.createElement("div", { className: Join.join(["outerContainer", className]), style: style, "data-testid": testId, id: tooltipId },
            positionState === "top" && positionTop(),
            React__default.createElement("span", { className: "hidden-spoken", id: msgid }, content),
            React__default.createElement("div", { tabIndex: isFocusable ? 0 : -1, ref: triggerRef, className: Join.join("rel", "trigger", styles$3.childContainer), onClick: onClick, onMouseEnter: onHoverIn, onMouseLeave: onHoverOut, onBlur: onBlur, onKeyDown: KeyDownHandler, role: "button", "aria-describedby": msgid, "aria-label": infoTxt ? infoTxt : "Help", "aria-expanded": showState ? true : false }, children),
            positionState === "bottom" && positionBottom())));
    function positionTop() {
        return (React__default.createElement("div", { className: zIndex === undefined || zIndex === false ? "rel" : styles$3.relPmt },
            React__default.createElement("div", { ref: boxRef, style: { width: boxWidth }, className: Join.join("infoBox", showState && styles$3.show, styles$3.infoBox, type === "light" ? styles$3.bgwhite : "", TooltipProps.PositionType[positionState], noWrap ? "nowrap" : "") },
                React__default.createElement("div", { className: Join.join("mar-b-none infoText pad-t-xxs pad-b-xxs pad-l-xs pad-r-xs line-h-md", styles$3.textInfo, type === "light" ? styles$3.bgwhite : "") }, content)),
            React__default.createElement("div", { ref: arrowRef, className: Join.join("arrow", showState && styles$3.show, styles$3.arrow, type === "light" ? styles$3.bgwhite : "", TooltipProps.PositionType[positionState]) })));
    }
    function positionBottom() {
        return (React__default.createElement("div", { className: zIndex === undefined || zIndex === false ? "rel" : styles$3.relPmt },
            React__default.createElement("div", { ref: arrowRef, className: Join.join("arrow", showState && styles$3.show, styles$3.arrow, type === "light" ? styles$3.bgwhite : "", TooltipProps.PositionType[positionState]) }),
            React__default.createElement("div", { ref: boxRef, style: { width: boxWidth }, className: Join.join("infoBox", showState && styles$3.show, styles$3.infoBox, type === "light" ? styles$3.bgwhite : "", TooltipProps.PositionType[positionState], noWrap ? "nowrap" : "") },
                React__default.createElement("div", { className: Join.join("mar-b-none infoText pad-t-xxs pad-b-xxs pad-l-xs pad-r-xs line-h-md", styles$3.textInfo, type === "light" ? styles$3.bgwhite : "") }, content))));
    }
    function onHoverOut() {
        if (isClick) {
            return;
        }
        else {
            hideTooltip();
            setIsHover(false);
        }
    }
    function onHoverIn() {
        setIsHover(true);
        showTooltip();
    }
    function onBlur() {
        setIsClick(false);
        setIsHover(false);
        hideTooltip();
    }
    function onClick(e) {
        e.stopPropagation();
        if (isHover) {
            showTooltip();
            setIsClick(true);
            setIsHover(false);
        }
        else if (showState) {
            hideTooltip();
            setIsClick(false);
        }
        else {
            showTooltip();
            setIsClick(true);
            setIsHover(false);
        }
    }
    function showTooltip() {
        checkPosition();
        setShowState(true);
    }
    function hideTooltip() {
        setShowState(false);
        setPositionState(position);
    }
};
exports.default = Tooltip;
});

var Tooltip$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Tooltip_1.default;
});

var Tooltip$3 = /*@__PURE__*/getDefaultExportFromCjs(Tooltip$2);

var RadioSelectionGroup = function (props) {
    var _a;
    var onRadioGroupChange = function (e) {
        var data = {
            value: e.target.value,
        };
        props.events.radioSelectionEvent(data);
    };
    var radioButton = function (label, checked, index) {
        return (React__default.createElement(React__default.Fragment, { key: index },
            React__default.createElement("div", { className: "" + buttonContainer$1 },
                React__default.createElement("input", { id: "sharedoffer-radio-button-" + props.name + "-" + index, name: props.name, type: "radio", value: label, key: index, checked: checked, onChange: onRadioGroupChange }),
                React__default.createElement("label", { htmlFor: "sharedoffer-radio-button-" + props.name + "-" + index, className: "type-base " + radioSelectButton$1 }, label))));
    };
    return (React__default.createElement("div", { className: "" + radioButtonGroup$2 },
        React__default.createElement("fieldset", { id: "sharedoffer-radio-group-" + props.name, "aria-label": props.heading },
            React__default.createElement("legend", null,
                React__default.createElement("label", { className: (((_a = props) === null || _a === void 0 ? void 0 : _a.isConditionQuestion) ? headerConditionQuestion
                        : header$2) + " formfield-label" },
                    React__default.createElement("span", { dangerouslySetInnerHTML: {
                            __html: purify.sanitize(props.heading),
                        } }),
                    React__default.createElement(Tooltip$3, { content: React__default.createElement("span", { dangerouslySetInnerHTML: {
                                __html: purify.sanitize(props.tooltipContent),
                            } }), offset: 75 },
                        React__default.createElement(IconSVG, { svgUrl: props.tooltipSvg, ariaLabel: 'tooltip', ariaHidden: false, className: "color-ui-black " + tooltip })))),
            props.children,
            props.options && (React__default.createElement("div", { className: "" + buttonGroupContainer }, props.options.map(function (option, index) { var _a; return radioButton(option.text, (_a = option) === null || _a === void 0 ? void 0 : _a.checked, index); }))))));
};

var CapacitySelector = function (_a) {
    var capacityLabel = _a.capacityLabel, selectedCapacity = _a.selectedCapacity, selectedModelData = _a.selectedModelData, setSelectedCapacity = _a.setSelectedCapacity, setSelectedProductData = _a.setSelectedProductData, setCurrentStage = _a.setCurrentStage, tooltipContent = _a.tooltipContent, tooltipSvg = _a.tooltipSvg, capacityRef = _a.capacityRef;
    var getDeviceCapacities = function () {
        var _a, _b, _c, _d;
        var capacityList = (_b = (_a = selectedModelData) === null || _a === void 0 ? void 0 : _a.productFamily) === null || _b === void 0 ? void 0 : _b.map(function (product) {
            return product.capacity;
        });
        // sort in order of capacity size
        (_c = capacityList) === null || _c === void 0 ? void 0 : _c.sort(function (firstEl, secondEl) { return parseInt(firstEl) - parseInt(secondEl); });
        var capacityObjectList = (_d = capacityList) === null || _d === void 0 ? void 0 : _d.map(function (capacity) {
            return { text: capacity, checked: selectedCapacity === capacity };
        });
        return capacityObjectList;
    };
    var onCapacityChange = function (capacity) {
        setSelectedCapacity(capacity);
        var device = selectedModelData.productFamily.find(function (i) { return i.capacity === capacity; });
        setSelectedProductData(device);
        setCurrentStage(CurrentStageEnum.SELECT_QUESTION_ANSWERS);
    };
    return (React__default.createElement("div", { ref: capacityRef },
        React__default.createElement(RadioSelectionGroup, { name: "sharedofferCapacityToggle", heading: capacityLabel ? capacityLabel : '', options: getDeviceCapacities(), tooltipContent: tooltipContent, tooltipSvg: tooltipSvg, events: {
                radioSelectionEvent: function (data) {
                    onCapacityChange(data.value);
                },
            } })));
};

var questionDescription = "Questions-module_question-description__f-c4D";
var css_248z$d = ".Questions-module_question-description__f-c4D {\n  font-size: 12px; }\n  .Questions-module_question-description__f-c4D b, .Questions-module_question-description__f-c4D strong {\n    font-weight: bold; }\n";
styleInject(css_248z$d);

var Question = function (_a) {
    var heading = _a.heading, questionDescription$1 = _a.questionDescription, onSelection = _a.onSelection, options = _a.options, name = _a.name, questionRef = _a.questionRef;
    var _b;
    return (React__default.createElement("div", { ref: questionRef },
        React__default.createElement(RadioSelectionGroup, { name: "questionToggle-" + name, heading: heading, options: options, isConditionQuestion: true, events: {
                radioSelectionEvent: function (data) {
                    var answer = data.value;
                    onSelection(answer);
                },
            } },
            React__default.createElement("ul", { className: questionDescription + " type-xs pad-l-xs pad-b-xs type-base Lists__type-base" }, (_b = questionDescription$1) === null || _b === void 0 ? void 0 : _b.map(function (item, index) { return (React__default.createElement("li", { key: index, dangerouslySetInnerHTML: {
                    __html: purify.sanitize(item),
                } })); })))));
};

var GenericQuestion = function (_a) {
    var heading = _a.heading, answerGenericQuestion = _a.answerGenericQuestion, questionDescription = _a.questionDescription, setAnswerGenericQuestion = _a.setAnswerGenericQuestion;
    return (React__default.createElement(Question, { options: [
            {
                text: GenericQuestionAnswerTextEnum.YES,
                checked: answerGenericQuestion === GenericQuestionAnswerTextEnum.YES,
            },
            {
                text: GenericQuestionAnswerTextEnum.NO,
                checked: answerGenericQuestion === GenericQuestionAnswerTextEnum.NO,
            },
        ], onSelection: function (answer) {
            if (answer === GenericQuestionAnswerTextEnum.NO) {
                setAnswerGenericQuestion(answer);
            }
            else if (answer === GenericQuestionAnswerTextEnum.YES) {
                setAnswerGenericQuestion(answer);
            }
        }, heading: heading, questionDescription: questionDescription, name: "GENERIC" }));
};

var QuestionsBadCondition = function (_a) {
    var questions = _a.questions, answersBadCondition = _a.answersBadCondition, setAnswersBadCondition = _a.setAnswersBadCondition, questionContent = _a.questionContent;
    var _b;
    var initializedAnswerMap = function () {
        var _a;
        var map = new Map();
        (_a = answersBadCondition) === null || _a === void 0 ? void 0 : _a.forEach(function (answer) {
            map.set(answer.questionCode, answer);
        });
        return map;
    };
    var _c = useState(initializedAnswerMap()), answerMap = _c[0], setAnswerMap = _c[1];
    var onQuestionAnswer = function (answer, question) {
        var answerObj = question.validAnswers.find(function (i) { return i.answerText === answer; });
        answerMap.set(question.questionCode, answerObj);
        setAnswerMap(new Map(answerMap)); // trigger re-render
    };
    var lastQuestionRef = useRef();
    useEffect(function () {
        var _a, _b, _c, _d;
        // scroll to the last question if answers change
        (_b = (_a = lastQuestionRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
        // we want to update the outside array when we hit the right length
        if (((_c = answerMap) === null || _c === void 0 ? void 0 : _c.size) && ((_d = questions) === null || _d === void 0 ? void 0 : _d.length)) {
            if (answerMap.size === questions.length) {
                // all answers are set
                var answers_1 = [];
                answerMap.forEach(function (questionAnswer) {
                    answers_1.push(questionAnswer);
                });
                setAnswersBadCondition(answers_1); // communicates that we have answered all the questions
            }
        }
    }, [answerMap, questions, setAnswersBadCondition]);
    return (React__default.createElement(React__default.Fragment, null, (_b = questions) === null || _b === void 0 ? void 0 : _b.map(function (question, index) {
        var _a, _b, _c, _d, _e, _f;
        var showQuestion = false;
        if (index === 0) {
            showQuestion = true;
        }
        else {
            var previousQuestionCode = (_a = questions[index - 1]) === null || _a === void 0 ? void 0 : _a.questionCode;
            if ((_b = answerMap) === null || _b === void 0 ? void 0 : _b.get(previousQuestionCode)) {
                showQuestion = true;
            }
        }
        if (showQuestion) {
            var content = (_d = (_c = questionContent) === null || _c === void 0 ? void 0 : _c.find(function (q) { var _a, _b; return ((_b = (_a = q) === null || _a === void 0 ? void 0 : _a.master) === null || _b === void 0 ? void 0 : _b.questionCode) === question.questionCode; })) === null || _d === void 0 ? void 0 : _d.master;
            var answerSelected_1 = answerMap.get(question.questionCode);
            var options = question.validAnswers.map(function (answerOption) {
                var _a;
                // check if customer supplied answer to this question already
                var checked = false;
                if (answerSelected_1)
                    checked = ((_a = answerSelected_1) === null || _a === void 0 ? void 0 : _a.answerText) === answerOption.answerText;
                return { text: answerOption.answerText, checked: checked };
            });
            return (React__default.createElement(Question, { heading: (_e = content) === null || _e === void 0 ? void 0 : _e.questionLabel, questionDescription: (_f = content) === null || _f === void 0 ? void 0 : _f.questionDescription, options: options, onSelection: function (answer) { return onQuestionAnswer(answer, question); }, key: question.questionCode, name: question.questionCode, questionRef: answerSelected_1 ? undefined : lastQuestionRef }));
        }
        else {
            return null;
        }
    })));
};

var QuestionDeactivated = function (_a) {
    var answerDeactivated = _a.answerDeactivated, setAnswerDeactivated = _a.setAnswerDeactivated, question = _a.question, questionContent = _a.questionContent, deactivatedRef = _a.deactivatedRef;
    var _b, _c, _d, _e;
    var onQuestionAnswer = function (answer) {
        var answerObj = question.validAnswers.find(function (i) { return i.answerText === answer; });
        setAnswerDeactivated(answerObj);
    };
    var options = useMemo(function () { var _a, _b; return (_b = (_a = question) === null || _a === void 0 ? void 0 : _a.validAnswers) === null || _b === void 0 ? void 0 : _b.map(function (answerOption) {
        var _a;
        // check if customer supplied answer to this question already
        var checked = false;
        if (answerDeactivated)
            checked = ((_a = answerDeactivated) === null || _a === void 0 ? void 0 : _a.answerText) === answerOption.answerText;
        return { text: answerOption.answerText, checked: checked };
    }); }, [question, answerDeactivated]);
    return (React__default.createElement(Question, { options: options, onSelection: onQuestionAnswer, heading: (_c = (_b = questionContent) === null || _b === void 0 ? void 0 : _b.master) === null || _c === void 0 ? void 0 : _c.questionLabel, questionDescription: (_e = (_d = questionContent) === null || _d === void 0 ? void 0 : _d.master) === null || _e === void 0 ? void 0 : _e.questionDescription, name: "DEACTIVATED", questionRef: deactivatedRef }));
};

var Questions = function (_a) {
    var questionContent = _a.questionContent, hasDeactivatedQuestion = _a.hasDeactivatedQuestion, questionsBadCondition = _a.questionsBadCondition, questionDeactivated = _a.questionDeactivated, setQuestionAnswers = _a.setQuestionAnswers, answerGenericQuestion = _a.answerGenericQuestion, setAnswerGenericQuestion = _a.setAnswerGenericQuestion, questionAnswers = _a.questionAnswers;
    var _b, _c, _d, _e, _f;
    var deactivatedRef = useRef();
    var preSelectedAnswersBadCondition = function () {
        if (questionAnswers && answerGenericQuestion === GenericQuestionAnswerTextEnum.NO) {
            var result = questionAnswers.filter(function (answer) { return answer.questionCode !== QuestionCodeEnum.DEACTIVATED; });
            return result;
        }
        else {
            return undefined;
        }
    };
    var preSelectedAnswerDeactivated = function () {
        if (questionAnswers && answerGenericQuestion === GenericQuestionAnswerTextEnum.NO) {
            var result = questionAnswers.find(function (answer) { return answer.questionCode === QuestionCodeEnum.DEACTIVATED; });
            return result;
        }
        else {
            return undefined;
        }
    };
    var _g = useState(preSelectedAnswersBadCondition()), answersBadCondition = _g[0], setAnswersBadCondition = _g[1];
    var _h = useState(preSelectedAnswerDeactivated()), answerDeactivated = _h[0], setAnswerDeactivated = _h[1];
    // update question answers when the answers change
    useEffect(function () {
        if (answerGenericQuestion === GenericQuestionAnswerTextEnum.YES) {
            setQuestionAnswers(undefined);
            setAnswersBadCondition(undefined);
            setAnswerDeactivated(undefined);
        }
    }, [answerGenericQuestion, setQuestionAnswers]);
    useEffect(function () {
        var _a, _b;
        var questionsComplete = true;
        if (answerGenericQuestion === GenericQuestionAnswerTextEnum.NO) {
            if (questionsBadCondition && questionDeactivated && answersBadCondition) {
                if (answersBadCondition.length === questionsBadCondition.length) {
                    if (hasDeactivatedQuestion) {
                        if (answerDeactivated) {
                            var answers = __spreadArrays(answersBadCondition);
                            answers.push(answerDeactivated);
                            setQuestionAnswers(answers);
                        }
                        else {
                            (_b = (_a = deactivatedRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
                            questionsComplete = false;
                        }
                    }
                    else {
                        setQuestionAnswers(__spreadArrays(answersBadCondition));
                    }
                }
                else {
                    questionsComplete = false;
                }
            }
            else {
                questionsComplete = false;
            }
        }
        if (!questionsComplete)
            setQuestionAnswers(undefined);
    }, [
        answerDeactivated,
        answerGenericQuestion,
        answersBadCondition,
        hasDeactivatedQuestion,
        questionDeactivated,
        questionsBadCondition,
        setQuestionAnswers,
    ]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(GenericQuestion, { heading: (_c = (_b = questionContent.find(function (q) { var _a, _b; return ((_b = (_a = q) === null || _a === void 0 ? void 0 : _a.master) === null || _b === void 0 ? void 0 : _b.questionCode) === QuestionCodeEnum.GENERIC; })) === null || _b === void 0 ? void 0 : _b.master) === null || _c === void 0 ? void 0 : _c.questionLabel, questionDescription: (_f = (_e = (_d = questionContent) === null || _d === void 0 ? void 0 : _d.find(function (q) { var _a, _b; return ((_b = (_a = q) === null || _a === void 0 ? void 0 : _a.master) === null || _b === void 0 ? void 0 : _b.questionCode) === QuestionCodeEnum.GENERIC; })) === null || _e === void 0 ? void 0 : _e.master) === null || _f === void 0 ? void 0 : _f.questionDescription, answerGenericQuestion: answerGenericQuestion, setAnswerGenericQuestion: setAnswerGenericQuestion }),
        answerGenericQuestion === GenericQuestionAnswerTextEnum.NO && (React__default.createElement(QuestionsBadCondition, { questions: questionsBadCondition, questionContent: questionContent, answersBadCondition: answersBadCondition, setAnswersBadCondition: setAnswersBadCondition })),
        answersBadCondition && hasDeactivatedQuestion && (React__default.createElement(QuestionDeactivated, { answerDeactivated: answerDeactivated, setAnswerDeactivated: setAnswerDeactivated, question: questionDeactivated, questionContent: questionContent.find(function (q) { var _a, _b; return ((_b = (_a = q) === null || _a === void 0 ? void 0 : _a.master) === null || _b === void 0 ? void 0 : _b.questionCode) === QuestionCodeEnum.DEACTIVATED; }), deactivatedRef: deactivatedRef }))));
};

var loader = "Spinner_loader__Iiay6";
var loaderSvg = "Spinner_loader-svg__8RImA";
var path = "Spinner_path__bUbFt";
var loadingSpinner = "Spinner_loading-spinner__QAyLH";
var loadingSpinnerInner = "Spinner_loading-spinner-inner__o63Dg";
var loadingSpinnerOuter = "Spinner_loading-spinner-outer__EFfre";
var css_248z$e = ".Spinner_loader__Iiay6 {\n  flex-flow: column;\n  margin: 0 auto; }\n  .Spinner_loader__Iiay6 .Spinner_loader-svg__8RImA:not(:last-child) {\n    margin-bottom: 10px; }\n\n.Spinner_loader-svg__8RImA {\n  height: 42px; }\n\n[disabled] > .Spinner_loader__Iiay6 .Spinner_path__bUbFt,\n.disabled > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #ffffff;\n  opacity: 0.56; }\n\n.btn-primary-2:not([disabled]):not(.disabled) > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #f2f2f2; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .Spinner_loading-spinner__QAyLH {\n    animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n    transform-origin: center center; } }\n\n.Spinner_loading-spinner__QAyLH g {\n  animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n  transform-origin: center center; }\n\n.Spinner_loading-spinner-inner__o63Dg {\n  stroke-width: 3;\n  stroke: #878c94;\n  opacity: 0.25; }\n\n.Spinner_loading-spinner-outer__EFfre {\n  stroke-width: 3;\n  stroke-dasharray: 89, 200;\n  stroke-dashoffset: 0;\n  stroke: #009fdb;\n  animation: Spinner_loading-spinner-outer__EFfre 1.6875s ease-in-out infinite;\n  stroke-linecap: round; }\n\n@keyframes Spinner_loading-spinner__QAyLH {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes Spinner_loading-spinner-outer__EFfre {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n";
var Spinner = {"loader":"Spinner_loader__Iiay6","loader-svg":"Spinner_loader-svg__8RImA","path":"Spinner_path__bUbFt","loading-spinner":"Spinner_loading-spinner__QAyLH","loading-spinner-inner":"Spinner_loading-spinner-inner__o63Dg","loading-spinner-outer":"Spinner_loading-spinner-outer__EFfre","loaderSvg":"Spinner_loader-svg__8RImA","loadingSpinner":"Spinner_loading-spinner__QAyLH","loadingSpinnerInner":"Spinner_loading-spinner-inner__o63Dg","loadingSpinnerOuter":"Spinner_loading-spinner-outer__EFfre"};
const stylesheet$5=".Spinner_loader__Iiay6 {\n  flex-flow: column;\n  margin: 0 auto; }\n  .Spinner_loader__Iiay6 .Spinner_loader-svg__8RImA:not(:last-child) {\n    margin-bottom: 10px; }\n\n.Spinner_loader-svg__8RImA {\n  height: 42px; }\n\n[disabled] > .Spinner_loader__Iiay6 .Spinner_path__bUbFt,\n.disabled > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #ffffff;\n  opacity: 0.56; }\n\n.btn-primary-2:not([disabled]):not(.disabled) > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #f2f2f2; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .Spinner_loading-spinner__QAyLH {\n    animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n    transform-origin: center center; } }\n\n.Spinner_loading-spinner__QAyLH g {\n  animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n  transform-origin: center center; }\n\n.Spinner_loading-spinner-inner__o63Dg {\n  stroke-width: 3;\n  stroke: #878c94;\n  opacity: 0.25; }\n\n.Spinner_loading-spinner-outer__EFfre {\n  stroke-width: 3;\n  stroke-dasharray: 89, 200;\n  stroke-dashoffset: 0;\n  stroke: #009fdb;\n  animation: Spinner_loading-spinner-outer__EFfre 1.6875s ease-in-out infinite;\n  stroke-linecap: round; }\n\n@keyframes Spinner_loading-spinner__QAyLH {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes Spinner_loading-spinner-outer__EFfre {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n";
styleInject(css_248z$e);

var Spinner$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loader: loader,
    loaderSvg: loaderSvg,
    path: path,
    loadingSpinner: loadingSpinner,
    loadingSpinnerInner: loadingSpinnerInner,
    loadingSpinnerOuter: loadingSpinnerOuter,
    'default': Spinner,
    stylesheet: stylesheet$5
});

var styles$4 = /*@__PURE__*/getAugmentedNamespace(Spinner$1);

var Spinner_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });



var Spinner = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, onDark = _a.onDark, testId = _a.testId;
    var svg = (React__default.createElement("svg", __assign({ viewBox: "0 0 43 43", className: Join.join([className, styles$4.loadingSpinner, "flex", "flex-items-center"], styles$4.loaderSvg, styles$4.loader) }, (!children
        ? {
            style: style,
        }
        : {})),
        React__default.createElement("g", null,
            React__default.createElement("circle", { className: styles$4.loadingSpinnerInner, r: "20", cx: "21.5", cy: "21.5", fill: "none" }),
            React__default.createElement("circle", { className: styles$4.loadingSpinnerOuter, r: "20", cx: "21.5", cy: "21.5", fill: "none" }))));
    return children ? (React__default.createElement("div", { className: Join.join(className, styles$4.loader, "flex", "flex-items-center", "color-ui-dark-gray", onDark && "color-ui-gray"), "data-testid": testId, style: style },
        svg,
        React__default.createElement("span", { className: "type-sm-2 font-medium line-h-lg" }, children))) : (svg);
};
exports.default = Spinner;
});

var SpinnerProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
});

var Spinner$2 = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Spinner_1, exports);
__exportStar(SpinnerProps, exports);
var Spinner_1$1 = Spinner_1;
exports.default = Spinner_1$1.default;
});

var Spinner$3 = /*@__PURE__*/getDefaultExportFromCjs(Spinner$2);

var css_248z$f = "[class*=\" btn-\"] svg,\n[class^=\"btn-\"] svg {\n  height: 24px; }\n\n[class*=\" btn-\"] > *:not(.add-margin-right),\n[class^=\"btn-\"] > *:not(.add-margin-right) {\n  margin: 0 !important; }\n\n[class*=\" btn-\"] > .add-margin-right,\n[class^=\"btn-\"] > .add-margin-right {\n  margin: 0 16px 0 0; }\n\n[class*=\" btn-\"].btn-small svg,\n[class^=\"btn-\"].btn-small svg {\n  height: 18px; }\n\n[class*=\" btn-\"].btn-small .add-margin-right,\n[class^=\"btn-\"].btn-small .add-margin-right {\n  margin: 0 12px 0 0; }\n\n@media (max-width: 767px) {\n  [class*=\" btn-\"]:not(.btn-large) svg,\n  [class^=\"btn-\"]:not(.btn-large) svg {\n    height: 18px; }\n  [class*=\" btn-\"]:not(.btn-large) .add-margin-right,\n  [class^=\"btn-\"]:not(.btn-large) .add-margin-right {\n    margin: 0 12px 0 0; } }\n\n[class*=\" btn-\"][disabled] svg, [class*=\" btn-\"].disabled svg,\n[class^=\"btn-\"][disabled] svg,\n[class^=\"btn-\"].disabled svg {\n  fill: #878c94 !important; }\n\n.btn-primary svg,\n.btn-primary-2 svg {\n  fill: #ffffff; }\n\n.btn-secondary svg {\n  fill: #1d2329; }\n\n.btn-secondary:hover svg, .btn-secondary:focus svg {\n  fill: #ffffff; }\n\n.on-dark.btn-primary svg {\n  fill: #1d2329; }\n\n.on-dark.btn-primary-2 svg, .on-dark.btn-secondary svg {\n  fill: #ffffff; }\n\n.on-dark.btn-secondary:hover svg, .on-dark.btn-secondary:focus svg {\n  fill: #1d2329; }\n";
styleInject(css_248z$f);

var ButtonProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = exports.Kind = exports.Size = void 0;
var Size;
(function (Size) {
    /** Large at all viewport widths. */
    Size["large"] = "btn-large";
    /** Large on desktop and tablet viewport widths; small on mobile viewport widths. */
    Size["responsive"] = "";
    /** Small at all viewport widths. */
    Size["small"] = "btn-small";
})(Size = exports.Size || (exports.Size = {}));
var Kind;
(function (Kind) {
    /** Black on a light background; white on a dark background. */
    Kind["primaryBlack"] = "btn-primary";
    /** Blue on light and dark backgrounds. */
    Kind["primaryBlue"] = "btn-primary-2";
    /** White on a light background; black on a dark background. */
    Kind["secondary"] = "btn-secondary";
})(Kind = exports.Kind || (exports.Kind = {}));
var Classes;
(function (Classes) {
    /** Show the rightward arrow. */
    Classes["arrow"] = "btn-arrow";
    /** Span the width of its containing element. */
    Classes["fullWidth"] = "btn-full-width";
    Classes["icon"] = "add-margin-right";
})(Classes = exports.Classes || (exports.Classes = {}));
});

var Button_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });






/**
 * A CTA that looks like a button. Will use `<button>` or `<a>` under the hood depending on the functionality needed.
 */
var Button = BaseCta$3.MakeCtaFromBase(function (allProps) {
    var _a = Simplify.simplify(allProps), _b = _a.arrow, arrow = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.kind, kind = _d === void 0 ? "primaryBlack" : _d, _e = _a.size, size = _e === void 0 ? "responsive" : _e, _f = _a.spinner, spinner = _f === void 0 ? false : _f, props = __rest(_a, ["arrow", "icon", "fullWidth", "kind", "size", "spinner"]);
    var accessoryClass = allProps.children && "add-margin-right";
    return {
        prepend: spinner ? (React__default.createElement(Spinner$2.default, { "aria-hidden": Boolean(allProps.children), className: accessoryClass })) : (!arrow && icon),
        classes: [
            ButtonProps.Size[size],
            ButtonProps.Kind[kind],
            fullWidth && ButtonProps.Classes.fullWidth,
            !spinner && arrow && ButtonProps.Classes.arrow,
        ],
        props: __assign(__assign({}, props), { role: "button" }),
    };
});
exports.default = Button;
});

var Button = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Button_1, exports);
__exportStar(ButtonProps, exports);
var Button_1$1 = Button_1;
exports.default = Button_1$1.default;
});

var Button$1 = /*@__PURE__*/getDefaultExportFromCjs(Button);

var imageContainer = "DeviceDisplay-module_image-container__Ckhil";
var offerTextContainer = "DeviceDisplay-module_offer-text-container__GCZs3";
var container = "DeviceDisplay-module_container__mEKQP";
var css_248z$g = ".DeviceDisplay-module_image-container__Ckhil img {\n  max-width: 90px;\n  max-height: 90px; }\n\n.DeviceDisplay-module_offer-text-container__GCZs3 {\n  padding-left: 16px; }\n\n.DeviceDisplay-module_container__mEKQP {\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px; }\n";
styleInject(css_248z$g);

var DeviceDisplay = function (_a) {
    var selectedProductData = _a.selectedProductData, yourDeviceLabel = _a.yourDeviceLabel, make = _a.make;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: container },
            React__default.createElement("div", { className: imageContainer },
                React__default.createElement("img", { src: selectedProductData.image, alt: "" + selectedProductData.name })),
            React__default.createElement("div", { className: offerTextContainer },
                React__default.createElement("div", { className: "type-sm" }, yourDeviceLabel),
                React__default.createElement("div", { className: "type-base font-bold color-ui-black" }, make + " " + selectedProductData.name + " " + selectedProductData.capacity)))));
};

var container$1 = "PromotionDisplay-module_container__TEdq5";
var promotionSavingsPercentageContainer = "PromotionDisplay-module_promotion-savings-percentage-container__oUWHJ";
var marketValue = "PromotionDisplay-module_market-value__G4jD8";
var priceContainer = "PromotionDisplay-module_price-container__gQrvn";
var price = "PromotionDisplay-module_price__fsoSo";
var promotionDisplayHeader = "PromotionDisplay-module_promotion-display-header__AJz1d";
var requiredPlanContainer = "PromotionDisplay-module_required-plan-container__XrKQ0";
var warningIcon = "PromotionDisplay-module_warning-icon__AIZ8L";
var css_248z$h = ".PromotionDisplay-module_container__TEdq5 {\n  background-color: #F8FAFB;\n  border-radius: 0px 0px 14px 14px;\n  padding: 0 16px 16px 16px;\n  border-color: #DCDFE3;\n  border-style: none solid solid solid;\n  border-width: 1px; }\n\n.PromotionDisplay-module_promotion-savings-percentage-container__oUWHJ {\n  background-color: #BEEEFC;\n  margin-top: 24px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 14px 14px 0px 0px;\n  font-size: 12px; }\n\n.PromotionDisplay-module_market-value__G4jD8 {\n  text-decoration: line-through;\n  margin-left: 8px;\n  font-size: 12px;\n  color: #878C94; }\n  @media (min-width: 1025px) {\n    .PromotionDisplay-module_market-value__G4jD8 {\n      font-size: 14px; } }\n\n.PromotionDisplay-module_price-container__gQrvn {\n  padding-top: 4px;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline; }\n\n.PromotionDisplay-module_price__fsoSo {\n  font-weight: 700; }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .PromotionDisplay-module_price__fsoSo {\n      font-size: 28px; } }\n  @media (min-width: 1025px) {\n    .PromotionDisplay-module_price__fsoSo {\n      font-size: 34px; } }\n\n.PromotionDisplay-module_promotion-display-header__AJz1d {\n  font-size: 12px;\n  margin-bottom: 4px; }\n  @media (min-width: 1025px) {\n    .PromotionDisplay-module_promotion-display-header__AJz1d {\n      font-size: 14px; } }\n\n.PromotionDisplay-module_required-plan-container__XrKQ0 {\n  display: flex;\n  margin: 10px 2px; }\n\n.PromotionDisplay-module_warning-icon__AIZ8L {\n  width: 22.5px;\n  margin-right: 10px;\n  height: 22.5px; }\n  @media (max-width: 425px) {\n    .PromotionDisplay-module_warning-icon__AIZ8L svg {\n      max-width: 15px;\n      margin-right: 0px;\n      height: 15px; } }\n";
styleInject(css_248z$h);

var WarningIcon = function () {
    return (React__default.createElement(IconSVG, { ariaHidden: false, ariaLabel: "Warning", svgNodeStr: "<svg aria-label=\"info\" focusable=\"false\" role=\"img\" class=\"\" height=\"32\" width=\"32\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm1 22h-2V13h2zm0-12h-2V9h2z\"></path></svg>", colorClass: "color-cobalt" }));
};

var PromotionDisplay = function (_a) {
    var promotionDisplayHeader$1 = _a.promotionDisplayHeader, promotionDisplayMarketValueLabel = _a.promotionDisplayMarketValueLabel, promotionDisplayDisclaimer = _a.promotionDisplayDisclaimer, promotionDisplaySavingsPercentage = _a.promotionDisplaySavingsPercentage, value = _a.value, marketValue$1 = _a.marketValue, promotionOfferMsg = _a.promotionOfferMsg, showPromotionOfferMsg = _a.showPromotionOfferMsg;
    var _b, _c;
    var showMarketValue = useMemo(function () { return marketValue$1 !== value && marketValue$1; }, [marketValue$1, value]);
    var showDecimal = useMemo(function () {
        if (value !== Math.floor(value))
            return true;
        else
            return false;
    }, [value]);
    var showDecimalMarketValue = useMemo(function () {
        if (!showMarketValue)
            return false;
        if (marketValue$1 !== Math.floor(marketValue$1))
            return true;
        else
            return false;
    }, [showMarketValue, marketValue$1]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "font-medium color-ui-black " + promotionSavingsPercentageContainer }, promotionDisplaySavingsPercentage),
        React__default.createElement("div", { className: container$1 },
            React__default.createElement("div", { className: priceContainer },
                React__default.createElement("div", { className: price + " type-lg font-bold color-ui-black" }, "$" + (showDecimal ? (_b = value) === null || _b === void 0 ? void 0 : _b.toFixed(2) : value)),
                showMarketValue && (React__default.createElement("div", { className: marketValue + " type-sm font-regular" }, promotionDisplayMarketValueLabel + " $" + (showDecimalMarketValue ? (_c = marketValue$1) === null || _c === void 0 ? void 0 : _c.toFixed(2) : marketValue$1)))),
            React__default.createElement("div", { className: promotionDisplayHeader + " font-medium color-ui-black" }, promotionDisplayHeader$1),
            React__default.createElement("div", { className: 'type-xs font-regular' }, React__default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: purify.sanitize(promotionDisplayDisclaimer, {
                        ADD_ATTR: ['target'],
                    }),
                } })),
            showPromotionOfferMsg && (React__default.createElement("div", { className: requiredPlanContainer },
                React__default.createElement("div", { className: warningIcon },
                    React__default.createElement(WarningIcon, null)),
                React__default.createElement("div", null, promotionOfferMsg
                    ? promotionOfferMsg
                    : 'Reminder: Make sure you have an eligible unlimited plan to get this offer.'))))));
};

var svgSize = "ContextualMessage_svgSize__H5W-9";
var marginTop1 = "ContextualMessage_marginTop1__R-O-M";
var marginTop2 = "ContextualMessage_marginTop2__atHQZ";
var marginTop3 = "ContextualMessage_marginTop3__5ehq0";
var msgPadding = "ContextualMessage_msgPadding__MBR2T";
var msgMaxWidth = "ContextualMessage_msgMaxWidth__QGSVF";
var linkColor = "ContextualMessage_linkColor__WkJDO";
var css_248z$i = ".ContextualMessage_svgSize__H5W-9 svg {\n  height: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  width: 24px;\n  margin-right: 8px; }\n\n.ContextualMessage_marginTop1__R-O-M {\n  margin-top: 0; }\n\n.ContextualMessage_marginTop2__atHQZ {\n  margin-top: 1px; }\n\n.ContextualMessage_marginTop3__5ehq0 {\n  margin-top: -2px; }\n\n.ContextualMessage_msgPadding__MBR2T {\n  padding: 8px 0; }\n\n.ContextualMessage_msgMaxWidth__QGSVF {\n  max-width: 300px; }\n\n.ContextualMessage_linkColor__WkJDO {\n  color: #0057b8; }\n\n@media (max-width: 767px) {\n  .ContextualMessage_marginTop1__R-O-M {\n    margin-top: 1px; }\n  .ContextualMessage_marginTop2__atHQZ {\n    margin-top: 2px; }\n  .ContextualMessage_marginTop3__5ehq0 {\n    margin-top: -1px; } }\n";
var ContextualMessage = {"svgSize":"ContextualMessage_svgSize__H5W-9","marginTop1":"ContextualMessage_marginTop1__R-O-M","marginTop2":"ContextualMessage_marginTop2__atHQZ","marginTop3":"ContextualMessage_marginTop3__5ehq0","msgPadding":"ContextualMessage_msgPadding__MBR2T","msgMaxWidth":"ContextualMessage_msgMaxWidth__QGSVF","linkColor":"ContextualMessage_linkColor__WkJDO"};
const stylesheet$6=".ContextualMessage_svgSize__H5W-9 svg {\n  height: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  width: 24px;\n  margin-right: 8px; }\n\n.ContextualMessage_marginTop1__R-O-M {\n  margin-top: 0; }\n\n.ContextualMessage_marginTop2__atHQZ {\n  margin-top: 1px; }\n\n.ContextualMessage_marginTop3__5ehq0 {\n  margin-top: -2px; }\n\n.ContextualMessage_msgPadding__MBR2T {\n  padding: 8px 0; }\n\n.ContextualMessage_msgMaxWidth__QGSVF {\n  max-width: 300px; }\n\n.ContextualMessage_linkColor__WkJDO {\n  color: #0057b8; }\n\n@media (max-width: 767px) {\n  .ContextualMessage_marginTop1__R-O-M {\n    margin-top: 1px; }\n  .ContextualMessage_marginTop2__atHQZ {\n    margin-top: 2px; }\n  .ContextualMessage_marginTop3__5ehq0 {\n    margin-top: -1px; } }\n";
styleInject(css_248z$i);

var ContextualMessage$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    svgSize: svgSize,
    marginTop1: marginTop1,
    marginTop2: marginTop2,
    marginTop3: marginTop3,
    msgPadding: msgPadding,
    msgMaxWidth: msgMaxWidth,
    linkColor: linkColor,
    'default': ContextualMessage,
    stylesheet: stylesheet$6
});

var styles$5 = /*@__PURE__*/getAugmentedNamespace(ContextualMessage$1);

var ContextualMessage_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



/**
 * Note: For user-initiated alerts which occur most frequently at the top of page or section, please use the <a href="#/Atoms/Alert" class="rsg--link-45">Alert</a> component in the library.<br /><br />
 * Contextual messages occur on page load and are not user-initiated. They can be placed anywhere on the page but must be in close proximity to the relevant content and are usually placed inside a component, such as a card or a table. Contextual messages span the width of the container they are placed within.
 */
var ContextualMessage = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    return (React__default.createElement("div", { className: "flex flex-wrap justify-between rel", "data-testid": testId },
        React__default.createElement("div", { className: "flex flex-items-stretch " + styles$5.msgPadding },
            data.icon && React__default.createElement("span", { className: styles$5.svgSize }, data.icon),
            (data.text || options.showLink) && (React__default.createElement("span", { className: "color-ui-dark-gray mar-b-none " + (options.type === 2
                    ? " " + styles$5.marginTop2
                    : options.type === 3
                        ? " " + styles$5.marginTop3
                        : " " + styles$5.marginTop1) + (data.className ? " " + data.className : "") },
                React__default.createElement("span", { dangerouslySetInnerHTML: { __html: data.text } }),
                options.showLink && (React__default.createElement(Link.default, { className: styles$5.linkColor, kind: "textMedium", url: options.linkUrl }, options.link)))))));
};
exports.default = ContextualMessage;
});

var ContextualMessage$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ContextualMessage_1.default;
});

var ContextualMessage$3 = /*@__PURE__*/getDefaultExportFromCjs(ContextualMessage$2);

var message = "BaseContextualMessage-module_message__Lvepi";
var css_248z$j = ".BaseContextualMessage-module_message__Lvepi {\n  padding-top: 16px; }\n  @media (max-width: 425px) {\n    .BaseContextualMessage-module_message__Lvepi {\n      font-size: 16px; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .BaseContextualMessage-module_message__Lvepi {\n      font-size: 17px; } }\n  @media (min-width: 1025px) {\n    .BaseContextualMessage-module_message__Lvepi {\n      font-size: 18px; } }\n";
styleInject(css_248z$j);

var BaseContextualMessage = function (_a) {
    var svgUrl = _a.svgUrl, message$1 = _a.message, colorClassName = _a.colorClassName, altText = _a.altText;
    var icon = (React__default.createElement(IconSVG, { svgUrl: svgUrl, ariaLabel: altText, ariaHidden: false, className: "" + colorClassName }));
    return (React__default.createElement("div", { className: "" + message },
        React__default.createElement(ContextualMessage$3, { data: {
                text: message$1,
                icon: icon,
                className: 'flex flex-wrap justify-between rel',
            }, options: { type: 3 } })));
};

var generateAllGoodAnswers = function (hasDeactivatedQuestion, questionsBadCondition, questionDeactivated) {
    var answers = questionsBadCondition.map(function (question) {
        return question.validAnswers.find(function (answer) { return answer.answerText === GenericQuestionAnswerTextEnum.YES; });
    });
    if (hasDeactivatedQuestion) {
        var answerDeactivated = questionDeactivated.validAnswers.find(function (answer) { return answer.answerText === GenericQuestionAnswerTextEnum.YES; });
        answers.push(answerDeactivated);
    }
    return answers;
};

var offlineData = {"idp-cms-feed":{feedID:"fd165a9977061990ead107ee5e53b4eb",feedTimeStamp:"2023-08-10T22:59:41.302Z",docId:"84f96461-cf20-3cc3-86c0-5739ab59eb44",byodvalidator:{analytics:{lineOfBusiness:"General",_type:"scmsAnalytics"},seo:{_type:"scmsSeo",twittercard:"summary",metaRobots:"INDEX,FOLLOW",disableBreadCrumbs:false},release:"prod",configuration:{enablePersonalization:true,_type:"scmsConfig",pagePath:"/byodvalidator"},contentFragments:{errorList:{docId:"a98663c1-fe8e-3b41-8bbb-5596c6c40db1",_type:"scmsFragment",scmsCompId:"errorList",master:{errors:[{docId:"47de54fa-836c-3a68-907d-57a7c6eac15c",_type:"scmsFragment",scmsCompId:"lostOrStolen",master:{description:"This device has been reported to AT&T as lost or stolen and can’t be activated online. Call us at 800.331.0500 for more information.",errorId:"VI-CSIIMEIDB-1001",type:"modal",header:"Lost or stolen device",tryAgain:"Close",variationID:"47de54fa-836c-3a68-907d-57a7c6eac15c"}},{docId:"d91a26d6-541e-3100-a6c6-93ea16e0bd58",_type:"scmsFragment",scmsCompId:"deviceLocked",master:{description:"It looks like your replacement device is locked by another carrier. You will need to contact your current carrier to unlock.",errorId:"ERROR_DEVICECARRIER_lOCKED",type:"modal",header:"Your device is locked",tryAgain:"Close",variationID:"d91a26d6-541e-3100-a6c6-93ea16e0bd58"}},{docId:"7f7f4721-70d2-399f-b190-f6a95a48c861",_type:"scmsFragment",scmsCompId:"incompatible",master:{description:"Your device is not compatible with the AT&T network.",errorId:"devices-papi-validation-error-002",type:"modal",header:"Incompatible device",tryAgain:"Close",variationID:"7f7f4721-70d2-399f-b190-f6a95a48c861"}},{docId:"8bd8807b-db54-3feb-bf5b-ce2fb600e341",_type:"scmsFragment",scmsCompId:"maxentries",master:{errorId:"devices-papi-validation-error-003",type:"inline",header:"Max IMEI entries exceeded. Please wait 30 minutes and try again.",variationID:"8bd8807b-db54-3feb-bf5b-ce2fb600e341"}},{docId:"07055db9-2e6f-3cfc-8e52-e6617a897ecf",_type:"scmsFragment",scmsCompId:"firnetincompatible",master:{description:"To add a device on FirstNet, you can check another device's IMEI or shop for a new FirstNet-compatible device",errorId:"VALIDATE-IMEI-ERROR-001",type:"modal",header:"Sorry, your device isn’t FirstNet compatible",tryAgain:"Try another IMEI",variationID:"07055db9-2e6f-3cfc-8e52-e6617a897ecf"}},{docId:"579fc9d3-ee80-353e-bdbd-f589cc314068",_type:"scmsFragment",scmsCompId:"fnLostOrStolen",master:{description:"This device has been reported to AT&amp;T as lost or stolen and can’t be activated online. Please call FirstNet Support at 800.574.7000.",errorId:"VI-CSIIMEIDB-1001",type:"modal",header:"Lost or stolen device",tryAgain:"Try re-entering IMEI",page:"REPLACEMENT-DEVICE-ID",variationID:"579fc9d3-ee80-353e-bdbd-f589cc314068"}},{docId:"b20e3608-f93c-3140-ae75-ba65ad47a5cf",_type:"scmsFragment",scmsCompId:"firnetincompatible_pscbyodidentify",master:{description:"To add a device on FirstNet, please check another device’s IMEI. Or, you can add another device on the AT&T network instead.",errorId:"VALIDATE-IMEI-ERROR-001",type:"modal",header:"Sorry, your device isn’t FirstNet compatible",tryAgain:"Try another IMEI",support:"Add device on AT&T network",page:"PSC-BYOD-IDENTIFY",variationID:"b20e3608-f93c-3140-ae75-ba65ad47a5cf"}},{docId:"dcad6c79-9def-466a-9b75-59e9717395f4",_type:"scmsFragment",scmsCompId:"tradeInSameImeiSameOrder",master:{errorId:"devices-papi-user-error-002",type:"inline",header:"This IMEI is associated with another trade-in offer in your cart. Try entering a different device’s IMEI.",page:"tradeIn",variationID:"dcad6c79-9def-466a-9b75-59e9717395f4"}},{docId:"a1189c77-c2cc-4860-935c-c0d7c0c0a29b",_type:"scmsFragment",scmsCompId:"tradeInLostStolenCouNotInCat",master:{errorId:"devices-papi-user-error-001",type:"inline",header:"This device isn’t eligible for trade-in. If you’d like, you can try entering an IMEI for a different device.",page:"tradeIn",variationID:"a1189c77-c2cc-4860-935c-c0d7c0c0a29b"}},{docId:"a1189c77-c2cc-4860-935c-c0d7c0c0a29c",_type:"scmsFragment",scmsCompId:"tradeInSameImeiUsedDiffLineSameOrder",master:{errorId:"devices-papi-user-error-003",type:"inline",header:"This IMEI is associated with your existing trade-in offer. Want to trade in a different device? Enter the IMEI number for that device.",page:"tradeIn",variationID:"a1189c77-c2cc-4860-935c-c0d7c0c0a29c"}},{master:{errorId:"devices-papi-validation-error-017",type:"inline",header:"We're sorry, you can't trade in this device type for the new one you've selected.",page:"tradeIn",variationID:"9c7a263a-7594-3175-bbfc-e322d8faa5f9"}},{master:{errorId:"devices-papi-validation-error-016",type:"inline",header:"We're sorry, you can't trade in this device type for the new one you've selected.",page:"tradeIn",variationID:"9c7a263a-7594-3175-bbfc-e322d8faa5f9"}}],variationID:"a98663c1-fe8e-3b41-8bbb-5596c6c40db1"}},tradeIn:{docId:"cea43e14-a1f0-493a-9ca5-777583295f8d",_type:"scmsFragment",scmsCompId:"tradeIn",master:{header:"Enter device IMEI",headerCollapsed:"Enter device IMEI",subHeader:"Dial *#06* to see your IMEI number.",subHeaderPhone:"Dial *#06* to see your phone’s IMEI number.",subHeaderCollapsed:"Skip IMEI entry",inputPlaceholder:"Enter 15-digit IMEI",charWarning:"Enter all 15 digits of device IMEI number.",notFoundError:"IMEI not found. Please try re-entering.",buttonContinue:"Continue",buttonSkip:"Skip IMEI entry",variationID:"cea43e14-a1f0-493a-9ca5-777583295f8d"}}}}}};

var validateImeiTradeIn = function (imei, losgId, deviceSubType, useWomsValidateImeiApi) { return __awaiter(void 0, void 0, void 0, function () {
    var request, headers, imeiApi;
    return __generator(this, function (_a) {
        request = {
            imei: imei,
            mode: 'tradein',
            losgId: losgId && losgId,
            deviceSubType: deviceSubType && deviceSubType,
        };
        headers = { 'content-type': 'application/json' };
        imeiApi = useWomsValidateImeiApi
            ? '/msapi/wirelessorder/v1/activation/validateimei'
            : '/msapi/onlinesalesorchestration/devices-papi/v1/imei';
        return [2 /*return*/, fetch(imeiApi, {
                method: 'POST',
                body: JSON.stringify(request),
                headers: headers,
            })
                .then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                else {
                    throw response.json();
                }
            })
                .then(function (res) {
                return res;
            })
                .catch(function (err) {
                throw err;
            })];
    });
}); };
function makeRequest(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var complete = false;
                    var timeout = setTimeout(function () {
                        complete = true;
                        console.error("ByodValidator: Request timed out. URL: " + url);
                        reject('timed out');
                    }, 20000);
                    fetch(url, __assign({ mode: 'cors', headers: { 'Content-Type': 'application/json' } }, config))
                        .then(function (res) {
                        clearTimeout(timeout);
                        if (res && res.ok && !complete) {
                            return res.json();
                        }
                        reject(res.json());
                    })
                        .then(function (res) {
                        resolve(res);
                    });
                })];
        });
    });
}
/** Strip the various master layers from cmsfeed if necessary */
function purgeMasterLevels(obj) {
    if (!obj)
        return;
    if (obj.master) {
        Object.assign(obj, obj.master);
        delete obj.master;
    }
    var structure = typeof obj;
    switch (structure) {
        case 'number':
        case 'string':
        case 'boolean':
            return;
        default:
            Object.keys(obj).forEach(function (x) { return purgeMasterLevels(obj[x]); });
    }
}
/** Sort the error list so page specific errors show first */
function sortErrorList(obj) {
    var _a, _b;
    if ((_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.errorList) === null || _b === void 0 ? void 0 : _b.errors) {
        obj.errorList.errors = obj.errorList.errors.sort(function (a, b) {
            // sort returns -1/0/1 for shift up/none/down
            // if a has page, compare with b.page, else a undefined, none/down based on b
            return a.page ? a.page.localeCompare(b.page) : Number(!!b.page);
        });
    }
}
/** get and return the cleaned AEM CMS content for byod validator feed */
function getByodValidatorCms(setByodContent) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, makeRequest('/msapi/idp-content-orchestration/v1/idpcms/sales/wireless/byodvalidator', {
                    method: 'GET',
                })
                    .then(function (data) {
                    var _a, _b;
                    var byodData = (_b = (_a = data['idp-cms-feed']) === null || _a === void 0 ? void 0 : _a.byodvalidator) === null || _b === void 0 ? void 0 : _b.contentFragments;
                    purgeMasterLevels(byodData);
                    sortErrorList(byodData);
                    setByodContent(byodData);
                    return byodData;
                })
                    .catch(function (err) {
                    var _a, _b;
                    console.error("ByodValidator: IDP CMS byodvalidator API call failed, using static content");
                    var byodData = (_b = (_a = offlineData['idp-cms-feed']) === null || _a === void 0 ? void 0 : _a.byodvalidator) === null || _b === void 0 ? void 0 : _b.contentFragments;
                    purgeMasterLevels(byodData);
                    sortErrorList(byodData);
                    setByodContent(byodData);
                    throw err;
                })];
        });
    });
}

var ImeiContainer = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var displayedValue = props.displayedValue, count = props.count, cmsByodTradeIn = props.cmsByodTradeIn, purchasingDeviceType = props.purchasingDeviceType, loading = props.loading, validateError = props.validateError, setDisplayedValue = props.setDisplayedValue, handleChange = props.handleChange;
    var _g = useState(''), charWarningError = _g[0], setCharWarningError = _g[1];
    if (!cmsByodTradeIn)
        return null;
    var handleFocusChange = function (e) {
        var _a;
        if (e.target.value.length < count) {
            setCharWarningError((_a = cmsByodTradeIn) === null || _a === void 0 ? void 0 : _a.charWarning);
        }
    };
    var onChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleChange(e, count, setCharWarningError, setDisplayedValue)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var subHeader = purchasingDeviceType === DeviceTypeEnum.PHONE && ((_a = cmsByodTradeIn) === null || _a === void 0 ? void 0 : _a.subHeaderPhone)
        ? (_b = cmsByodTradeIn) === null || _b === void 0 ? void 0 : _b.subHeaderPhone : (_c = cmsByodTradeIn) === null || _c === void 0 ? void 0 : _c.subHeader;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", null,
            React__default.createElement("div", { className: "flex" },
                React__default.createElement("div", null,
                    React__default.createElement("p", { className: "type-sm mar-b-xs" }, subHeader))),
            React__default.createElement("div", null,
                React__default.createElement("div", { className: "rel mar-t-xxs mar-b-xxs" },
                    React__default.createElement("div", { className: "font-regular absolute right top", style: { fontSize: '11px', marginTop: '-20px' } }, (_d = displayedValue) === null || _d === void 0 ? void 0 :
                        _d.length,
                        "/",
                        count),
                    React__default.createElement("input", { placeholder: (_e = cmsByodTradeIn) === null || _e === void 0 ? void 0 : _e.inputPlaceholder, type: "text", pattern: "\\d*", maxLength: count, "aria-label": (_f = cmsByodTradeIn) === null || _f === void 0 ? void 0 : _f.inputPlaceholder, "aria-describedby": charWarningError || validateError ? 'input_error_content' : null, className: "height-lg-all pad-l-xxs pad-r-xxs width-full border" + (charWarningError || validateError ? '-error' : '-default'), onChange: onChange, onBlur: handleFocusChange, disabled: loading, value: displayedValue }),
                    loading && (React__default.createElement("div", { className: "absolute right top height-sm-all", style: { marginTop: '12px', marginRight: '12px' } },
                        React__default.createElement(Spinner$3, { className: "height-sm-all" })))),
                (charWarningError || validateError) && (React__default.createElement("p", { className: "type-sm color-functional-dk-red", id: "input_error_content", dangerouslySetInnerHTML: {
                        __html: purify.sanitize(charWarningError || validateError),
                    } }))))));
};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement$1,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$4 = has$3;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$4(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$3(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$3(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolvePathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link$2 = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    invariant_1(this.context.router, "You should not use <Link> outside a <Router>");

    invariant_1(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? createLocation(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return React__default.createElement("a", _extends$1({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(React__default.Component);

Link$2.propTypes = {
  onClick: propTypes.func,
  target: propTypes.string,
  replace: propTypes.bool,
  to: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired,
  innerRef: propTypes.oneOfType([propTypes.string, propTypes.func])
};
Link$2.defaultProps = {
  replace: false
};
Link$2.contextTypes = {
  router: propTypes.shape({
    history: propTypes.shape({
      push: propTypes.func.isRequired,
      replace: propTypes.func.isRequired,
      createHref: propTypes.func.isRequired
    }).isRequired
  }).isRequired
};

var content$1 = {
    PLAN_EDIT_TEXT: "Edit",
    ADD_TEXT: "Add"
};

var withContainer = function (children, expanded, label) {
    return (React__default.createElement("div", { className: "flex flex-items-center justify-between" },
        React__default.createElement("span", { className: "type-sm font-medium color-cobalt pad-r-xxs" }, label),
        children));
};
var withoutContainer = function (children, expanded, label) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { className: "type-sm font-medium color-cobalt pad-r-xxs" }, label),
        children));
};
var disabled = function (children) {
    return React__default.createElement(React__default.Fragment, null, children);
};
var EditLabel = function (_a) {
    var useContainer = _a.useContainer, children = _a.children, expanded = _a.expanded, expandCta = _a.expandCta, collapseCta = _a.collapseCta, useAdd = _a.useAdd, _b = _a.showEditLabel, showEditLabel = _b === void 0 ? true : _b;
    // The label for the edit cta should be to collapse it when it is expanded, and to expanded it when collapsed
    // We will fall back on the "edit" content previous versions used at all times,
    // but if an updated label is supplied it will be used here
    var label = expanded ? collapseCta || (useAdd ? content$1.ADD_TEXT : content$1.PLAN_EDIT_TEXT) : expandCta || (useAdd ? content$1.ADD_TEXT : content$1.PLAN_EDIT_TEXT);
    if (!showEditLabel) {
        return disabled(children);
    }
    if (showEditLabel && !!useContainer) {
        return withContainer(children, expanded, label);
    }
    if (showEditLabel && !useContainer) {
        return withoutContainer(children, expanded, label);
    }
};

function AccordionIcon(props) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { className: [
                'icon-chevron',
                (props.expanded ? 'rotate270 ' : 'rotate90'),
                'ease'
            ].join(' ') }),
        React__default.createElement("style", null, "\n            .ease{\n                transition: transform .2s ease 0s;\n            }\n        ")));
}

var RoundCard = function (props) {
    var header = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("h2", { id: props.aria + "-section", className: "type-base color-ui-black mar-b-none pad-r-xxxs line-h-md " + (props.isCollapsed && props.isSelected ? "" : "font-bold"), style: { width: '100%' }, tabIndex: 0 }, props.collapsedLabel && props.isCollapsed ? props.collapsedLabel : props.label),
        props.collapseEnabled &&
            React__default.createElement(EditLabel, { expanded: !props.isCollapsed, useContainer: false, expandCta: props.expandCta, collapseCta: props.collapseCta, useAdd: props.useAdd ? props.useAdd : false, showEditLabel: props.showEditLabel }, !props.useAdd && React__default.createElement(AccordionIcon, { expanded: !props.isCollapsed, "data-qa": props.dataQa + "-header-accordiontoggle" }))));
    var showDescriptionOnCollapse = (props.descriptionWhenSelected || !props.isSelected) && (props.collapsedDescription || props.description);
    var handleKeyDown = function (e) {
        if (e.key === 'Enter' && !e.repeat) {
            e.preventDefault();
            e.target.click();
        }
    };
    return (React__default.createElement("div", { className: "roundBorder " + props.className, style: props.style, "data-qa": "" + props.dataQa, id: props.aria + "-section" },
        props.isUpcoming ? (React__default.createElement("div", { className: "type-base color-ui-medium-gray" }, props.collapsedLabel ? props.collapsedLabel : props.label)) : (React__default.createElement(React__default.Fragment, null,
            typeof props.onAccordionClick === "function" ? (React__default.createElement("span", { className: "focusable type-base color-ui-black font-regular formfield-label pad-b-xs-lg " + (props.collapseEnabled && "cursor"), onClick: props.collapseEnabled && props.onAccordionClick, onKeyDown: handleKeyDown, role: "button", "aria-hidden": props.isUpcoming || !props.collapseEnabled ? "true" : "false", "aria-expanded": !props.isCollapsed, "aria-controls": props.aria + "-section", "aria-label": props.aria, "data-qa": props.dataQa + "-header" }, header)) : (React__default.createElement(Link$2, { to: props.onAccordionClick, style: { textDecoration: 'none' }, "aria-label": props.aria + " edit icon" },
                React__default.createElement("span", { className: "type-base color-ui-black font-regular formfield-label pad-b-xs-lg " + (props.collapseEnabled && "cursor"), "data-qa": props.dataQa + "-header" }, header))),
            props.isCollapsed &&
                React__default.createElement(React__default.Fragment, null,
                    showDescriptionOnCollapse &&
                        React__default.createElement("p", { className: "type-sm color-ui-black", "data-qa": props.dataQa + "-subheader" }, props.collapsedDescription || props.description),
                    !!props.collapsedContent &&
                        React__default.createElement("div", { className: "fullWidth text-left " + (showDescriptionOnCollapse && "mar-t-xs") },
                            React__default.createElement("div", { className: "flex fullWidth type-base color-ui-black mar-b-none " + (props.collapsedContentColumn && "flex-column") }, props.collapsedContent))),
            !props.isCollapsed &&
                React__default.createElement(React__default.Fragment, null,
                    props.description &&
                        React__default.createElement("p", { className: "type-sm color-ui-black", "data-qa": props.dataQa + "-subheader" }, props.description),
                    !!props.content && React__default.createElement("div", { className: props.description && "mar-t-xs" }, props.content)))),
        React__default.createElement("style", null, " \n                .roundBorder {\n                    background-color: #FFFFFF;\n                    border: 1px solid #DCDFE3;\n                    border-radius: 14px;\n                    padding: 24px 16px;\n                    margin-top: 24px;\n                }\n                .fullWidth {\n                    width: 100%;\n                }\n                .focusable:focus-within {\n                    outline: 1px dotted currentColor;\n                }\n            ")));
};

var ImeiValidator = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var buttonSize = props.buttonSize, cmsByodData = props.cmsByodData, _k = props.collapseImei, collapseImei = _k === void 0 ? false : _k, selectByImei = props.selectByImei, losgId = props.losgId, deviceSubType = props.deviceSubType, purchasingDeviceType = props.purchasingDeviceType, useWomsValidateImeiApi = props.useWomsValidateImeiApi, returnImeiResponse = props.returnImeiResponse, returnSkipImei = props.returnSkipImei, returnValidImei = props.returnValidImei, returnImeiValidation = props.returnImeiValidation;
    var sessionValidImeiData = sessionStorage.getItem('validImeiData');
    var validImeiData = sessionValidImeiData && JSON.parse(sessionValidImeiData);
    var cmsByodTradeIn = (_a = cmsByodData) === null || _a === void 0 ? void 0 : _a.tradeIn;
    var cmsByodErrors = (_c = (_b = cmsByodData) === null || _b === void 0 ? void 0 : _b.errorList) === null || _c === void 0 ? void 0 : _c.errors;
    var buttonRef = useRef();
    var valSelectByImei = selectByImei;
    var IMEI_LENGTH = 15;
    var _l = useState(''), displayedImei = _l[0], setDisplayedImei = _l[1];
    var _m = useState(''), imeiLabel = _m[0], setImeiLabel = _m[1];
    var _o = useState(collapseImei), imeiCollapse = _o[0], setImeiCollapse = _o[1];
    var _p = useState(true), continueButtonDisabled = _p[0], setContinueButtonDisabled = _p[1];
    var _q = useState((_d = validImeiData) === null || _d === void 0 ? void 0 : _d.validImeiNumber), imeiValue = _q[0], setImeiValue = _q[1];
    var _r = useState(false), loading = _r[0], setLoading = _r[1];
    var _s = useState(''), validateError = _s[0], setValidateError = _s[1];
    var _t = useState(), fetchedImeiResponse = _t[0], setFetchedImeiResponse = _t[1];
    // const [valSelectByImei, setValSelectByImei] = useState<boolean>(selectByImei);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (valSelectByImei &&
            ((_b = (_a = validImeiData) === null || _a === void 0 ? void 0 : _a.validImeiNumber) === null || _b === void 0 ? void 0 : _b.length) === IMEI_LENGTH && ((_c = validImeiData) === null || _c === void 0 ? void 0 : _c.validImeiRes)) {
            setDisplayedImei((_d = validImeiData) === null || _d === void 0 ? void 0 : _d.validImeiNumber);
            setFetchedImeiResponse(validImeiData.validImeiRes);
            setContinueButtonDisabled(false);
        }
    }, [(_e = validImeiData) === null || _e === void 0 ? void 0 : _e.validImeiNumber]);
    var runValidations = function (entered) { return __awaiter(void 0, void 0, void 0, function () {
        var validImeiRes, imeiStorageData, responseData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setContinueButtonDisabled(true);
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, validateImeiTradeIn(entered, losgId, deviceSubType, useWomsValidateImeiApi)];
                case 2:
                    validImeiRes = _a.sent();
                    setFetchedImeiResponse(validImeiRes);
                    setContinueButtonDisabled(false);
                    imeiStorageData = {
                        validImeiNumber: entered,
                        validImeiRes: validImeiRes,
                    };
                    window.sessionStorage.setItem('validImeiData', JSON.stringify(imeiStorageData));
                    responseData = {};
                    responseData.errorType = ErrorTypes.SUCCESS_ADMIT;
                    responseData.statusCode = 0;
                    responseData.statusMessage = 'SUCCESS';
                    responseData.successFlag = 1;
                    returnImeiValidation(responseData);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    Promise.resolve(e_1).then(function (err) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        setLoading(false);
                        window.sessionStorage.setItem('validImeiData', '');
                        // look for first matching error id - if applicable page specified, make sure it matches current page
                        var newError = (_a = cmsByodErrors) === null || _a === void 0 ? void 0 : _a.find(function (cmsError) {
                            var _a, _b;
                            return cmsError.errorId === ((_b = (_a = err) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errorId) &&
                                (!cmsError.page || cmsError.page === 'tradeIn');
                        });
                        if ((_b = newError) === null || _b === void 0 ? void 0 : _b.header) {
                            setValidateError((_c = newError) === null || _c === void 0 ? void 0 : _c.header);
                        }
                        else {
                            setValidateError((_d = cmsByodTradeIn) === null || _d === void 0 ? void 0 : _d.notFoundError);
                        }
                        var responseData = {};
                        responseData.errorType = ErrorTypes.FAILURE_DATA;
                        responseData.statusCode = -1;
                        responseData.statusMessage =
                            ((_e = newError) === null || _e === void 0 ? void 0 : _e.header) || ((_g = (_f = err) === null || _f === void 0 ? void 0 : _f.error) === null || _g === void 0 ? void 0 : _g.message) || 'System Error';
                        responseData.errorId = (_j = (_h = err) === null || _h === void 0 ? void 0 : _h.error) === null || _j === void 0 ? void 0 : _j.errorId;
                        responseData.successFlag = 0;
                        returnImeiValidation(responseData);
                    });
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    setImeiValue(entered);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e, count, setCharWarningError, setValue) { return __awaiter(void 0, void 0, void 0, function () {
        var entered;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // clear errors / warnings on change
                    setCharWarningError('');
                    setValidateError('');
                    setValue(e.target.value);
                    if (!e.target.checkValidity()) {
                        e.target.value = e.target.value.replaceAll(/[\D]/g, '');
                    }
                    entered = e.target.value;
                    setDisplayedImei(entered);
                    if (!(!count || entered.length === count)) return [3 /*break*/, 2];
                    return [4 /*yield*/, runValidations(entered)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setCharWarningError((_a = cmsByodTradeIn) === null || _a === void 0 ? void 0 : _a.charWarning);
                    setContinueButtonDisabled(true);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onImeiAccordionClick = function () {
        var _a, _b;
        valSelectByImei && !imeiCollapse && returnImeiResponse(undefined);
        setImeiCollapse(!imeiCollapse);
        setImeiLabel(!imeiCollapse ? (_a = cmsByodTradeIn) === null || _a === void 0 ? void 0 : _a.headerCollapsed : (_b = cmsByodTradeIn) === null || _b === void 0 ? void 0 : _b.header);
        returnSkipImei(!imeiCollapse, !imeiCollapse && 'collapse_imei', valSelectByImei && !imeiCollapse);
    };
    var skipImeiOnClick = function () {
        var _a;
        valSelectByImei && !imeiCollapse && returnImeiResponse(undefined);
        setImeiCollapse(!imeiCollapse);
        returnSkipImei(!imeiCollapse, (_a = cmsByodTradeIn) === null || _a === void 0 ? void 0 : _a.buttonSkip, valSelectByImei && !imeiCollapse);
        setValidateError('');
        setDisplayedImei('');
    };
    var onContinueButtonPress = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            setImeiCollapse(!imeiCollapse);
            returnSkipImei(!imeiCollapse);
            returnValidImei(imeiValue);
            returnImeiResponse &&
                fetchedImeiResponse &&
                returnImeiResponse(fetchedImeiResponse, AnalyticsEventType.CONTINUE_IMEI_CTA_PRESSED, (_a = cmsByodTradeIn) === null || _a === void 0 ? void 0 : _a.buttonContinue);
            return [2 /*return*/];
        });
    }); };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(RoundCard, { aria: "tradein-imei", collapsedContent: React__default.createElement("span", { className: "type-base font-bold" }, (_f = cmsByodTradeIn) === null || _f === void 0 ? void 0 : _f.subHeaderCollapsed), isCollapsed: imeiCollapse, collapseEnabled: true, onAccordionClick: onImeiAccordionClick, label: imeiLabel || ((_g = cmsByodTradeIn) === null || _g === void 0 ? void 0 : _g.header), isSelected: true, showEditLabel: false, content: React__default.createElement("div", null,
                React__default.createElement(ImeiContainer, { displayedValue: displayedImei, count: IMEI_LENGTH, cmsByodTradeIn: cmsByodTradeIn, purchasingDeviceType: purchasingDeviceType, setDisplayedValue: setDisplayedImei, handleChange: handleChange, loading: loading, validateError: validateError }),
                React__default.createElement("style", null, "\n                            .border-default, .border-error {\n                                border-radius: 8px;\n                                border: 1px solid #686E74;\n                            }\n                            .border-default:hover, .border-default:focus {\n                                border-color: #0057B8;\n                            }\n                            .border-default:disabled {\n                                background-color: #F8FAFB;\n                                border-color: #BDC2C7;\n                            }\n                            .border-error {\n                                border-color: #c70032 !important;\n                            }\n                            .color-functional-lt-gray {\n                                color: #C4C4C4;\n                            }\n                            [class*=\"color-functional-\"] > svg > path {\n                                fill: currentColor !important;\n                            }\n                            .round-border-sm {\n                                border-radius: 3px;\n                            }\n                            .radius-lg {\n                                border-radius: 1.6rem\n                            }\n                        ")) }),
        !imeiCollapse && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button$1, { kind: "primaryBlack", size: buttonSize, disabled: continueButtonDisabled, className: buttonAccept, onClick: onContinueButtonPress }, (_h = cmsByodTradeIn) === null || _h === void 0 ? void 0 : _h.buttonContinue),
            React__default.createElement(Button$1, { kind: "secondary", size: buttonSize, className: buttonDecline, onClick: skipImeiOnClick, ref: buttonRef }, (_j = cmsByodTradeIn) === null || _j === void 0 ? void 0 : _j.buttonSkip)))));
};

var PageEnum;
(function (PageEnum) {
    PageEnum[PageEnum["PAGE_SELECT_DEVICE"] = 1] = "PAGE_SELECT_DEVICE";
    PageEnum[PageEnum["PAGE_ANSWER_QUESTIONS"] = 2] = "PAGE_ANSWER_QUESTIONS";
})(PageEnum || (PageEnum = {}));
var TOTAL_NUMBER_PAGES = 2;
var SharedOffer = function (_a) {
    var events = _a.events, data = _a.data, campaignIdHeader = _a.campaignIdHeader, callHylaTradeinMuleApi = _a.callHylaTradeinMuleApi, mustSwitchPriceOption = _a.mustSwitchPriceOption, useWomsValidateImeiApi = _a.useWomsValidateImeiApi, _b = _a.isImeiMode, isImeiMode = _b === void 0 ? false : _b, losgId = _a.losgId;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var _r = useState(), content = _r[0], setContent = _r[1];
    var _s = useState(), byodContent = _s[0], setByodContent = _s[1];
    var _t = useState(), makesData = _t[0], setMakesData = _t[1];
    var _u = useState(), devicesData = _u[0], setDevicesData = _u[1];
    var _v = useState(true), showDeviceTypeSelector = _v[0], setShowDeviceTypeSelector = _v[1];
    var _w = useState(), selectedDeviceType = _w[0], setSelectedDeviceType = _w[1];
    var _x = useState(), selectedMakeData = _x[0], setSelectedMakeData = _x[1];
    var _y = useState(), selectedModelData = _y[0], setSelectedModelData = _y[1];
    var _z = useState(), selectedCapacity = _z[0], setSelectedCapacity = _z[1];
    var _0 = useState(), selectedProductData = _0[0], setSelectedProductData = _0[1];
    var _1 = useState(), questionsBadCondition = _1[0], setQuestionsBadCondition = _1[1];
    var _2 = useState(), questionDeactivated = _2[0], setQuestionDeactivated = _2[1];
    var _3 = useState(), questionAnswers = _3[0], setQuestionAnswers = _3[1];
    var _4 = useState(), currentPage = _4[0], setCurrentPage = _4[1];
    var _5 = useState(true), continueButtonDisabled = _5[0], setContinueButtonDisabled = _5[1];
    var _6 = useState(false), showError = _6[0], setShowError = _6[1];
    var _7 = useState(false), showSpinner = _7[0], setShowSpinner = _7[1];
    var _8 = useState(), imeiResponse = _8[0], setImeiResponse = _8[1];
    var _9 = useState(false), skipImei = _9[0], setSkipImei = _9[1];
    var _10 = useState('small'), buttonSize = _10[0], setbuttonSize = _10[1];
    var _11 = useState(), imeiNumber = _11[0], setImeiNumber = _11[1];
    var _12 = useState(false), collapseImei = _12[0], setCollapseImei = _12[1];
    var _13 = useState(true), selectByImei = _13[0], setSelectByImei = _13[1];
    var _14 = useState(CurrentStageEnum.SELECT_DEVICE_TYPE), currentStage = _14[0], setCurrentStage = _14[1];
    var _15 = useState(), answerGenericQuestion = _15[0], setAnswerGenericQuestion = _15[1];
    var makeRef = useRef();
    var modelRef = useRef();
    var modelInputRef = useRef();
    var capacityRef = useRef();
    var buttonRef = useRef();
    useEffect(function () {
        sessionStorage.removeItem('validImeiData');
        var handleResize = function () {
            if (window.innerWidth > 768) {
                setbuttonSize('large');
            }
            else {
                setbuttonSize('small');
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    var _16 = useState(), hylaResponse = _16[0], setHylaResponse = _16[1];
    var sendError = useCallback(function (reason) {
        var errorData = {
            errorType: reason,
        };
        events.onError(errorData);
    }, [events]);
    var sendAnalyticsEvent = useCallback(function (eventType, linkName, formResponseData) {
        var _a;
        var eventData = {
            eventType: eventType,
        };
        if (linkName) {
            eventData.linkName = linkName;
        }
        if (formResponseData) {
            eventData.formResponseData = formResponseData;
        }
        if ((_a = events) === null || _a === void 0 ? void 0 : _a.onAnalyticsEvent) {
            events.onAnalyticsEvent(eventData);
        }
    }, [events]);
    var onImeiValidationResponse = function (formResponseData) {
        sendAnalyticsEvent(AnalyticsEventType.IMEI_VALIDATION, '', formResponseData);
    };
    var declineOffer = function () {
        var tradeInValues = {
            sku: data.skuId,
            status: SharedOfferModalStatus.DECLINE,
            linkName: content.buttonDecline,
            purchasingDeviceType: data.purchasingDeviceType,
        };
        if (answerGenericQuestion && currentPage === PageEnum.PAGE_ANSWER_QUESTIONS) {
            var isGoodCondition = answerGenericQuestion === GenericQuestionAnswerTextEnum.YES;
            var tradeInDeviceCondition = isGoodCondition
                ? ReportingDeviceCondition.GOOD
                : ReportingDeviceCondition.BAD;
            tradeInValues.tradeInDeviceCondition = tradeInDeviceCondition;
        }
        events.onOfferDecision(tradeInValues);
    };
    var getDeviceType = function (deviceSubType) {
        var deviceType = '';
        switch (deviceSubType) {
            case 'pda':
            case 'smartphone':
                return (deviceSubType = DeviceTypeEnum.PHONE);
            case 'tablet':
                return (deviceSubType = DeviceTypeEnum.TABLET);
            case 'wearable':
                return (deviceSubType = DeviceTypeEnum.WEARABLE);
        }
        return deviceType;
    };
    useEffect(function () {
        if (currentPage === PageEnum.PAGE_ANSWER_QUESTIONS) {
            sendAnalyticsEvent(AnalyticsEventType.PAGE_LOAD_ANSWER_QUESTIONS);
        }
        else if (currentPage === PageEnum.PAGE_SELECT_DEVICE) {
            sendAnalyticsEvent(AnalyticsEventType.PAGE_LOAD_SELECT_DEVICE);
        }
    }, [currentPage, sendAnalyticsEvent]);
    // check to see if purchasingDeviceType is Phone
    useEffect(function () {
        var _a;
        if (((_a = data) === null || _a === void 0 ? void 0 : _a.purchasingDeviceType) === DeviceTypeEnum.PHONE) {
            setSelectedDeviceType(DeviceTypeEnum.PHONE);
            setShowDeviceTypeSelector(false);
        }
    }, [(_c = data) === null || _c === void 0 ? void 0 : _c.purchasingDeviceType]);
    // check for preSelectedDevice or imeiResponse and set state accordingly
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
        if (content && devicesData) {
            var preSelectedDevice = (_a = data) === null || _a === void 0 ? void 0 : _a.preSelectedDevice;
            if (preSelectedDevice || imeiResponse) {
                var typeName_1, makeName_1, modelName_1, capacity_1;
                if (isImeiMode && imeiResponse) {
                    typeName_1 =
                        getDeviceType((_b = imeiResponse.deviceSubType) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || ((_c = data) === null || _c === void 0 ? void 0 : _c.purchasingDeviceType);
                    makeName_1 = (_d = imeiResponse.make) === null || _d === void 0 ? void 0 : _d.toLowerCase();
                    modelName_1 = (_e = imeiResponse.model) === null || _e === void 0 ? void 0 : _e.toLowerCase();
                    var imeiCapacity = imeiResponse.capacity.replace(' ', '');
                    capacity_1 = imeiCapacity.toLowerCase();
                }
                else if (preSelectedDevice) {
                    typeName_1 = (_h = (_g = (_f = preSelectedDevice) === null || _f === void 0 ? void 0 : _f.product) === null || _g === void 0 ? void 0 : _g.type) === null || _h === void 0 ? void 0 : _h.toLowerCase();
                    makeName_1 = (_l = (_k = (_j = preSelectedDevice) === null || _j === void 0 ? void 0 : _j.product) === null || _k === void 0 ? void 0 : _k.make) === null || _l === void 0 ? void 0 : _l.toLowerCase();
                    modelName_1 = (_p = (_o = (_m = preSelectedDevice) === null || _m === void 0 ? void 0 : _m.product) === null || _o === void 0 ? void 0 : _o.productFamily) === null || _p === void 0 ? void 0 : _p.toLowerCase();
                    capacity_1 = (_s = (_r = (_q = preSelectedDevice) === null || _q === void 0 ? void 0 : _q.product) === null || _r === void 0 ? void 0 : _r.capacity) === null || _s === void 0 ? void 0 : _s.toLowerCase();
                }
                // make sure typename exists and is apart of the Enum
                if (!typeName_1 ||
                    !Object.values(DeviceTypeEnum).includes(typeName_1)) {
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    setCurrentStage(CurrentStageEnum.SELECT_DEVICE_TYPE);
                    return;
                }
                setSelectedDeviceType(typeName_1);
                var devicesDataType = (_t = devicesData) === null || _t === void 0 ? void 0 : _t.find(function (i) { var _a, _b; return ((_b = (_a = i) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === typeName_1; });
                if (!((_u = devicesDataType) === null || _u === void 0 ? void 0 : _u.makes) || !((_v = devicesDataType) === null || _v === void 0 ? void 0 : _v.otherMakes)) {
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    setCurrentStage(CurrentStageEnum.SELECT_DEVICE_TYPE);
                    return;
                }
                var makes = devicesDataType.makes;
                var otherMakes = devicesDataType.otherMakes;
                // dont need to set makes data because it is handled by effect
                if (!makeName_1) {
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    setCurrentStage(CurrentStageEnum.SELECT_MAKE);
                    return;
                }
                var preSelectedMakeData = (_w = makes) === null || _w === void 0 ? void 0 : _w.find(function (i) { var _a, _b; return ((_b = (_a = i) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === makeName_1; });
                var preSelectedOtherMakeData = (_x = otherMakes) === null || _x === void 0 ? void 0 : _x.find(function (i) { var _a, _b; return ((_b = (_a = i) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === makeName_1; });
                if (preSelectedMakeData) {
                    setSelectedMakeData(preSelectedMakeData);
                }
                else if (preSelectedOtherMakeData) {
                    setSelectedMakeData(preSelectedOtherMakeData);
                }
                else {
                    setCurrentStage(CurrentStageEnum.SELECT_MAKE);
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    return;
                }
                if (!modelName_1) {
                    setCurrentStage(CurrentStageEnum.SELECT_MODEL);
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    return;
                }
                var preSelectedModelData = (_z = (_y = preSelectedMakeData) === null || _y === void 0 ? void 0 : _y.models) === null || _z === void 0 ? void 0 : _z.find(function (i) { var _a, _b; return ((_b = (_a = i) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === modelName_1; });
                var preSelectedOtherModelData = (_1 = (_0 = preSelectedOtherMakeData) === null || _0 === void 0 ? void 0 : _0.models) === null || _1 === void 0 ? void 0 : _1.find(function (i) { var _a, _b; return ((_b = (_a = i) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === modelName_1; });
                if (!preSelectedModelData && !preSelectedOtherModelData) {
                    setCurrentStage(CurrentStageEnum.SELECT_MODEL);
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    return;
                }
                setSelectedModelData(preSelectedModelData ? preSelectedModelData : preSelectedOtherModelData);
                if (!capacity_1) {
                    setCurrentStage(CurrentStageEnum.SELECT_CAPACITY);
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    isImeiMode && setSkipImei(true);
                    return;
                }
                var preSelectedProductData = (_3 = (_2 = preSelectedModelData) === null || _2 === void 0 ? void 0 : _2.productFamily) === null || _3 === void 0 ? void 0 : _3.find(function (i) { var _a; return ((_a = i.capacity) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === capacity_1; });
                var preSelectedOtherProductData = (_5 = (_4 = preSelectedOtherModelData) === null || _4 === void 0 ? void 0 : _4.productFamily) === null || _5 === void 0 ? void 0 : _5.find(function (i) { var _a; return ((_a = i.capacity) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === capacity_1; });
                if (!preSelectedProductData && !preSelectedOtherProductData) {
                    setCurrentStage(CurrentStageEnum.SELECT_CAPACITY);
                    setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
                    return;
                }
                if (preSelectedProductData) {
                    setSelectedProductData(preSelectedProductData);
                    setSelectedCapacity((_6 = preSelectedProductData) === null || _6 === void 0 ? void 0 : _6.capacity);
                }
                else {
                    setSelectedProductData(preSelectedOtherProductData);
                    setSelectedCapacity((_7 = preSelectedOtherProductData) === null || _7 === void 0 ? void 0 : _7.capacity);
                }
                // if we hit this point we should start on 2nd page
                setCurrentPage(PageEnum.PAGE_ANSWER_QUESTIONS);
                isImeiMode && setSkipImei(true);
                if (!((_8 = preSelectedDevice) === null || _8 === void 0 ? void 0 : _8.tradeInDeviceCondition)) {
                    setCurrentStage(CurrentStageEnum.SELECT_QUESTION_ANSWERS);
                    return;
                }
                if (preSelectedDevice.tradeInDeviceCondition === ReportingDeviceCondition.GOOD) {
                    setAnswerGenericQuestion(GenericQuestionAnswerTextEnum.YES);
                    setCurrentStage(CurrentStageEnum.HYLA_CALL);
                    return;
                }
                else {
                    setAnswerGenericQuestion(GenericQuestionAnswerTextEnum.NO);
                }
                if ((_9 = preSelectedDevice) === null || _9 === void 0 ? void 0 : _9.questionAnswers) {
                    setQuestionAnswers(preSelectedDevice.questionAnswers);
                }
                else {
                    setCurrentStage(CurrentStageEnum.SELECT_QUESTION_ANSWERS);
                    return;
                }
                setCurrentStage(CurrentStageEnum.HYLA_CALL);
            }
            else {
                setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
            }
        }
    }, [(_d = data) === null || _d === void 0 ? void 0 : _d.preSelectedDevice, content, devicesData, imeiResponse]);
    // when a device type is selected we need to load in the corresponding data
    useEffect(function () {
        if (devicesData && selectedDeviceType) {
            var deviceTypeData = devicesData.find(function (i) {
                return i.category === selectedDeviceType;
            });
            setMakesData({ makes: deviceTypeData.makes, otherMakes: deviceTypeData.otherMakes });
            var unsortedQuestions = deviceTypeData.questions.filter(function (i) {
                return (i.questionCode !== QuestionCodeEnum.GENERIC &&
                    i.questionCode !== QuestionCodeEnum.DEACTIVATED);
            });
            setQuestionsBadCondition(unsortedQuestions.sort(function (firstEl, secondEl) { return firstEl.sortOrder - secondEl.sortOrder; }));
            setQuestionDeactivated(deviceTypeData.questions.find(function (i) {
                return i.questionCode === QuestionCodeEnum.DEACTIVATED;
            }));
        }
    }, [selectedDeviceType, devicesData]);
    // update state depending on current stage of modal
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // reset state of elements in case we are moving backwards
        if (currentStage <= CurrentStageEnum.SELECT_QUESTION_ANSWERS) {
            setQuestionAnswers(undefined);
            setAnswerGenericQuestion(undefined); // default to yes
        }
        if (currentStage <= CurrentStageEnum.SELECT_CAPACITY) {
            setContinueButtonDisabled(true);
            setSelectedCapacity(undefined);
        }
        if (currentStage <= CurrentStageEnum.SELECT_MODEL) {
            setSelectedModelData(undefined);
        }
        if (currentStage <= CurrentStageEnum.SELECT_MAKE) {
            setSelectedMakeData(undefined);
        }
        if (currentStage >= CurrentStageEnum.SELECT_QUESTION_ANSWERS) {
            setContinueButtonDisabled(false);
        }
        switch (currentStage) {
            case CurrentStageEnum.SELECT_CAPACITY:
                (_b = (_a = capacityRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
                break;
            case CurrentStageEnum.SELECT_MAKE:
                (_d = (_c = makeRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.scrollIntoView();
                break;
            case CurrentStageEnum.SELECT_MODEL:
                (_f = (_e = modelRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.scrollIntoView();
                var preventDefault = function () { return null; };
                var e = {
                    preventDefault: preventDefault,
                };
                (_h = (_g = modelInputRef) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.clearInput(e);
                break;
        }
    }, [currentStage]);
    useEffect(function () {
        if (answerGenericQuestion === GenericQuestionAnswerTextEnum.NO &&
            hylaResponse &&
            !questionAnswers)
            setHylaResponse(undefined);
    }, [answerGenericQuestion, hylaResponse, questionAnswers]);
    useEffect(function () {
        loadDataConfig(setDevicesData, sendError, setShowError);
        loadCMSContent(setContent);
        if (isImeiMode) {
            getByodValidatorCms(setByodContent);
        }
    }, [events, sendError]);
    var onContinueButtonPress = function () {
        sendAnalyticsEvent(AnalyticsEventType.CONTINUE_CTA_PRESSED, content.buttonContinue);
        setCurrentPage(PageEnum.PAGE_ANSWER_QUESTIONS);
    };
    var hasDeactivatedQuestion = useMemo(function () {
        var _a, _b;
        return !!((_b = (_a = selectedProductData) === null || _a === void 0 ? void 0 : _a.questions) === null || _b === void 0 ? void 0 : _b.find(function (i) { return i.code === QuestionCodeEnum.DEACTIVATED; }));
    }, [selectedProductData]);
    var acceptOffer = function () {
        var isGoodCondition = answerGenericQuestion === GenericQuestionAnswerTextEnum.YES;
        var tradeInDeviceCondition = isGoodCondition
            ? ReportingDeviceCondition.GOOD
            : ReportingDeviceCondition.BAD;
        var selectedQuestionAnswers = questionAnswers;
        if (isGoodCondition) {
            selectedQuestionAnswers = generateAllGoodAnswers(hasDeactivatedQuestion, questionsBadCondition, questionDeactivated);
        }
        var tradeInValues = {
            modelPrice: isGoodCondition
                ? selectedProductData.modelPrice
                : hylaResponse.hylaMarketValue,
            hylaDiscountAmount: hylaResponse.hylaDiscountAmount,
            purchasingDeviceType: data.purchasingDeviceType,
            make: selectedMakeData.name,
            type: selectedDeviceType,
            productFamily: selectedModelData.name,
            image: selectedProductData.image,
            offerCode: hylaResponse.hylaOfferCode,
            sku: data.skuId,
            modelCode: selectedProductData.modelCode,
            status: SharedOfferModalStatus.ACCEPT,
            capacity: selectedProductData.capacity,
            questionAnswers: selectedQuestionAnswers,
            isHYLATradeIn: hylaResponse.offerType === OfferType.NORMAL,
            isHYLAReward: hylaResponse.offerType === OfferType.GENERIC,
            linkName: content.buttonAccept,
            tradeInDeviceCondition: tradeInDeviceCondition,
            imei: imeiNumber,
        };
        events.onOfferDecision(tradeInValues);
    };
    var onErrorButtonClick = function () {
        var errorData = {
            status: SharedOfferModalStatus.DATAFAILED,
            linkName: content.buttonError,
            sku: data.skuId,
            purchasingDeviceType: data.purchasingDeviceType,
        };
        events.onOfferDecision(errorData);
    };
    var onBackButtonClick = function () {
        if (showError)
            setShowError(false);
        if (isImeiMode && selectByImei) {
            setSkipImei(false);
            setCollapseImei(false);
        }
        else if (isImeiMode && !selectByImei) {
            setSkipImei(true);
            setCollapseImei(true);
        }
        setCurrentStage(CurrentStageEnum.SELECT_QUESTION_ANSWERS);
        setCurrentPage(PageEnum.PAGE_SELECT_DEVICE);
    };
    var getWirelessPromotion = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, offerType, e_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    setCurrentStage(CurrentStageEnum.HYLA_CALL);
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    setShowSpinner(true);
                    formData = {
                        tradeInValue: selectedProductData.modelPrice,
                        productId: data.productId,
                        modelCode: selectedProductData.modelCode,
                        skuId: data.skuId,
                        losgTypes: data.losgTypes,
                        tradeInModel: selectedModelData.name,
                        offerTypes: 'tradein',
                    };
                    if (answerGenericQuestion === GenericQuestionAnswerTextEnum.NO) {
                        formData.questions = questionAnswers;
                    }
                    return [4 /*yield*/, getHylaOffer({
                            formData: formData,
                            isGoodCondition: answerGenericQuestion === GenericQuestionAnswerTextEnum.YES,
                            promotions: (_a = selectedProductData) === null || _a === void 0 ? void 0 : _a.promotions,
                            campaignIdHeader: campaignIdHeader,
                            callHylaTradeinMuleApi: callHylaTradeinMuleApi,
                        })];
                case 2:
                    response = _k.sent();
                    if (!response.success) {
                        throw Error('Failed to retrieve hyla');
                    }
                    offerType = ((_c = (_b = response) === null || _b === void 0 ? void 0 : _b.offer) === null || _c === void 0 ? void 0 : _c.promoType) === OfferType.GENERIC
                        ? OfferType.GENERIC
                        : OfferType.NORMAL;
                    setHylaResponse({
                        offerType: offerType,
                        hylaDiscountAmount: (_e = (_d = response) === null || _d === void 0 ? void 0 : _d.offer) === null || _e === void 0 ? void 0 : _e.discount,
                        hylaOfferCode: (_g = (_f = response) === null || _f === void 0 ? void 0 : _f.offer) === null || _g === void 0 ? void 0 : _g.hylaOfferCode,
                        hylaMarketValue: (_j = (_h = response) === null || _h === void 0 ? void 0 : _h.offer) === null || _j === void 0 ? void 0 : _j.hylaMarketValue,
                    });
                    setShowSpinner(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _k.sent();
                    setShowSpinner(false);
                    setShowError(true);
                    sendError(ErrorTypeEnum.API_ERROR);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [data, questionAnswers, selectedProductData, sendError, answerGenericQuestion]);
    useEffect(function () {
        var _a, _b;
        setShowError(false); // remove error display if shown
        setHylaResponse(undefined);
        // dont make call if we aren't ready
        if (!selectedProductData)
            return;
        if (currentPage !== PageEnum.PAGE_ANSWER_QUESTIONS)
            return;
        if (!questionsBadCondition)
            return;
        // Dont proceed if we are missing the question answers, questions while the answer to the generic question isn't yes
        if ((!questionsBadCondition || !questionAnswers) &&
            answerGenericQuestion !== GenericQuestionAnswerTextEnum.YES) {
            return;
        }
        // If we have answers to the questions but the answer to the generic is yes dont proceed, wait for state to be correct
        if (questionAnswers && answerGenericQuestion === GenericQuestionAnswerTextEnum.YES)
            return;
        var completedQuestionLength = hasDeactivatedQuestion
            ? ((_a = questionsBadCondition) === null || _a === void 0 ? void 0 : _a.length) + 1
            : (_b = questionsBadCondition) === null || _b === void 0 ? void 0 : _b.length;
        if (answerGenericQuestion === GenericQuestionAnswerTextEnum.YES ||
            completedQuestionLength === questionAnswers.length) {
            getWirelessPromotion();
        }
    }, [
        questionAnswers,
        getWirelessPromotion,
        hasDeactivatedQuestion,
        questionsBadCondition,
        answerGenericQuestion,
        selectedProductData,
        currentPage,
    ]);
    var promotionSavingsPercentageText = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        var purchasingDeviceMSRP = data.purchasingDeviceMSRP;
        if (((_a = hylaResponse) === null || _a === void 0 ? void 0 : _a.offerType) === OfferType.NORMAL &&
            purchasingDeviceMSRP > 0 &&
            ((_b = hylaResponse) === null || _b === void 0 ? void 0 : _b.hylaDiscountAmount) !== undefined) {
            if (((_c = hylaResponse) === null || _c === void 0 ? void 0 : _c.hylaDiscountAmount) >= purchasingDeviceMSRP) {
                return ((_d = content) === null || _d === void 0 ? void 0 : _d.promotionDisplayOptionFreeDevice) ? content.promotionDisplayOptionFreeDevice
                    : 'Trade in and get a FREE new device';
            }
            else {
                var savingsPercentage = Math.floor((100 * hylaResponse.hylaDiscountAmount) / purchasingDeviceMSRP);
                return ((_e = content) === null || _e === void 0 ? void 0 : _e.promotionDisplayOptionSavingsPercentage) ? content.promotionDisplayOptionSavingsPercentage.replace('[[savings percentage]]', "" + savingsPercentage)
                    : "Save " + savingsPercentage + "% on your new device";
            }
        }
        return ((_f = content) === null || _f === void 0 ? void 0 : _f.promotionDisplayOptionNoPercentage) ? content.promotionDisplayOptionNoPercentage
            : 'Trade in and save on your new device';
    }, [hylaResponse, data, content]);
    var onIMEIResponse = function (imeiValResponse, eventType, linkName) {
        setImeiResponse(imeiValResponse);
        eventType && linkName && sendAnalyticsEvent(eventType, linkName);
    };
    var onSkipImei = function (isSkipImei, linkName, clearSelectedData) {
        isSkipImei && linkName ? setSelectByImei(false) : setSelectByImei(true);
        linkName && sendAnalyticsEvent(AnalyticsEventType.SKIP_IMEI_CTA_PRESSED, linkName);
        if (clearSelectedData) {
            setSelectedMakeData(undefined);
            setSelectedModelData(undefined);
            setSelectedCapacity(undefined);
            setContinueButtonDisabled(true);
        }
        setSkipImei(isSkipImei);
    };
    var onValidImei = function (validImei) {
        setImeiNumber(validImei);
    };
    var selectDeviceHeading = ((_e = data) === null || _e === void 0 ? void 0 : _e.purchasingDeviceType) === DeviceTypeEnum.PHONE && ((_f = content) === null || _f === void 0 ? void 0 : _f.headingPhone)
        ? (_g = content) === null || _g === void 0 ? void 0 : _g.headingPhone : (_h = content) === null || _h === void 0 ? void 0 : _h.heading;
    return content ? (React__default.createElement("div", { id: "sharedoffer-component" },
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { id: "sharedoffer-content", className: allContent + " " + boxContainer },
                React__default.createElement(Header, { heading: showError
                        ? content.errorHeading
                        : currentPage === PageEnum.PAGE_ANSWER_QUESTIONS
                            ? content.headingDeviceCondition
                            : selectDeviceHeading, subHeading: showError ||
                        currentPage === PageEnum.PAGE_ANSWER_QUESTIONS ||
                        isImeiMode
                        ? ''
                        : content.subHeading, deviceName: (_j = data) === null || _j === void 0 ? void 0 : _j.deviceName, currentPage: currentPage, numberOfPages: TOTAL_NUMBER_PAGES, backButtonContent: showError ? (_k = content) === null || _k === void 0 ? void 0 : _k.backButtonContentError : content.backButtonContent, onBackButtonClick: onBackButtonClick, backButtonVisible: currentPage === PageEnum.PAGE_ANSWER_QUESTIONS }),
                showError ? (React__default.createElement(BaseContextualMessage, { message: content.errorMessage, svgUrl: content.errorMessageSVG, altText: content.errorMessageSVGAltText, colorClassName: "color-functional-dk-red" })) : (React__default.createElement("div", null,
                    isImeiMode && currentPage === PageEnum.PAGE_SELECT_DEVICE && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("div", null,
                            React__default.createElement(ImeiValidator, { cmsByodData: byodContent, buttonSize: buttonSize, collapseImei: collapseImei, selectByImei: selectByImei, returnImeiResponse: onIMEIResponse, returnSkipImei: onSkipImei, returnValidImei: onValidImei, returnImeiValidation: onImeiValidationResponse, losgId: losgId, deviceSubType: data.deviceSubType, purchasingDeviceType: data.purchasingDeviceType, useWomsValidateImeiApi: useWomsValidateImeiApi })))),
                    (!isImeiMode || skipImei) &&
                        currentPage === PageEnum.PAGE_SELECT_DEVICE && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("div", { className: (isImeiMode && skipImei ? 'mar-t-sm' : '') + " font-regular type-sm mar-b-xs" },
                            isImeiMode && (React__default.createElement("div", { className: "type-sm mar-b-lg", dangerouslySetInnerHTML: {
                                    __html: purify.sanitize(data.deviceSubType === 'smartphone'
                                        ? content.subHeadingPhone
                                        : content.subHeading),
                                } })),
                            showDeviceTypeSelector && (React__default.createElement(DeviceTypeSelectionGroup, { name: "sharedofferCapacityToggleTest", heading: content.deviceSelectionHeading, optionsFromCMS: content.deviceSelectionOptions, setCurrentStage: setCurrentStage, selectedDeviceType: selectedDeviceType, setSelectedDeviceType: setSelectedDeviceType })),
                            makesData && (React__default.createElement(MakeSelector, { manufacturerLabel: content.manufacturerLabel, 
                                // makeRef={makeRef}
                                selectedMakeName: (_l = selectedMakeData) === null || _l === void 0 ? void 0 : _l.name, makesData: makesData, setSelectedMakeData: setSelectedMakeData, setCurrentStage: setCurrentStage, otherMakeText: content.otherMakeText, otherMakeSelectorPlaceholder: content.otherMakeSelectorPlaceholder, makeRef: makeRef })),
                            selectedMakeData && (React__default.createElement(ModelSelector, { modelSeriesLabel: content.modelLabel, selectedModelName: (_m = selectedModelData) === null || _m === void 0 ? void 0 : _m.name, selectedMakeData: selectedMakeData, setSelectedModelData: setSelectedModelData, setCurrentStage: setCurrentStage, modelSelectorPlaceholder: content.modelSelectorPlaceholder, modelRef: modelRef, modelInputRef: modelInputRef })),
                            selectedModelData && (React__default.createElement(CapacitySelector, { capacityLabel: content.capacityLabel, selectedModelData: selectedModelData, selectedCapacity: selectedCapacity, setSelectedCapacity: setSelectedCapacity, setSelectedProductData: setSelectedProductData, setCurrentStage: setCurrentStage, tooltipContent: content.tooltipContent, tooltipSvg: content.tooltipSvg, capacityRef: capacityRef }))))),
                    currentPage === PageEnum.PAGE_ANSWER_QUESTIONS && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(DeviceDisplay, { selectedProductData: selectedProductData, yourDeviceLabel: content.yourDeviceLabel, make: (_o = selectedMakeData) === null || _o === void 0 ? void 0 : _o.name }),
                        React__default.createElement(Questions, { questionContent: content.questions, questionsBadCondition: questionsBadCondition, questionDeactivated: questionDeactivated, setQuestionAnswers: setQuestionAnswers, hasDeactivatedQuestion: hasDeactivatedQuestion, answerGenericQuestion: answerGenericQuestion, setAnswerGenericQuestion: setAnswerGenericQuestion, questionAnswers: questionAnswers }),
                        showSpinner && (React__default.createElement("div", { className: spinnerContainer },
                            React__default.createElement(Spinner$3, null),
                            React__default.createElement("div", { className: spinnerLoadingText + " font-regular type-sm mar-b-xs" }, content.spinnerLoadingMessage))),
                        hylaResponse &&
                            hylaResponse.offerType === OfferType.GENERIC && (React__default.createElement(BaseContextualMessage, { svgUrl: content.tradeInMessageSVG, altText: content.tradeInMessageSVGAltText, message: content.genericTradeInMessage, colorClassName: "color-cobalt" })),
                        hylaResponse && (React__default.createElement(PromotionDisplay, { promotionDisplayHeader: hylaResponse.offerType === OfferType.GENERIC
                                ? content.promotionCardDisplayHeader
                                : content.promotionDisplayHeader, promotionDisplayMarketValueLabel: content.promotionDisplayMarketValueLabel, promotionDisplayDisclaimer: hylaResponse.offerType === OfferType.GENERIC
                                ? content.promotionCardDisplayDisclaimer
                                : content.promotionDisplayDisclaimer, promotionDisplaySavingsPercentage: promotionSavingsPercentageText, showPromotionOfferMsg: hylaResponse.offerType === OfferType.NORMAL, promotionOfferMsg: content.promotionOfferMsg, value: (_p = hylaResponse) === null || _p === void 0 ? void 0 : _p.hylaDiscountAmount, marketValue: (_q = hylaResponse) === null || _q === void 0 ? void 0 : _q.hylaMarketValue })),
                        hylaResponse && mustSwitchPriceOption && (React__default.createElement(BaseContextualMessage, { svgUrl: "/idpassets/global/icons/svg/communication-alerts/functional-icon_exclamation-triangle-filled_32.svg", altText: "Warning", message: content.mustSwitchPriceOptionMessage, colorClassName: "color-functional-dk-orange" })))))),
                (!isImeiMode || (isImeiMode && skipImei)) && (React__default.createElement(React__default.Fragment, null,
                    showError ? (React__default.createElement(Button$1, { kind: "primaryBlack", size: buttonSize, className: buttonAccept, onClick: onErrorButtonClick }, content.buttonError)) : (React__default.createElement("div", null, currentPage === PageEnum.PAGE_SELECT_DEVICE ? (React__default.createElement(Button$1, { kind: "primaryBlack", size: buttonSize, disabled: continueButtonDisabled, className: buttonAccept, onClick: onContinueButtonPress }, content.buttonContinue)) : (React__default.createElement("div", null,
                        React__default.createElement(Button$1, { kind: "primaryBlack", size: buttonSize, disabled: !hylaResponse, className: buttonAccept, onClick: acceptOffer }, content.buttonAccept))))),
                    !showError && (React__default.createElement(Button$1, { kind: "secondary", size: buttonSize, className: buttonDecline, onClick: declineOffer, ref: buttonRef }, content.buttonDecline)))))))) : (React__default.createElement(React__default.Fragment, null));
};

var SharedOfferModalStatus$1;
(function (SharedOfferModalStatus) {
    SharedOfferModalStatus["ACCEPT"] = "USER_ACCEPTED";
    SharedOfferModalStatus["DECLINE"] = "USER_DECLINED";
    SharedOfferModalStatus["NOOFFER"] = "NO_OFFER_FOUND";
    SharedOfferModalStatus["DATAFAILED"] = "DATA_RETRIEVE_FAILED";
})(SharedOfferModalStatus$1 || (SharedOfferModalStatus$1 = {}));

var allContent$1 = "SharedOffer-module_all-content__ZiU6o";
var header$3 = "SharedOffer-module_header__eBtDi";
var separator = "SharedOffer-module_separator__dFuYS";
var subHeader$1 = "SharedOffer-module_sub-header__jGCvA";
var boxContainer$1 = "SharedOffer-module_box-container__l84--";
var boxHeader = "SharedOffer-module_box-header__zXS79";
var instructions = "SharedOffer-module_instructions__wMTBd";
var resultsContainer = "SharedOffer-module_results-container__QZ6MY";
var offerContainer = "SharedOffer-module_offer-container__wntYE";
var offerTextContainer$1 = "SharedOffer-module_offer-text-container__7ju5Z";
var estimate = "SharedOffer-module_estimate__EiyYh";
var amount = "SharedOffer-module_amount__RXqfk";
var disclaimer = "SharedOffer-module_disclaimer__RGsIt";
var imageContainer$1 = "SharedOffer-module_image-container__2dpJT";
var buttonAccept$1 = "SharedOffer-module_button-accept__kuZko";
var buttonDecline$1 = "SharedOffer-module_button-decline__X-sNm";
var css_248z$k = ".SharedOffer-module_all-content__ZiU6o {\n  background-color: #FFFFFF;\n  width: 100%; }\n\n.SharedOffer-module_header__eBtDi {\n  font-family: font-medium, sans-serif;\n  font-size: 16px;\n  margin-bottom: 30px; }\n\n.SharedOffer-module_separator__dFuYS {\n  width: 100%;\n  height: 1px;\n  background-color: #dcdfe3;\n  display: block;\n  margin-bottom: 18px;\n  margin-top: 18px; }\n\n.SharedOffer-module_sub-header__jGCvA {\n  font-family: font-regular, sans-serif;\n  font-size: 14px;\n  margin-bottom: 24px; }\n\n.SharedOffer-module_box-container__l84-- {\n  border: 2px solid #0057B8;\n  border-radius: 3px;\n  background-color: rgba(0, 87, 184, 0.05);\n  padding: 16px; }\n\n.SharedOffer-module_box-header__zXS79 {\n  font-family: font-regular, sans-serif;\n  font-size: 16px; }\n\n.SharedOffer-module_instructions__wMTBd {\n  font-family: font-regular, sans-serif;\n  font-size: 14px;\n  margin-top: 20px; }\n\n.SharedOffer-module_results-container__QZ6MY > ul {\n  list-style-type: disc; }\n\n.SharedOffer-module_results-container__QZ6MY > ul > li {\n  margin-top: 8px; }\n\n.SharedOffer-module_offer-container__wntYE {\n  display: flex;\n  font-family: font-medium, sans-serif;\n  margin-top: 16px; }\n  .SharedOffer-module_offer-container__wntYE .SharedOffer-module_offer-text-container__7ju5Z {\n    padding-left: 16px; }\n    .SharedOffer-module_offer-container__wntYE .SharedOffer-module_offer-text-container__7ju5Z .SharedOffer-module_estimate__EiyYh {\n      font-size: 15px;\n      line-height: 24px; }\n    .SharedOffer-module_offer-container__wntYE .SharedOffer-module_offer-text-container__7ju5Z .SharedOffer-module_amount__RXqfk {\n      font-size: 24px;\n      line-height: 26px; }\n    .SharedOffer-module_offer-container__wntYE .SharedOffer-module_offer-text-container__7ju5Z .SharedOffer-module_disclaimer__RGsIt {\n      font-family: font-regular, sans-serif;\n      padding-top: 8px;\n      font-size: 11px;\n      line-height: 14px; }\n\n.SharedOffer-module_image-container__2dpJT img {\n  width: 93px;\n  max-width: 93px;\n  height: auto; }\n\n.SharedOffer-module_button-accept__kuZko {\n  margin: 16px auto 0; }\n\n.SharedOffer-module_button-decline__X-sNm {\n  margin: 16px auto 0; }\n  .SharedOffer-module_button-decline__X-sNm button {\n    justify-content: unset;\n    padding-left: 16px;\n    height: 5.6rem; }\n\n.SharedOffer-module_optional-contextual-container__3CPeS {\n  display: flex;\n  font-family: font-medium, sans-serif;\n  margin-top: 16px;\n  font-size: 16px; }\n\n.SharedOffer-module_optional-contextual-image__bLitd path {\n  fill: #0057b8; }\n\n.SharedOffer-module_optional-contextual-image__bLitd svg {\n  height: 24px;\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px; }\n\n.SharedOffer-module_error-image__KE0dv path {\n  fill: #c70032; }\n\n.SharedOffer-module_error-image__KE0dv svg {\n  height: 24px;\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px; }\n\n.SharedOffer-module_spinner-container__7GwUd {\n  display: flex;\n  font-family: font-medium, sans-serif;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px; }\n  .SharedOffer-module_spinner-container__7GwUd .SharedOffer-module_spinner-loading-text__zaBIX {\n    margin-top: 16px; }\n\n.SharedOffer-module_question-description__1Lkgf b, .SharedOffer-module_question-description__1Lkgf strong {\n  font-weight: bold; }\n";
styleInject(css_248z$k);

var SharedOfferV1 = /** @class */ (function (_super) {
    __extends(SharedOfferV1, _super);
    function SharedOfferV1(props) {
        var _this = _super.call(this, props) || this;
        _this.makeRef = createRef();
        _this.modelRef = createRef();
        _this.acceptRef = createRef();
        _this.state = {
            dataLoaded: false,
        };
        _this.acceptOffer = _this.acceptOffer.bind(_this);
        _this.declineOffer = _this.declineOffer.bind(_this);
        _this.onMakeChange = _this.onMakeChange.bind(_this);
        _this.onModelChange = _this.onModelChange.bind(_this);
        return _this;
    }
    SharedOfferV1.prototype.componentDidMount = function () {
        if (this.state.dataLoaded !== true) {
            this.loadConfig();
        }
    };
    SharedOfferV1.prototype.loadConfig = function () {
        var _this = this;
        try {
            var script = document.createElement('script');
            if (window.location.hostname.indexOf('dev') > -1 ||
                window.location.hostname.indexOf('test') > -1 ||
                window.location.hostname.indexOf('localhost') > -1) {
                script.src =
                    'https://e-tst2.stage.att.com/sharedoffer/stage/sharedoffermodal/config.js';
            }
            else {
                script.src = '/sharedoffer/prod/sharedoffermodal/config.js';
            }
            script.onload = function () { return _this.configLoaded(); };
            document.body.appendChild(script);
        }
        catch (e) {
            this.returnInvalid(SharedOfferModalStatus$1.DATAFAILED);
            return;
        }
    };
    SharedOfferV1.prototype.configLoaded = function () {
        this.content = window.sharedOfferContent;
        var sharedOfferData = window.sharedOfferData;
        this.devices = sharedOfferData.devices;
        this.setState({ dataLoaded: true });
        this.validateInput();
    };
    SharedOfferV1.prototype.validateInput = function () {
        if (this.findOffersForSku() < 0) {
            this.returnInvalid(SharedOfferModalStatus$1.NOOFFER);
        }
    };
    SharedOfferV1.prototype.findOffersForSku = function () {
        var _this = this;
        var eligibleSkuSets = this.devices &&
            this.devices.map(function (skus) {
                return skus.purchasingSku;
            });
        var isOfferForSku = eligibleSkuSets &&
            eligibleSkuSets.findIndex(function (set) {
                return set.indexOf(_this.props.data.skuId) > -1;
            });
        return isOfferForSku;
    };
    SharedOfferV1.prototype.returnInvalid = function (reason) {
        var tradeInValues = {
            sku: this.props.data.skuId,
            status: reason,
        };
        this.props.events.onOfferDecision(tradeInValues);
    };
    SharedOfferV1.prototype.acceptOffer = function () {
        var tradeInValues = {
            modelPrice: this.state.amount,
            make: this.state.selectedMake,
            productFamily: this.state.selectedModel,
            image: this.state.image,
            offerCode: this.state.offerCode,
            sku: this.props.data.skuId,
            defaultSku: this.state.defaultSku,
            status: SharedOfferModalStatus$1.ACCEPT,
        };
        this.props.events.onOfferDecision(tradeInValues);
    };
    SharedOfferV1.prototype.declineOffer = function () {
        var tradeInValues = {
            sku: this.props.data.skuId,
            status: SharedOfferModalStatus$1.DECLINE,
        };
        this.props.events.onOfferDecision(tradeInValues);
    };
    SharedOfferV1.prototype.render = function () {
        var data = this.props.data;
        return this.findOffersForSku() > -1 ? (createElement(Fragment$1, null,
            createElement("div", { id: "sharedoffer-component" }, this.renderContent()))) : ('');
    };
    SharedOfferV1.prototype.renderContent = function () {
        var data = this.props.data;
        var content = this.content;
        return (createElement(Fragment$1, null,
            createElement("div", { id: "sharedoffer-content", className: allContent$1 },
                createElement("div", { className: header$3 }, data.heading ? data.heading : content.heading ? content.heading : ''),
                createElement("div", { className: subHeader$1, dangerouslySetInnerHTML: {
                        __html: purify.sanitize(data.subHeading
                            ? data.subHeading
                            : content.subHeading
                                ? content.subHeading
                                : ''),
                    } }),
                createElement("div", { className: boxContainer$1 },
                    createElement("div", { className: boxHeader }, content.boxHeading ? content.boxHeading : ''),
                    createElement("span", { className: separator }),
                    createElement("label", { htmlFor: "sharedoffer-selectbrand", className: "formfield-label" }, content.manufacturerLabel),
                    createElement("div", { className: "selectWrap" },
                        createElement("select", { id: "sharedoffer-selectbrand", ref: this.makeRef, className: "awd-select select-placeholder", onChange: this.onMakeChange }, this.getDeviceMakes().map(function (o) {
                            return o.value === null || o.value === undefined ? (createElement("option", { value: "", "data-placeholder": "true" }, o.label)) : (createElement("option", { value: o.value }, o.label));
                        })),
                        createElement("span", { className: "select-skin" })),
                    this.state.selectedMake !== null &&
                        this.state.selectedMake !== undefined ? (createElement(Fragment$1, null,
                        createElement("label", { htmlFor: "sharedoffer-selectmodel", className: "formfield-label mar-t-xs" }, content.modelLabel),
                        createElement("div", { className: "selectWrap" },
                            createElement("select", { id: "sharedoffer-selectmodel", ref: this.modelRef, className: "awd-select select-placeholder", onChange: this.onModelChange }, this.getDeviceModels().map(function (o) {
                                return o.value === null || o.value === undefined ? (createElement("option", { value: "", "data-placeholder": "true" }, o.label)) : (createElement("option", { value: o.value }, o.label));
                            })),
                            createElement("span", { className: "select-skin" })))) : (''),
                    this.state.selectedModel !== null &&
                        this.state.selectedModel !== undefined ? (createElement(Fragment$1, null,
                        createElement("div", { id: "sharedoffer-results", className: resultsContainer },
                            createElement("div", { className: instructions, dangerouslySetInnerHTML: {
                                    __html: purify.sanitize(content.nextStep),
                                } }),
                            createElement("ul", { className: "type-xs pad-l-xs" }, content.nextStepList &&
                                content.nextStepList.length > 0 &&
                                content.nextStepList.map(function (item) { return createElement("li", null, item); })),
                            createElement("div", { className: offerContainer },
                                createElement("div", { className: imageContainer$1 },
                                    createElement("img", { src: this.state.image, alt: this.state.selectedMake + " " + this.state.selectedModel })),
                                createElement("div", { className: offerTextContainer$1 },
                                    createElement("div", { className: estimate }, this.state.amount !== null &&
                                        this.state.amount !== undefined
                                        ? content.estimatedValue
                                        : ''),
                                    createElement("div", { className: amount }, this.state.amount !== null &&
                                        this.state.amount !== undefined
                                        ? '$' + this.state.amount.toFixed(2)
                                        : ''),
                                    content.disclaimer ? (createElement("div", { className: disclaimer }, content.disclaimer)) : (''))),
                            createElement("div", { className: buttonAccept$1 },
                                createElement("button", { id: "sharedoffer-buttonaccept", type: "button", ref: this.acceptRef, className: "btn-primary btn-large btn-full-width", onClick: this.acceptOffer }, content.buttonAccept))))) : ('')),
                this.state.selectedModel !== null && this.state.selectedModel !== undefined ? (createElement("div", { className: buttonDecline$1 },
                    createElement("button", { id: "sharedoffer-buttondecline", type: "button", className: "btn-secondary btn-full-width", onClick: this.declineOffer }, data.noThanksButtonLabel
                        ? data.noThanksButtonLabel
                        : content.buttonDecline))) : (''))));
    };
    SharedOfferV1.prototype.getDeviceMakes = function () {
        var device = this.findOffersForSku();
        var makeList = this.devices &&
            this.devices[device] &&
            this.devices[device].makes &&
            this.devices[device].makes.map(function (d, index) { return ({ value: d.name, label: d.name }); });
        makeList.unshift({ value: null, label: 'Select' });
        return makeList;
    };
    SharedOfferV1.prototype.getDeviceModels = function () {
        var _this = this;
        var device = this.findOffersForSku();
        var selectedMake = this.devices &&
            this.devices[device] &&
            this.devices[device].makes &&
            this.devices[device].makes.find(function (b) {
                return b.name === _this.state.selectedMake;
            });
        var models = selectedMake && selectedMake.models;
        var modelList = models && models.map(function (m, index) { return ({ value: m.name, label: m.name }); });
        modelList.unshift({ value: null, label: 'Select' });
        return modelList;
    };
    SharedOfferV1.prototype.getDeviceOffer = function () {
        var _this = this;
        var offerMake = this.devices[this.findOffersForSku()].makes.find(function (i) {
            return i.name === _this.state.selectedMake;
        });
        var offerModel = offerMake.models.find(function (i) {
            return i.name === _this.state.selectedModel;
        });
        var offerAmount = offerModel && offerModel.offer;
        var offerDefaultSku = offerModel && offerModel.defaultSku;
        this.setState({
            amount: offerAmount && offerAmount.tradeInAmount,
            image: offerModel && offerModel.image,
            offerCode: offerAmount && offerAmount.offerCode,
            defaultSku: offerDefaultSku && offerDefaultSku,
        });
        this.acceptRef.current.focus();
        this.acceptRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    SharedOfferV1.prototype.onMakeChange = function (e) {
        var _this = this;
        var val = e.target.value;
        if (this.state.selectedMake !== e.target.value && e.target.selectedIndex > 0) {
            this.setState({
                amount: undefined,
                offerCode: undefined,
                selectedMake: undefined,
                selectedModel: undefined,
            }, function () {
                _this.setState({ selectedMake: val }, function () { return _this.modelRef.current.focus(); });
            });
        }
        else {
            this.setState({ selectedMake: undefined, selectedModel: undefined });
        }
    };
    SharedOfferV1.prototype.onModelChange = function (e) {
        var _this = this;
        if (e.target.selectedIndex > 0) {
            this.setState({ selectedModel: e.target.value }, function () { return _this.getDeviceOffer(); });
        }
        else if (this.state.selectedModel !== e.target.value) {
            this.setState({ selectedModel: undefined });
        }
    };
    return SharedOfferV1;
}(Component));

var SharedOfferIXPSwitch = function (props) {
    var _a, _b;
    if ((_b = (_a = props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.disableOrchestrationOffers) {
        return React__default.createElement(SharedOfferV1, __assign({}, props));
    }
    else {
        return React__default.createElement(SharedOffer, __assign({}, props));
    }
};

var SharedOffer$1 = SharedOfferIXPSwitch;

export { ErrorTypeEnum, GenericQuestionAnswerTextEnum, QuestionCodeEnum, ReportingDeviceCondition, SharedOffer$1 as SharedOffer };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sales/shared-offer/dist/shared-offer.es.js
// module id = 943
// module chunks = 8